export default {
    "AI 员工": "AIスタッフ",
    "18 位 AI 员工": "18人のAIスタッフ",
    "最忙的是拉流量那几位": "最も忙しいのはトラフィックを増やす役割です",
    "商品有人采、图片有人翻、订单有人盯——这些都不难。真正决定一间店活不活得下去的，是": "商品の調達、画像の翻訳、注文の管理——これらは難しくありません。店舗が生き残るかどうかを決めるのは",
    "有没有人来": "来客数",
    "。所以增长组的 5 位员工，天天在做的就是这件事：先把店修到能接住流量，再把流量一处一处引过来。": "です。そのため、成長チームの5人は毎日この作業に取り組んでいます：まず店舗をトラフィックを受け入れられる状態に整え、次にトラフィックを少しずつ引き寄せます。",
    "免费开店，让 AI 员工先体检一遍": "無料で開店し、AIスタッフに一度診断してもらう",
    "看自动营销怎么跑": "自動マーケティングの実行方法を見る",
    "18 位员工，四组分工": "18人のスタッフ、4つのグループに分かれる",
    "9 个内容渠道": "9つのコンテンツチャネル",
    "12 项店铺体检": "12項目の店舗診断",
    "4 条自动序列": "4つの自動シーケンス",
    "这页分两半。前半说": "このページは二つに分けられます。前半では",
    "流量是怎么被拉进来的": "トラフィックがどのように引き寄せられるのか",
    "，后半是 18 位员工分别管什么。赶时间就直接往下翻到「30 天」。": "後半では18人のスタッフがそれぞれ何を担当しているか説明します。時間がない場合は「30日」まで直接スクロールしてください。",
    "位 AI 员工，分四组": "人AIスタッフ、4つのグループに分かれる",
    "个内容渠道一件商品全铺": "9つのコンテンツチャネルで1つの商品を展開",
    "项店铺体检，按浪费钱排序": "12項目の店舗診断、費用の無駄遣い順に並べ替え",
    "条自动营销序列": "4つの自動マーケティングシーケンス",
    "先找堵点": "まずは詰まりを見つける",
    "流量不是没来，是被挡住了": "トラフィックが来ていないわけではなく、ブロックされている",
    "很多店花了力气发内容，还是没单。问题常常不在内容，而在「页面接不住」——标题是中文、没主图、没描述、价格离谱。这些不修，来多少人都一样。": "多くの店舗はコンテンツ作成に力を入れていますが、注文が増えません。問題はしばしばコンテンツではなく、「ページが受け止めていない」ことにあります——タイトルが中国語、メイン画像がない、説明がない、価格が異常です。これらを修正しないと、どれだけ人が来ても同じ結果です。",
    "12 项体检，按「会不会浪费钱」排序": "12項目の診断、「お金を無駄にするかどうか」で順位付け",
    "先花三分钟，把店过一遍": "まずは3分間、店舗全体をチェック",
    "「推广总控」打开就跑一次体检：不是给你一张漂亮的分数表，而是直接告诉你哪几项": "「プロモーションコントロール」を開くと自動的に診断が実行されます：綺麗なスコア表ではなく、具体的にどの項目を修正すべきかを教えてくれます",
    "现在推就等于扔钱": "今すぐプロモーションするとお金が無駄になります",
    "，该修的先修，能放的最后再说。": "、まず修正すべきものを修正し、後回しにできるものは最後に考えましょう。",
    "阻塞项 / 建议修 / 已通过，三档分清": "ブロック項目 / 修正推奨 / 合格、三段階で明確に",
    "每一项都写清楚「不修的后果」，不是打分了事": "各項目について「修正しない場合の影響」を明確に記載し、単なるスコア付けではありません",
    "体检完直接收敛到 15 个商品，不让你 65 个一起推": "診断後、15個の商品に絞って提案します、65個すべてを一度にプロモーションする必要はありません",
    "体检用的是你店里的真实数据：商品数、SEO 地址、主图、描述、分类、价格分布、买家数。": "診断にはあなたの店舗の実際のデータを使用します：商品数、SEOアドレス、メイン画像、説明、カテゴリ、価格分布、購入者数。",
    "不是模板打分": "テンプレートによるスコア付けではありません",
    "店铺体检": "店舗診断",
    "刚刚 · 65 个在售商品": "たった今 · 65個の販売中商品",
    "3 项待修": "3項目の修正が必要",
    "商品标题语言": "商品タイトル言語",
    "阻塞": "ブロック",
    "52 / 65 个标题疑似中文，而站点语言是 Deutsch": "52 / 65個のタイトルが中国語の疑いがあり、サイトの言語はDeutschです",
    "先改主推那 10 个，不用 65 个一起改 →": "まずは主要な10個を修正し、65個すべてを一度に修正する必要はありません →",
    "商品主图": "商品のメイン画像",
    "只有 41 / 65 个商品有主图": "65個の商品中、41個のみにメイン画像があります",
    "没图的既进不了 Merchant Feed，也做不了 Pinterest": "画像がないとMerchant Feedにも入れられず、Pinterestも作成できません",
    "价格合理性": "価格の妥当性",
    "建议修": "修正をおすすめします",
    "2 个价格明显异常（最高 ¥38,600）": "2つの価格が明らかに異常（最高¥38,600）",
    "大概率是导入时汇率算错，逐个改回合理价": "おそらくインポート時の為替レート計算ミス、それぞれ適切な価格に修正してください",
    "品类归属": "カテゴリ分類",
    "通过": "合格",
    "品类集中在 3 个类目": "カテゴリは3つに集中しています",
    "体检项": "健康チェック項目",
    "卡住会怎样": "滞った場合どうなるか",
    "谁来修": "誰が修正するか",
    "在售商品": "販売中の商品",
    "可正常打开的商品不到 5 个，投多少流量都白搭": "正常に開ける商品が5個未満、どれだけトラフィックを送っても無駄です",
    "你上架，巡检官列缺项": "あなたが出品し、パトロール官が不足点を列挙します",
    "站点是德语、标题还是中文，当地人根本搜不到": "サイトはドイツ語ですがタイトルは中国語、現地の人には検索できません",
    "翻译本地化官": "翻訳・ローカライズ担当者",
    "SEO 描述": "SEO説明文",
    "搜索结果里没摘要，收录会慢上好几周": "検索結果に要約がなく、インデックス化まで数週間かかる可能性があります",
    "SEO 优化师": "SEO 最適化スペシャリスト",
    "进不了 Merchant Feed，也做不了 Pinterest": "Merchant Feed にアクセスできず、Pinterest も利用できません",
    "图片处理官": "画像処理担当者",
    "分不清卖什么，就选不了渠道和人群": "何を売っているのかわからなければ、チャネルや対象顧客を選べません",
    "你归类，AI 给建议": "あなたが分類し、AI が提案します",
    "汇率算错留个「¥38,600」的杯子，来人也转化不了": "為替レートの計算ミスで「¥38,600」のカップが売れ残り、訪問者も購入に至りません",
    "定价策略官": "価格戦略担当者",
    "库存": "在庫",
    "推爆了发现没货，等于白推一轮": "商品が売り切れだと、プロモーションは無駄になります",
    "订单管家": "注文管理担当者",
    "SEO 地基": "SEO の基礎",
    "没有 sitemap，搜索引擎不知道你有多少页": "サイトマップがないと、検索エンジンはあなたのウェブページの数を把握できません",
    "平台自动生成": "プラットフォーム自動生成",
    "另外还有合规页面、已发内容、站内文章、已成交买家四项，一起算在 12 项里。": "さらに、コンプライアンスページ、既に公開されたコンテンツ、サイト内の記事、既に成約したバイヤーの4項目も含め、合計12項目です。",
    "最实在的一步": "最も具体的なステップ",
    "30 天，每天做什么已经写好了": "30日間、毎日のタスクがすでに書かれています",
    "体检完点一下「生成 30 天方案」，出来的不是一份「建议加强内容运营」的空话，而是 30 条具体任务：哪天做什么、为什么做、点开能直接跳到该改的页面。": "診断後に「30日間プラン生成」をクリックすると、「コンテンツ運用を強化することをお勧めします」という空疎なアドバイスではなく、具体的な30のタスク：どの日に何をするか、なぜそれをするか、そしてそのタスクを開始するためのリンクが表示されます。",
    "第 1 周 · 修地基": "第1週 · 基礎整備",
    "这周": "今週",
    "故意不产出任何对外内容": "意図的に外部向けコンテンツを作成しません",
    "。页面接不住流量，发了也是白花。先把 sitemap 交上去、异常价格改掉、商品归类、选出主推。": "。ページのトラフィックが対応できない場合、発信しても無駄です。まずは sitemap を提出し、異常な価格を修正し、商品を分類し、主推を選んでください。",
    "提交 sitemap 与 Merchant Feed": "sitemap と Merchant Feed の提出",
    "改掉汇率算错的价格": "為替レート計算ミスの価格を修正",
    "主推的 10 个商品改本地语言": "主推の 10 個の商品を現地言語に変更",
    "第 2 周 · 铺图钉": "第 2 週 · 鋲付け",
    "Pinterest 每天 2 个，一直排到第 14 天。商品主图现成，竖版 2:3 就是内容，不需要另外拍。": "Pinterest は 1 日 2 つずつ、14 日目まで続けます。商品のメイン画像は既にあるので、縦版 2:3 でコンテンツを作成するだけで、別途撮影は必要ありません。",
    "零授权、零成本": "ゼロ認証、ゼロコスト",
    "描述里带商品链接": "説明文に商品リンクを含める",
    "有买家的话加一封新品通知": "購入者があれば新商品通知を追加",
    "第 3 周 · 写长尾": "第 3 週 · ロングテールの作成",
    "站内博客 3 篇，每篇围绕一个真实搜索词，正文 800 字，中间内链到商品页。发出去会进 sitemap，慢慢带收录。": "サイト内ブログ 3 篇、それぞれ実際の検索ワードを中心に、本文 800 字、中間に商品ページへの内部リンクを設置します。公開後は sitemap に反映され、徐々にインデックスされます。",
    "「XX おすすめ」这种词": "「XX おすすめ」のようなキーワード",
    "一键发成站内文章": "ワンクリックでサイト内記事に発行",
    "比广告便宜，比广告久": "広告よりも安価で、効果が長持ち",
    "第 4 周 · 复盘加码": "第 4 週 · レビューと強化",
    "看四个数：收录页数、站外访问、加购、订单。哪个渠道有访问就挪 70% 精力过去，其他的先停。": "4 つの数値を見る：インデックスされたページ数、外部からのアクセス数、カート追加数、注文数。どのチャネルでもアクセスがあれば、そのチャネルに 70% の力を入れ、他のものは一旦停止します。",
    "收录没动 → 查抓取错误": "インデックスが動いていない → クロールエラーを確認",
    "有点击没加购 → 补商品页细节": "クリックはあるがカート追加がない → 商品ページの詳細を補完",
    "有加购没下单 → 查运费和支付": "カート追加はあるが注文がない → 配送費と支払い方法を確認",
    "第 1 周的实际任务": "第 1 週の実際のタスク",
    "来自一份真实生成的方案 · 节奏和顺序都由店铺数据决定": "実際の生成プランに基づいて · ペースと順序は店舗データによって決定されます",
    "把站点地图提交给 Google": "サイトマップを Google に提出する",
    "打开 Search Console 提交 sitemap.xml；顺手在 Merchant Center 添加 feed/google.xml。这两步不花时间，但是后面所有流量的入口。": "Search Console で sitemap.xml を提出し、Merchant Center に feed/google.xml を追加します。これらの手順は時間のかからないものですが、その後のすべてのトラフィックの入口となります。",
    "第 1 天 · 不花钱": "1日目 · 無料",
    "改掉异常价格": "異常な価格を修正する",
    "这些商品价格明显不对，多半是导入时汇率算错。价格离谱的页面，投多少流量都转化不了。": "これらの商品の価格は明らかに間違っています。おそらくインポート時の為替レート計算ミスです。価格がおかしいページにはどれだけトラフィックを流してもコンバージョンしません。",
    "第 1 天 · 点开就到商品列表": "1日目 · クリックで商品リストへ",
    "选出这次主推的 10 个商品": "今回の主推商品 10 個を選出する",
    "系统按「有图、有详情、有 SEO 地址、价格正常、有库存」排过序。这 30 天只推这批，其余先不动。": "システムは「画像あり、詳細あり、SEO アドレスあり、価格正常、在庫あり」でソートしています。この 30 日間はこれらのみを推奨し、他のものは動かさない。",
    "第 3 天": "3日目",
    "主推商品的标题改成 Deutsche": "主推商品のタイトルを Deutsche に変更する",
    "只改主推那 10 个，不要 65 个一起改。标题里带上「是什么 + 给谁用 + 关键属性」——当地用户搜的是这个词，不是中文直译。": "主推の 10 個のみ変更し、65 個全てを変更しない。タイトルには「何であるか + 誰が使う + 重要な属性」を含める——現地ユーザーが椐索するのはこの言葉であり、中国語の直訳ではない。",
    "第 4 天 · 调翻译本地化官出稿": "4日目 · 翻訳ローカライズ担当者による調整",
    "补主推商品的 SEO 描述": "主推商品の SEO 説明を補完する",
    "每个 80~120 字，写清楚谁会买、解决什么问题、有什么细节。这段话会直接出现在搜索结果里，比广告文案还重要。": "各 80~120 文字で、誰が購入するか、どのような問題を解決するか、どのような詳細があるかを明確に記述する。この文章は検索結果に直接表示され、広告コピー以上に重要です。",
    "第 5 天 · 调 SEO 优化师出稿": "5日目 · SEO 最適化担当者による調整",
    "全站体检一遍": "全サイトの診断を行う",
    "缺主图、缺描述、零库存、断链全部列出来，能当场修的就修掉。": "メイン画像不足、説明不足、在庫ゼロ、リンク切れをすべてリストアップし、即座に修正できるものは修正する。",
    "第 6 天 · 调店铺巡检官": "6日目 · 店舗巡回担当者による調整",
    "方案里的预期指标都标了推算依据，": "プラン内の予想指標にはすべて推定根拠が示されています",
    "我们不承诺效果": "効果を保証しません",
    "。0 基础的站，30 天内 0 单是正常的——这句话写在方案里，不是藏在条款里。": "。0からのスタートで、30日以内に0注文は普通のこと——これは提案書に明記し、細かい条項に隠していません。",
    "内容产能": "コンテンツ生産力",
    "一件商品，铺到 9 个渠道": "1つの商品を9つのチャネルに展開",
    "不是把同一段话复制九遍。Pinterest 要图钉描述，TikTok 要口播脚本，X 要短句，Google 商家要本地化措辞，站内博客要 800 字长文——这些是同一条卖点的九种写法。": "同じ文章を9回コピーするのではありません。Pinterestにはピンの説明、TikTokには口述台本、Xには短いフレーズ、Google My Businessにはローカライズされた表現、サイト内ブログには800文字の長文——これらは同じ売り込みポイントの9通りの書き方です。",
    "手冲咖啡滤杯 · 陶瓷": "手挽きコーヒー用フィルター・セラミック",
    "¥168 · 库存 42 · 已本地化": "¥168 · 在庫42 · ローカライズ済み",
    "选一件主推商品": "主推商品を選択",
    "图钉描述": "ピンの説明",
    "配图短文": "画像付き短文",
    "帖子": "投稿",
    "短句": "短いフレーズ",
    "口播脚本": "口述台本",
    "私域话术": "プライベートメッセージ術",
    "频道稿": "チャンネル原稿",
    "本地文案": "ローカルコピーテキスト",
    "站内博客": "サイト内ブログ",
    "800 字长文": "800文字の長文",
    "品牌名和固定标签带进每一篇": "ブランド名と固定タグを各記事に含める",
    "设一次，之后每一条都自动带上，不用每次重新交代语气。": "一度設定すれば、その後のすべての投稿に自動的に追加され、毎回再設定する必要はありません。",
    "今天建议发哪个渠道": "今日の推奨チャネル",
    "投递箱顶部直接给当天的排期，不用自己记 30 天日历。": "投函ボックスの上部にその日のスケジュールが直接表示されるので、30日間のカレンダーを自分で覚える必要はありません。",
    "博客可以一键发成站内文章": "ブログはワンクリックでサイト内の記事に投稿できます",
    "发布后进文章列表，被 sitemap 收录，成为长期的自然流量入口。": "投稿後、記事リストに追加され、サイトマップに収録され、長期的な自然検索流入の入口となります。",
    "说实话：文案是生成好的，发帖要你自己发。": "正直に言うと：文章は自動生成されますが、投稿は自分で行う必要があります。",
    "平台不碰你的社媒账号，也不会拿你的账号去群发——所以不需要把 FB / IG 授权给我们。需要自动发的只有站内博客和营销邮件，这两条走的是你自己的系统。": "プラットフォームはあなたのソーシャルメディアアカウントには触れず、あなたのアカウントを使って大量送信することもありません——そのため、FB / IGの認証は必要ありません。自動送信が必要なのはサイト内ブログとマーケティングメールだけで、これらはあなたのシステムを通じて行われます。",
    "这一页最重要的一段": "このページで最も重要な部分",
    "自动营销：开了开关，它自己发": "自動マーケティング：スイッチを入れると自動的に送信されます",
    "拉新是靠内容和渠道，一单一单攒的。但已经买过的人，不用再花钱去拉——他们就在你的订单里。自动营销干的就是这件不花广告费的事：按规则挑人、按场景写信、按额度慢慢发。": "新規顧客獲得はコンテンツとチャネルによって一歩一歩積み上げていきます。しかし、すでに購入した人は、再び費用をかけて引き込む必要はありません——彼らは既にあなたの注文履歴にいます。自動マーケティングが行うのは、広告費がかからないこの作業です：ルールに基づいて人を選択し、シナリオに応じてメールを作成し、徐々に送信します。",
    "自动": "自動",
    "新品通知": "新商品通知",
    "近": "最近",
    "180 天": "180 日",
    "买过的人，告诉他们刚上架的新品。上新了没人知道，等于没上。": "購入した人に新しく追加された商品を知らせます。新商品が誰にも知られなければ、存在しないのと同じです。",
    "圈人依据：已付款订单 + 最近购买时间": "対象選定基準：支払済みの注文 + 最近の購入日時",
    "弃购召回": "カート放棄者へのリマインダー",
    "加了购物车": "カートに追加",
    "2 小时": "2 時間",
    "还没下单，提醒回来结账；超过 7 天就不再发了——再久就没意义。": "まだ注文していない場合、チェックアウトに戻るよう促します；7日以上経過すると、それ以上送信しません——それ以上長くなると意味がありません。",
    "圈人依据：加车时间，2 小时 ~ 7 天之间": "対象選定基準：カート追加時間、2 時間 〜 7 日以内",
    "老客唤醒": "既存顧客の呼び戻し",
    "最后一单已经超过": "最後の注文からすでに",
    "45 天": "45 日",
    "，请他们回来看看。老客回购的成本，比拉新低得多。": "経過しています。既存顧客を呼び戻すコストは、新規顧客獲得よりもずっと低いです。",
    "圈人依据：最后一单时间超过 45 天": "対象選定基準：最後の注文から45日以上経過",
    "手动": "手動",
    "促销群发": "プロモーション配信",
    "所有下过单的顾客，按最近购买时间倒序。做活动时用，不适合天天发。": "すべての注文者を、最近の購入日時順に並べます。キャンペーン時に使用し、毎日送信するものではありません。",
    "圈人依据：全部已付款买家": "対象選定基準：全支払い済みの買い手",
    "怕打扰？三个上限替你守住": "迷惑にならないように3つの上限を設定",
    "宁可少发一封，也别被退订": "1通少なく送る方が、退会されるより良い",
    "营销邮件发烂了比不发更糟——域名信誉一掉，连发货通知都进垃圾箱。所以这套系统的默认值偏保守，而且是": "マーケティングメールを多すぎると、送らないよりも悪い——ドメインの評判が下がると、発送通知までスパムボックスに入ります。そのため、このシステムのデフォルト設定は保守的で、そしてそれは",
    "你自己能改的": "自分で変更可能です",
    "每天最多发多少封，自己定（默认 200）": "1日に最大何通送れるか、自分で決める（デフォルト200通）",
    "同一个人最少间隔多少天（默认 15 天）": "同じ人に最低何日間隔を開けるか（デフォルト15日）",
    "同一条序列 7 天内不重复跑": "同じシーケンスは7日以内に再実行しない",
    "退订的、最近刚发过的，自动排除": "退会した人や最近送信した人は自動的に除外",
    "只圈付过款的人，不碰注册未下单的": "支払い済みの人だけを選択し、登録のみで注文していない人には触れない",
    "自动营销": "自動マーケティング",
    "每天最多发": "1日に最大送信数",
    "封": "封鎖",
    "同一人最少间隔": "同一人物の最小間隔",
    "天": "日",
    "自动跑哪些序列": "自動実行するシーケンス",
    "累计送达": "累積配信数",
    "队列待发": "キュー待ち",
    "退订率": "退訂率",
    "定时任务每 10 分钟推一批。走你自己配的发信账号，退订链接自动带上。": "定期タスクは10分ごとに一括で送信されます。自分の設定した送信アカウントを使用し、自動的に解除リンクが付与されます。",
    "自动营销不消耗 AI 积分": "自動マーケティングはAIポイントを消費しません",
    "自动跑的是内置模板，只有你点「AI 写一版」时才计费。所以就算每天发满，也不会偷偷烧额度。": "自動実行されるのは組み込みテンプレートであり、「AIで書く」を選択した場合のみ課金されます。そのため、毎日最大限に送信しても、勝手にクレジットが消費されることはありません。",
    "看订阅怎么算": "購読の計算方法を見る",
    "别什么都做": "すべてを一度に行わない",
    "先做哪个，先别做哪个": "何から始め、何から先延ばしにするか",
    "新店最容易犯的错，是五个平台一起开、每周都发、每条都没人看。系统会按你的店况直接排出优先级——包括明确告诉你「这个月先别做」。": "新店舗が最もよく犯す間違いは、5つのプラットフォームを同時に開設し、毎週送信し、誰も見ないメッセージを送ることです。システムはあなたの店の状況に基づいて優先順位を直接決定します——「今月はこれを行わない」と明確に示すこともあります。",
    "渠道": "チャネル",
    "优先级": "優先度",
    "为什么": "理由",
    "什么时候开始": "いつ開始するか",
    "站点地图 / Merchant Feed": "サイトマップ / Merchant Feed",
    "零授权、零成本，一次配好长期有效": "ゼロの認証、ゼロコスト、一度設定すれば長期的に有効",
    "立刻": "すぐに",
    "站内 SEO（商品页）": "サイト内SEO（商品ページ）",
    "有复利，越早做越好": "複利効果があり、早ければ早いほど良い",
    "第 1 周": "1週目",
    "商品主图就是内容，零授权、可长期带访问": "商品のメイン画像がコンテンツになり、認証不要で長期的にアクセスをもたらす",
    "第 2 周": "2週目",
    "营销邮件（EDM）": "マーケティングメール（EDM）",
    "唯一能全自动的渠道，但要有买家才有收件人": "唯一完全自動化できるチャネルだが、購入者が必要",
    "辅助": "補助的な役割",
    "见效慢，但长尾关键词能一直带流量": "効果が出るまで時間がかかるが、長尾キーワードは継続的にトラフィックをもたらす",
    "第 3 周": "3週目",
    "暂不做": "現時点では実施しない",
    "要账号授权，新号容易限流，性价比低于 Pinterest": "アカウント認証が必要で、新規アカウントは制限を受けやすく、Pinterestよりもコストパフォーマンスが低い",
    "后面再评估": "後で再評価する",
    "要拍视频、API 需审核，这 30 天不划算": "ビデオ撮影とAPI審査が必要で、この30日間では非効率的",
    "付费广告": "有料広告",
    "不建议": "推奨しない",
    "页面还没准备好，投了也转化不了": "ページがまだ準備できていないため、広告を出しても変換されない",
    "先不花这个钱": "今のところ費用をかけない",
    "这张表是按「有没有主图、描述铺没铺满、有没有买家」实时算的。你的店况不同，排出来的顺序也不同。": "この表は「メイン画像の有無、説明文の充実度、購入者の有無」に基づいてリアルタイムで計算されます。あなたの店の状況によって、表示される順序も異なります。",
    "花名册": "名簿",
    "前面讲的是「拉流量」这一条线。剩下的日常——采货、翻译、盯单、对账——也都有人在管。按位订阅，也可以买组合包。": "先に説明したのは「トラフィックを増やす」という一連の流れです。残りの日常業務——商品調達、翻訳、注文管理、精算——もすべて対応しています。個別のサービスを購読したり、パッケージプランを選択することも可能です。",
    "商品组": "商品グループ",
    "5 位": "5 人",
    "把外面看到的东西，变成你店里能卖的东西。": "外から見つけた商品を、あなたの店で販売できる形に変える。",
    "商品采集官": "商品収集担当者",
    "从货源链接批量抓标题、属性、SKU 与图片，直接进已选商品，不用一条条复制。": "供給元のリンクからタイトル、属性、SKU、画像を一括で取得し、選択した商品に直接追加します。手動でのコピー作業が不要です。",
    "已接入": "接続済み",
    "标题、属性、详情按目标市场语言本地化，不是逐字直译，保持当地习惯用词。": "タイトル、属性、詳細は目標市場の言語に合わせてローカライズされ、逐語訳ではなく、現地の慣用表現を保ちます。",
    "按目标市场搜索习惯写标题、关键词、描述，写完直接入库。可以批量跑。": "目標市場の検索習慣に基づいてタイトル、キーワード、説明文を作成し、完成したらすぐにデータベースに保存できます。一括処理も可能です。",
    "主图上的外文一键换成本地语言，基础处理一起做，不用开设计软件。": "メイン画像上の外国語をワンクリックで現地の言語に置き換え、基本的な編集も行います。デザインソフトウェアを開く必要はありません。",
    "按采购价、运费、平台佣金与竞品价位算建议售价，避免拍脑袋定价。": "仕入れ価格、送料、プラットフォームのコミッション、競合他社の価格に基づいて推奨販売価格を計算し、適当な価格設定を避けることができます。",
    "接入中": "接続中",
    "订单组": "注文グループ",
    "4 位": "4 人",
    "有人下单以后，别让人等、别让件丢。": "注文があったら、お客様を待たせたり、商品を紛失させないようにしましょう。",
    "盯住待支付、待采购、待发货各环节，异常订单主动挑出来提醒处理。": "未払い、未調達、未発送などの各段階を監視し、異常な注文は自動的に抽出して処理を促します。",
    "物流追踪官": "物流追跡担当者",
    "批量跟进运单状态，卡在中转、清关超时、派送失败的件单独列出。": "運送状況を一括で確認し、中継所で滞留しているもの、通関時間が超過しているもの、配達に失敗したものは別途リストアップします。",
    "客服应答官": "カスタマーサポート",
    "按本店真实发货时效、支付方式与物流商，写一套买家常见问题话术，复制到你的客服渠道就能用。": "店舗の実際の発送時間、支払い方法、物流業者に基づいて、よくある質問の回答を作成し、あなたのサポートチャネルにコピーして使用できます。",
    "评论运营官": "レビューオペレーション",
    "汇总商品评价，差评归因、话术建议，好评提炼成卖点。": "商品レビューをまとめ、悪い評価の原因分析や対応提案を行い、良い評価は商品の売り点として活用します。",
    "增长组": "成長チーム",
    "负责「有人来」。前面三段讲的就是这一组。": "「顧客が来店する」ことを担当します。先ほどの3つの役割がこのチームに関連しています。",
    "推广总控": "プロモーションコントロール",
    "先体检找出真正卡住的地方，再给一份 30 天每天做什么的方案，点一下就调其他员工出稿。": "まずは診断を行い、問題点を見つけてから、30日間の具体的な行動計画を提供し、他のスタッフにコンテンツ作成を依頼することができます。",
    "社媒内容官": "ソーシャルメディアコンテンツ",
    "把一件商品改写成 9 个渠道的成品，从 Pinterest 图钉到 TikTok 口播脚本。": "1つの商品を9つの異なるプラットフォーム向けにアレンジし、PinterestのピンからTikTokのスクリプトまで制作します。",
    "客户维系官": "顧客維持",
    "按人群圈选买家：新品通知、弃购召回、老客唤醒、促销群发，营销邮件自动分批触达。": "特定の顧客層に対して：新製品のお知らせ、カート放棄のリマインダー、既存顧客への再接触、セール情報の配信など、自動的にメールを分類して送信します。",
    "选品侦察兵": "商品選定スカウト",
    "顺着你现在卖的品提相邻品类，用货源真实行情验证，每周给一份能落地的清单。": "現在販売している商品に関連するカテゴリーを提案し、実際の市場状況で椂証した上で、毎週具体的なリストを提供します。",
    "促销策划官": "プロモーションプランナー",
    "按节令和积压库存给活动方案，方案确认后可以直接建券。": "季節や在庫状況に応じたキャンペーンプランを提案し、プランが承認されたらクーポンを作成することができます。",
    "经营组": "運営チーム",
    "每天有人替你看数、对账、挑问题。": "日々のデータ確認、精算、問題点の特定を行います。",
    "数据播报员": "データアナウンサー",
    "每天把访客、订单、转化、客单价整理成一段人话播报，不用自己拉表。": "毎日、訪問者数、注文数、コンバージョン率、平均客単価などの情報を整理して報告しますので、自分で表を作成する必要はありません。",
    "财务对账官": "財務対照官",
    "订单收入和提成支出逐笔核对，找出漏记、重复扣款与异常提成。": "注文収入とコミッション支出を逐次照合し、記録漏れ、重複控除、異常なコミッションを見つけます。",
    "店铺巡检官": "店舗巡回官",
    "定期体检店铺：缺主图、缺描述、零库存、断链，一次性列出待修清单。": "定期的に店舗の健康診断を行い：メイン画像の欠如、説明文の不足、在庫ゼロ、リンク切れなどを一覧でリストアップします。",
    "合规审查官": "コンプライアンス審査官",
    "商品文案与图片过一遍违禁词、侵权与平台规则，降低下架封店风险。": "商品の文章と画像を禁止語、著作権侵害、プラットフォームルールに照らし合わせて確認し、削除やアカウント停止のリスクを軽減します。",
    "标「接入中」的几位，平台侧能力已经就绪、店主端页面还在接。我们不在官网上把它们写成「马上能用」。": "「接続中」と表示されている機能は、プラットフォーム側の準備が整っていますが、店舗側のページ設定がまだ完了していません。そのため、公式ウェブサイトではこれらを「すぐに使用可能」とは表現していません。",
    "怎么买": "購入方法",
    "按位买，或者一次买一组": "個別に購入するか、またはセットで一度に購入",
    "每一位员工可以单独订阅，也可以买组合包——组合包覆盖多位员工，折算下来单价更低。开通后到期时间按订阅算，快到期会提醒，不会突然停掉。": "各従業員が個別にサブスクライブすることも、複数の従業員をカバーするパッケージを購入することもできます。パッケージの方が単価が低くなります。有効期限はサブスクリプションに基づいて計算され、期限が近づくと通知されますので、突然停止されることはありません。",
    "先用哪几位就开哪几位，不必一次全开": "必要な機能だけを最初に利用開始し、すべてを一度に開設する必要はありません",
    "组合包覆盖的员工在服务市场里写清楚，不会含糊": "パッケージでカバーされる従業員はサービスマーケットで明確に示されています",
    "到期前提醒；过期后是「续费」，不用重新找入口": "期限が近づくと通知されます；期限切れ後は「更新」を選択すればよく、再登録の手間はありません",
    "看订阅和佣金怎么算": "サブスクリプションとコミッションの計算方法を見る",
    "增长组合包": "成長パッケージ",
    "覆盖 5 位员工": "5人の従業員をカバー",
    "比单买省": "個別購入よりもお得",
    "去服务市场": "サービスマーケットへ",
    "接上你自己的 AI": "独自のAIを接続",
    "豆包、ChatGPT、Claude 也能读这间店": "豆包、ChatGPT、Claudeもこの店舗を読み取ることができます",
    "平台提供数据接口：AI 能查商品、价格、库存和推广方案，也能把写好的文案存回投递箱。": "プラットフォームがデータインターフェースを提供：AIは商品、価格、在庫、プロモーションプランを調べることができ、作成したコピーを投递箱に保存することもできます。",
    "不用把账号密码交给任何插件": "アカウントやパスワードをプラグインに渡す必要はありません",
    "，也不用授权社媒账号。": "、ソーシャルメディアアカウントの認証も不要です。",
    "读：商品、价格、库存、体检结果、30 天方案": "読み取り：商品、価格、在庫、健康診断結果、30日間のプラン",
    "写：把文案按渠道存回投递箱": "書き込み：チャネルごとにコピーを投递箱に保存",
    "不发：发帖这一步始终由你决定": "投稿：投稿ステップは常にあなたが決定します",
    "先开哪位？": "どちらから始めますか？",
    "如果只开一位，开": "1つだけ開くなら",
    "——它会体检、会排 30 天、还会叫其他员工干活。等订单多起来，再加客户维系官做自动营销。": "——これは健康診断を行い、30日のスケジュールを作成し、他のスタッフにも仕事を指示します。注文が増えたら、顧客維持担当者を追加して自動マーケティングを行いましょう。",
    "看要花多少钱": "費用を見積もりましょう",
    "先让 AI 员工体检一遍你的店": "まずはAIスタッフにあなたの店を健康診断させましょう",
    "免费开店就能跑体检。先看堵点在哪，再决定花不花钱。": "無料で店を開設すれば健康診断を実行できます。まず問題点を見つけ、その後お金をかけるかどうかを決めましょう。",
    "免费开店": "無料で店を開設",
    "看全部功能": "すべての機能を見る",
    "卖家案例": "販売者の事例",
    "他们也在做同一件事，": "彼らも同じことをしていますが",
    "只是起点不一样": "スタート地点が異なります",
    "有人在义乌档口，有人在深圳写字楼，有人在德国的小公寓。": "ある人は義烏の店舗、ある人は深圳のオフィスビル、またある人はドイツの小さなアパート。",
    "难处不一样，解法是同一套。": "困難はそれぞれですが、解決策は同じです。",
    "我也开一间试试": "私も1つ開いて試してみます",
    "先看他们怎么做的": "まずは彼らのやり方を見てみよう",
    "这几位都不算「大神」。": "彼らは「大物」ではありません。",
    "他们的共同点是先开了店，": "彼らの共通点は、まず店を開いたこと",
    "而不是先把一切都想明白。": "すべてを完璧に計画する前に行動を起こしたことです。",
    "个不同起点的卖家": "異なる出発点を持つセラーたち",
    "天，最慢的一个开出第一单": "最速で9日、最も遅い人は初めての注文を獲得するまでにXX日かかった",
    "个语言站点，最多的一个": "言語サイト、最多はXX",
    "月订单，最高的一个": "月間注文数、最高はXX",
    "六个故事": "6つのストーリー",
    "从左到右，是三种「卖出去」的路": "左から右へ、「売れる」3つの道",
    "前三个在中国，后三个在海外。": "最初の3つは中国、残りの3つは海外",
    "陈": "陳",
    "陈女士": "陳さん",
    "义乌 · 饰品档口": "義烏 · アクセサリーショップ",
    "「档口一天来不了几个老外，但网上的老外一天能来几百个。」": "「店には外国人がほとんど来ませんが、オンラインでは1日に何百人もの外国人顧客が訪れます。」",
    "原来只做批发，客户是本地贸易商。用模板做了英文和西班牙语两个站，把档口最常卖的 60 款拍了图上架，价格自己定。": "元々は卸売のみで、顧客は地元の貿易業者でした。テンプレートを使って英語とスペイン語の2つのサイトを作成し、よく売れる60アイテムの写真を掲載し、価格を自分で設定しました。",
    "月订单": "月間注文数",
    "语言站点": "言語サイト",
    "9 天": "9日",
    "开出第一单": "初めての注文",
    "林先生": "林さん",
    "深圳 · 3C 配件": "深圳 · 3Cアクセサリー",
    "「在平台卖，客户是平台的。在自己的站卖，客户才是我的。」": "「プラットフォームで売ると、顧客はプラットフォームのもの。自分のサイトで売ると、顧客は私のものになる。」",
    "原来在第三方平台做了三年，佣金加广告费吃掉三成。把爆款挪到独立站，用同一批货，客单价反而高了——因为能卖套装。": "以前は3年間、サードパーティのプラットフォームで販売していましたが、手数料と広告費で30%が削られました。ヒット商品を独立したサイトに移すことで、同じ商品でも単価が上がりました——セット販売ができるからです。",
    "客单价": "単価",
    "渠道成本": "チャネルコスト",
    "王小姐": "王さん",
    "广州 · 女装": "广州 · レディースファッション",
    "「我不碰国际物流。货发到国内仓，后面的事不归我管。」": "「国際物流には手をつけません。商品は国内の倉庫に送り、その後のことは私には関係ありません。」",
    "用代购模式起步：客户在她店里看到的是美元价，下单后平台买手去采购、合箱、出国际单。她只负责选款和在国内发货。": "代購モデルで始動：彼女の店舗ではドル価格で表示され、注文後、プラットフォームのバイヤーが購入し、箱詰めして国際発送します。彼女は商品選定と国内発送のみを担当します。",
    "压货成本": "在庫コスト",
    "人小团队": "小規模チーム",
    "12 天": "12日間",
    "回本周期": "元本回収期間",
    "德国 · 户外装备": "ドイツ · アウトドアギア",
    "「我不会中文，也没去过中国。但我能找到货源。」": "「中国語は話せませんし、中国に行ったこともありませんが、供給源を見つけることができます。」",
    "在德国做户外小众品类。通过平台直接对接国内工厂，一件代发，不压库存。页面用德语和英语，AI 员工处理夜间的英文询盘。": "ドイツでニッチなアウトドアカテゴリーを展開。プラットフォームを通じて直接国内の工場と連携し、一件ずつ発送し、在庫を抱えません。ウェブページはドイツ語と英語で、AIスタッフが夜間の英語での問い合わせに対応します。",
    "6–9 天": "6–9日",
    "到货时效": "到着までの時間",
    "库存占用": "在庫確保",
    "美国 · 手工材料": "アメリカ · ハンドメイド素材",
    "「利润不在货上，在搭配上。中国供应链让我敢试新组合。」": "「利益は商品ではなく、組み合わせにある。中国のサプライチェーンのおかげで新しい組み合わせを試す勇気が出ます。」",
    "卖手工材料包，按主题搭配。因为能小批量补货，她敢每周上一个新主题，卖不动就换，不用清库存。": "ハンドメイドキットをテーマ別に販売。小ロットでの補充が可能なので、週ごとに新しいテーマを出し、売れなければ変更し、在庫を抱える必要がない。",
    "每周": "毎週",
    "上新频率": "新商品の頻度",
    "复购率": "リピート購入率",
    "1 人": "1人",
    "团队规模": "チーム規模",
    "法国 · 家居饰品": "フランス · インテリア雑貨",
    "「我不懂投放。AI 给了我一整个月要发什么。」": "「広告のことはよくわかりません。AIが1ヶ月分の投稿内容を提案してくれました。」",
    "靠 Instagram 起量。用 AI 营销生成 30 天内容和投放计划，先小预算试，哪个帖子有反应就加钱。": "Instagramでの拡大。AIマーケティングツールを使用して30日間のコンテンツと広告計画を作成し、まずは小額で試し、反応のある投稿には予算を増やす。",
    "渠道同时发": "複数チャネル同時投稿",
    "帖子点击率": "投稿のクリック率",
    "14 天": "14 日間",
    "首单": "初回注文",
    "拆一个给你看": "開けて見せましょう",
    "陈女士的头 90 天，做对了三件事": "陳さんの最初の90日間で正解だった3つのこと",
    "她没投过广告，也没请运营。三件很朴素的事，按顺序做完，单量就起来了。": "彼女は広告を出しておらず、オペレーションスタッフも雇っていませんでした。シンプルな3つのことを順番に行い、注文数が増えました。",
    "先只上 60 款，不贪多": "最初は60アイテムだけを出品",
    "档口卖得最好的款，实拍图上架。款式少，页面反而干净，客户挑得快。": "店頭で最も売れているアイテムの実物写真を掲載。アイテム数が少ないので、ページがスッキリし、お客様も選びやすいです。",
    "只开两个语言，做透": "2つの言語に絞って徹底的に",
    "英文和西班牙语。没有一上来开 20 种，先把这两个市场的标题和描述改顺。": "英語とスペイン語。いきなり20言語ではなく、まずこの2市場向けのタイトルと説明を整えます。",
    "把运费写清楚": "送料を明確に",
    "多少钱、几天到、能不能退，写在商品页顶上。询盘少了一半，转化高了一截。": "金額、到着日数、返品可否を商品ページの上部に記載。お問い合わせが半分になり、コンバージョン率が上がりました。",
    "第 90 天": "90日目",
    "月订单稳定在 480 上下，开始备第二个语言站": "月間注文数が480前後で安定し、2つ目の言語サイトの準備を開始",
    "稳定期": "安定期",
    "第 32 天": "32日目",
    "改了运费说明，商品页跳出率下降，开始有复购": "送料説明を改善し、商品ページの離脱率が下がり、リピート購入が始まりました",
    "优化期": "最適化期",
    "第 9 天": "9日目",
    "第一单来自西班牙，两件饰品，客单 $34": "最初の注文はスペインから、アクセサリー2点、平均客単価$34",
    "第 1 天": "1日目",
    "选了模板，填店铺名，上传 60 款商品": "テンプレートを選択し、店舗名を入力し、60アイテムをアップロード",
    "开店": "開店",
    "关于这些案例：": "これらの事例について：",
    "人物姓名与店铺信息已做脱敏，数据为区间示意，用于说明做法而非承诺结果。每个人的品类、资金和执行力不同，结果会有差异。": "人物名と店舗情報は匿名化されており、データは範囲を示すもので、結果を保証するものではありません。それぞれのカテゴリー、資金、実行力によって結果は異なります。",
    "这几个人你都不认识": "これらの人は誰も知らない",
    "但他们踩的坑，你大概率会踩。重点不是看他们赚了多少，而是": "しかし、彼らが遭遇した問題はあなたも大抵遭遇するでしょう。重要なのは彼らがどれだけ稼いだかではなく、",
    "看他们在哪个环节换了做法。": "どの段階でやり方を変えたかを見るべきです。",
    "你的起点，可能比他们还好一点": "あなたの出発点は、おそらく彼らよりも少し良いかもしれません。",
    "先开一间免费的，把第一个款上架。剩下的边做边改。": "まずは無料で店を開き、最初の商品を出品しましょう。残りは進めていく中で改善していきます。",
    "我该走哪条路": "どの道を選べばいいのか",
    "平台功能": "プラットフォーム機能",
    "开店要用的东西，这一页全有": "店を開くのに必要なものは全てこのページにあります",
    "建站、翻译、上架、发货、收款、拉客户——": "サイト構築、翻訳、商品登録、発送、決済、顧客獲得——",
    "15 个模块都在一个后台": "15 のモジュールが一つのバックオフィスに統合されています",
    "，不用再去外面拼七八个工具，也不用为了一个功能换一次服务商。": "、外で複数のツールを組み合わせる必要もなく、特定の機能のためにサービスプロバイダーを変える必要もありません。",
    "免费开店，10 分钟看到你的店": "無料で店を開き、10 分で自分の店を見ることができます",
    "先看有哪些模块": "まずは有哪些模块をご覧ください",
    "15 个内置模块": "15 つの内蔵モジュール",
    "20 种语言": "20 言語",
    "佣金 3% 起": "コミッション 3% から",
    "第一次开店最怕的是“还差一样东西”。我把常用的都摆在这一页了，": "初めて店を開くとき、最も怖いのは「まだ何か足りない」ことです。よく使うものをこのページに並べましたので、",
    "从上往下看就行": "上から順に見ていくだけで大丈夫です",
    "内置模块，一个后台": "内蔵モジュール、一つのバックオフィス",
    "种语言，覆盖全球买家": "多言語対応で世界中のバイヤーをカバー",
    "获客渠道可自动投放": "集客チャネルは自動的に配信",
    "交易佣金阶梯": "取引手数料の段階",
    "模块总览": "モジュールの概要",
    "八个方向，撑起一间店": "8つの方向性でお店を支える",
    "每个方向下面都有几个具体功能，往下翻能看到怎么用。": "各方向性には具体的な機能がいくつかあり、下にスクロールすると使い方がわかります。",
    "建站与装修": "サイト構築とデザイン",
    "选模板、拖组件，改完立刻生效。": "テンプレートを選んで、コンポーネントをドラッグ＆ドロップし、変更は即時反映されます。",
    "6 套主题": "6種類のテーマ",
    "手机端自动适配": "モバイル端末自動適応",
    "20 种语言一次配好，买家进来就是他的母语。": "20 言語を一度に設定すれば、バイヤーは自分の母語で閲覧できます。",
    "自动翻译": "自動翻訳",
    "可人工改": "手動修正可能",
    "商品与供应链": "商品とサプライチェーン",
    "粘个链接就能上架，卖出去再采购。": "リンクを貼るだけで商品を出品でき、売れたときに購入します。",
    "1688 / 淘宝采集": "1688 / 淘宝収集",
    "库存同步": "在庫同期",
    "客服、标题、描述，都能交给它。": "カスタマーサポート、タイトル、説明など、すべて任せられます。",
    "24 小时在线": "24時間オンライン",
    "多语言回复": "多言語対応",
    "AI 营销": "AIマーケティング",
    "诊断店铺，给 30 天计划，自动发帖。": "店舗診断を行い、30日間の計画を作成し、自動投稿します。",
    "5 个渠道": "5つのチャネル",
    "内容日历": "コンテンツカレンダー",
    "代购与集运": "代理購入と集荷",
    "客户付外币，平台代买代发。": "顧客が外貨で支払い、プラットフォームが代行購入と発送。",
    "外币收款": "外貨受け取り",
    "合箱省运费": "合箱で送料節約",
    "订单与物流": "注文と物流",
    "批量打面单，轨迹一处看完。": "一括でラベル印刷、トラッキング情報は一か所で確認。",
    "云途 / 燕文 / 4PX": "雲途 / 燕文 / 4PX",
    "异常提醒": "異常通知",
    "收款与结算": "収款と決済",
    "PayPal、Stripe、支付宝接上即用。": "PayPal、Stripe、支付宝を接続すればすぐに使用可能。",
    "T+7 结算": "T+7 決済",
    "多币种提现": "多通貨での出金",
    "01 · 建站": "01 · サイト構築",
    "不用会代码，也能把店弄得像样": "コーディングスキルなしでも立派な店舗を作れる",
    "选一套模板，改文字和图片，手机上就是成品。想调结构就拖组件——左边挑、中间摆，改完点保存，前台立刻变。": "テンプレートを選んで、テキストと画像を編集し、スマートフォンで完成品を見る。構造を調整するにはコンポーネントをドラッグ＆ドロップ——左から選んで中央に配置し、保存すると即座に反映される。",
    "首页、商品页、文章页都能可视化编辑": "ホーム、商品ページ、記事ページのすべてがビジュアルエディタで編集可能",
    "手机和桌面两套排版分开调，不用互相将就": "スマートフォンとデスクトップ用のレイアウトを別々に調整、互いに妥協不要",
    "改坏了能撤回上一版，不怕点错": "誤って変更した場合、前のバージョンに戻せる",
    "编辑 · 首页": "編集 · トップページ",
    "组件": "コンポーネント",
    "标题": "タイトル",
    "商品列表": "商品リスト",
    "图片": "画像",
    "优惠券": "クーポン",
    "视频": "ビデオ",
    "评价": "レビュー",
    "主视觉 banner": "メインビジュアルバナー",
    "拖动": "ドラッグ",
    "四列商品": "4列商品",
    "选中": "選択",
    "买家评价": "購入者レビュー",
    "02 · 多语言": "02 · 複数言語",
    "20 种语言，一次上完": "20の言語、一度に設定可能",
    "后台的语言列表和店铺前台是同一套，开一个语言，商品标题、描述、政策页都会自动翻。翻得不顺手的句子，可以自己改，改完只影响这一句。": "バックエンドの言語リストと店舗フロントエンドは同一で、一つの言語をオンにすると、商品タイトル、説明、ポリシーページが自動的に翻訳されます。不自然な文は自分で修正でき、修正した部分のみ影響を受けます。",
    "英、日、韩、德、法、西、葡、意、俄、阿……共 20 种": "英、日、韓、独、仏、西、葡、伊、露、阿……合計20種類",
    "机翻打底 + 人工修正，术语不会被翻歪": "機械翻訳ベース＋人間による修正、専門用語は正確に翻訳",
    "每种语言有独立的标题和描述，搜索结果不打架": "各言語ごとに独立したタイトルと説明があり、検索結果が重複しません",
    "中文": "中国語",
    "繁體中文": "繁体中国語",
    "店里开的每个语言都在这个列表里，": "店舗で開設したすべての言語がこのリストに含まれます。",
    "两边一一对应": "一対一に対応しています。",
    "，不会出现后台开了前台没有的情况。": "バックエンドで設定したものがフロントエンドにないという状況は発生しません。",
    "选品不用来回切十个网站": "複数のサイトを行き来する必要なく商品を選べます。",
    "从 1688、淘宝粘个链接，商品就采到自己店里，价格、规格、图片一起过来。卖出去再去采购，不用先压一批货在仓库。": "1688や淘宝からリンクを貼るだけで、商品の価格、仕様、画像がまとめて自分の店舗に取り込まれます。売れた後で購入すれば、在庫を先に抱える必要はありません。",
    "采集后自动换成店铺币种，加价规则自己定": "取り込み後、自動的に店舗の通貨単位に変換され、マージンの設定も自由自在です。",
    "库存和价格变动会同步，减少超卖": "在庫と価格の変動は同期され、過剰販売を防ぎます。",
    "支持一件代发，也可以批量导出到自己的仓": "ドロップシッピングをサポートし、また一括で自分の倉庫にエクスポートすることも可能です。",
    "采购价": "仕入れ価格",
    "店铺售价": "店舗販売価格",
    "纯棉圆领 T 恤": "コットンクルーネックTシャツ",
    "帆布托特包": "キャンバストートバッグ",
    "无线蓝牙耳机": "ワイヤレスブルートゥースイヤホン",
    "极简石英手表": "ミニマルなクォーツ腕時計",
    "显示的是": "表示されているのは",
    "你的进价和你的售价": "あなたの仕入れ価格と販売価格",
    "，中间差多少，一眼看得清。": "、差が一目でわかります。",
    "04 · AI 员工": "04 · AIスタッフ",
    "半夜的询盘，也有人回": "深夜の問い合わせにも対応",
    "客户问发货要几天、尺码怎么选、能不能退——AI 员工按你定的规则答，答不了的转人工。写标题、翻描述、改商品图，也能一起交给它。": "発送までの日数、サイズの選び方、返品可否など——AIスタッフはあなたの定めたルールに従って回答し、答えられない質問は人間に転送します。タイトル作成、説明文翻訳、商品画像編集も任せられます。",
    "24 小时在线，时差不用你熬夜补": "24時間オンライン、時差を気にせず",
    "用你的语气和退换规则，不乱承诺": "あなたの口調と返品規則に基づき、適切な約束を守ります",
    "中英日韩等语言来回切，客户说什么它听什么": "中国語、英語、日本語、韓国語など、顧客の言葉を理解して対応",
    "买家 · 02:14": "購入者 · 02:14",
    "AI 员工 · 02:14": "AIスタッフ · 02:14",
    "已自动回复 · 用时 3 秒": "自動返信済み · 所要時間3秒",
    "买家 · 02:15": "購入者 · 02:15",
    "转人工 · 02:15": "人間へ転送 · 02:15",
    "退换属于承诺类问题，已转给你，附上了订单号。": "返品に関する約束事項につき、あなたに転送しました。注文番号も添付しています。",
    "05 · AI 营销": "05 · AIマーケティング",
    "不会投广告，也能让客户找上门": "広告出稿の経験がなくても、顧客を集められます",
    "接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的内容和投放计划。Facebook、Instagram、TikTok 的帖子可以自动生成、定时发。": "豆包のようなAIツールを接続し、店舗の問題点を診断し、30日間のコンテンツと配信計画を作成します。Facebook、Instagram、TikTokの投稿は自動生成・定期投稿が可能です。",
    "店铺诊断：标题、图片、价格、转化，逐项说问题": "店舗診断：タイトル、画像、価格、コンバージョン、各項目の問題点を指摘",
    "30 天内容日历，哪天发什么直接排好": "30日のコンテンツカレンダー、どの日に何を投稿するかを予め設定",
    "一件商品铺到 9 个渠道，博客和邮件能自动发": "1つの商品を9つのチャネルに展開、ブログやメールは自動送信",
    "AI 给的是初稿。": "AIが提供するのは下書きです。",
    "涉及价格和承诺的内容，建议人工过一眼再发": "価格や約束事に関する内容は、送信前に一度人間が確認することをお勧めします",
    "，这一步我们不会替你做主。": "、このステップでは私たちが判断することはできません。",
    "看 18 位 AI 员工的分工": "18人のAIスタッフの役割を確認する",
    "诊断你的店": "あなたの店を診断する",
    "抓取首页和 20 个商品页，找出转化流失的位置。": "ホームページと20個の商品ページを分析し、コンバージョンロスの位置を見つけます。",
    "给出 30 天计划": "30日間の計画を提案する",
    "每天发什么、配什么图、投多少预算，写成清单。": "毎日の投稿内容、画像、予算をリスト化します。",
    "九个渠道一次铺完": "9つのチャネルで一括展開",
    "Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google 商家、站内博客。": "Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google ビジネス、サイト内ブログ。",
    "每周回收数据": "週ごとのデータ収集",
    "哪些帖子带来点击，下一周把预算挪过去。": "どの投稿がクリックをもたらしたかを確認し、次の週に予算を振り分けます。",
    "06 · 代购 / BuyLink": "06 · 代行購入 / BuyLink",
    "客户付外币，你只发国内快递": "顧客は外貨で支払い、あなたは国内配送のみを行います",
    "客户在你店里看到的是外币价，点「代购下单」跳到平台，链接已经预填好。平台买手替你采购、合箱、出国际单。你负责把货送到国内仓，剩下的跨境段平台接走。": "顧客があなたの店で見る価格は外貨表示で、「代行購入」を選択するとプラットフォームに飛び、リンクは既に埋め込まれています。プラットフォームのバイヤーが購入、合箱、国際発送を行います。あなたは商品を国内倉庫まで送るだけで、残りのクロスボーダー部分はプラットフォームが引き受けます。",
    "收外币、付人民币，中间不用自己换汇": "外貨を受け取り、人民元で支払うため、自分で為替を行う必要はありません",
    "多件合箱，运费比一件一件发便宜": "複数の商品を合箱することで、個別発送よりも送料が安くなります",
    "国际段轨迹可查，客户催单时有话说": "国際段階での追跡が可能で、顧客からの催促に対応できます",
    "看跨境物流怎么走": "クロスボーダーロジスティクスの流れを見る",
    "客户在你的店下单": "顧客があなたの店で注文を確定する",
    "看到的是你的价格、你的币种、你的品牌。": "表示されるのはあなたの価格、通貨、ブランドです。",
    "点「代购下单」": "「代購注文」をクリック",
    "跳到平台，商品链接和规格已预填，客户只需确认。": "プラットフォームに移動し、商品リンクと仕様は既に事前に入力されています。お客様は確認するだけです。",
    "平台采购并合箱": "プラットフォームが購入し、箱詰め",
    "买手收货、验货、去掉多余包装，几单并一箱。": "バイヤーが商品を受け取り、検品し、余分なパッケージを取り除き、複数の注文を1つの箱にまとめます。",
    "出国际单，轨迹回传": "国際発送、追跡情報の更新",
    "单号自动回到你的订单里，客户也能看到。": "トラッキング番号は自動的にあなたの注文に反映され、お客様も見ることができます。",
    "后台日常": "バックエンドの日常管理",
    "订单、客户、权限，一个地方管完": "注文、顧客、権限を一箇所で管理",
    "店里跑起来以后，每天真正要看的就这三块。": "店舗が稼働したら、毎日チェックすべきはこの3つです。",
    "订单看板": "注文ダッシュボード",
    "今天几单、待发货几单、哪单卡在海关，打开就看见。": "今日の注文数、発送待ちの注文数、税関で止まっている注文など、開くとすぐにわかります。",
    "批量打面单，一次几十张": "一度に数十枚の配送ラベルを印刷",
    "异常件单独列出来": "異常な注文は別途リストアップ",
    "客户资产": "顧客資産",
    "邮箱、订单、复购记录都在你的后台，不是平台的。": "メールアドレス、注文履歴、リピート購入記録はすべてあなたのバックエンドに保存されます。プラットフォームではありません。",
    "一键导出 CSV": "CSVの一括エクスポート",
    "按购买次数分组": "購入回数ごとにグループ分け",
    "权限与协作": "権限とコラボレーション",
    "谁能看什么，按角色分好，不用共享一个账号。": "役割に基づいて誰が何を見られるかを設定できます。1つのアカウントを共有する必要はありません。",
    "客服 / 运营 / 老板三档": "カスタマーサービス / オペレーション / 経営者 3段階",
    "操作日志可追溯": "操作ログは追跡可能です",
    "这一页东西多，不用全看完": "このページの内容は多いですが、全部読む必要はありません",
    "你只要记住一句：": "覚えておくべきことは一言です:",
    "开店要用的六件事，这里都有对应的人": "店舗運営に必要な6つの事項に対応する人がいます",
    "。建站、翻译、上架、发货、收款、拉客户——缺哪一块，直接跳到那一块看。": "。ウェブサイト構築、翻訳、商品登録、発送、決済、顧客獲得——どの部分が不足しているか確認し、その部分を直接見ましょう。",
    "先看要花多少钱": "まずは費用を見てみましょう",
    "看完了，直接开一间试试": "見てから、すぐに試してみてください",
    "免费开店，不绑卡、不签合同。店铺先跑起来，觉得有用再谈套餐。": "無料で店舗を開設できます。カードの紐付けや契約は不要です。店舗を実際に動かしてみて、有用であればプランについて話し合いましょう。",
    "看价格": "価格を見る",
    "给中国卖家": "中国の販売者向け",
    "你只管选品和定价，": "あなたは商品選定と価格設定だけを行えばよいです、",
    "其余我们办": "残りは私たちが行います",
    "建站、翻译、运费、打面单、答客户——": "ウェブサイト構築、翻訳、送料、ラベル作成、顧客対応——",
    "中间这些麻烦事，平台替你做了。": "これらの手間のかかる作業は、プラットフォームが代わりに行います。",
    "先看看别人在卖什么": "まずは他の人が何を売っているか見てみましょう",
    "佣金低至 3% · 模板和翻译按套餐含 · 店铺和客户数据都归你": "コミッションは3%から · テンプレートと翻訳はプランに含まれます · 店舗と顧客データはあなたのものです",
    "Taoify 商家工作台 · 数据看板界面": "Taoify セラーワークステーション · データダッシュボード",
    "已上线 20 种语言站点": "20 言語のサイトが既にリリース済み",
    "日本語 · Deutsch · Español …": "日本語 · ドイツ語 · スペイン語 …",
    "下面这六件事，你大概率会遇到其中三四件。": "以下の6つの事項のうち、おそらく3つから4つは遭遇することになります。",
    "遇到了再解决": "問題は起きたときに解決すればいい",
    "，不用现在全想明白。": "すべてを今すぐ理解する必要はありません。",
    "开店前后，绕不开的六个问题": "店舗開設前後の避けて通れない6つの問題",
    "每一件都有现成的解法": "すべてに既存の解決策があります",
    "上面是你会问的问题，中间是我们怎么接，下面是你最后得到什么。": "上部はあなたの質問、中部は私たちの対応、下部は最終的な成果です。",
    "没有技术团队，建站要外包？": "技術チームがいない場合、ウェブサイト構築は外部委託が必要ですか？",
    "选一个模板，填店铺名和邮箱，十分钟就开了。想改哪里点哪里，不用发需求等排期。": "テンプレートを選んで、店名とメールアドレスを入力すれば10分で開設できます。変更したい部分はクリックしてすぐに編集でき、要件提出やスケジュール待ちが不要です。",
    "10 分钟上线，改版不用排队": "10分でオンライン、リニューアルも待たずに対応",
    "不会外语，商品描述怎么写？": "外国語がわからなくても商品説明は書ける？",
    "20 种语言自动翻，翻得不顺的句子可以自己改。术语不会被翻歪，尺码表也是对的。": "20言語への自動翻訳機能があり、不自然な文は自分で修正できます。専門用語は正確に、サイズチャートも正しく表示されます。",
    "日本客户看日文，德国客户看德文": "日本のお客様には日本語、ドイツのお客様にはドイツ語",
    "运费到底收多少，才不亏？": "送料をどれだけ設定すれば損しないか？",
    "按重量和地区设好模板，客户下单时系统自动算。偏远地区单独加价，不用你手算。": "重量と地域に基づいてテンプレートを設定し、注文時にシステムが自動計算します。遠隔地には個別に追加料金を設定し、手動計算は不要です。",
    "不再出现「运费比货贵」": "「送料が高い」という状況はもう起こりません",
    "客户想刷卡，我只收过微信？": "クレジットカード決済を受け付けたいけど、今まで微信しか使ったことがない",
    "PayPal、Stripe、支付宝接上即用，外币直接进你的账户，平台不代收货款。": "PayPal、Stripe、Alipayを接続すればすぐに使用可能で、外貨は直接あなたの口座に入金され、プラットフォームが代わりに受け取ることはありません。",
    "结账页多三种付法，少一次流失": "チェックアウトページに3つの支払い方法を追加し、顧客の脱落を減らす",
    "国际快递怎么发，单号怎么回传？": "国際配送はどうやって行い、追跡番号はどうやって伝える？",
    "云途、燕文、4PX 实时比价，选一条就出单。面单批量打完，轨迹自动回到订单里。": "雲途、燕文、4PXでリアルタイム比較を行い、選択したサービスで即発送。一括でラベルを印刷し、トラッキング情報は自動的に注文に反映されます。",
    "一张面单贴完，客户自己查轨迹": "ラベルを貼るだけで、お客様自身がトラッキング情報を確認できます",
    "客户半夜问东问西，谁来回？": "深夜の問い合わせにも対応できるのは誰？",
    "AI 员工按你定的规则答，答不了的转给你。时差不用熬，第二天看记录就行。": "AIスタッフがあなたが設定したルールに従って回答し、答えられないものはあなたに転送します。時差を気にせず、翌日に記録を確認するだけです。",
    "询盘不隔夜，退换不乱承诺": "問い合わせは翌日に持ち越さず、返品交換について適切に対応",
    "全链路": "全工程",
    "你的活到「交给快递」为止": "あなたの作業は「配送業者に引き渡す」まで",
    "后面这一段，是大多数人卡住的地方。我们把它接走。": "ここから先は多くの人が困る部分です。私たちが引き継ぎます。",
    "你的货": "あなたの商品",
    "工厂或仓库里": "工場または倉庫内",
    "现成的那批货": "既存の在庫",
    "上架": "出品",
    "一键铺货": "一括出品",
    "20 语种自动翻译": "20言語自動翻訳",
    "收款": "収款",
    "外币进账": "外貨入金",
    "不经过平台": "プラットフォーム経由なし",
    "国内仓": "国内倉庫",
    "你发到仓": "あなたが倉庫へ発送",
    "验货合箱": "検品・梱包",
    "出境派送": "海外配送",
    "报关、干线": "通関、主要輸送路",
    "末端签收": "最終受け取り",
    "紫色：平台负责": "紫色：プラットフォームが責任を持ちます",
    "灰色：你负责": "灰色：あなたが責任を持ちます",
    "看物流怎么走": "物流の流れを見る",
    "获客": "顧客獲得",
    "店开好了，客户从哪来": "店舗は開設しましたが、顧客はどこから来ますか",
    "这是第二道坎。Taoify 接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的计划，然后自动发到五个渠道。": "これが第二の難関です。Taoify は豆包のような AI を接続し、まずあなたの店舗の問題を診断し、その後30日間実行できる計画を作成し、自動的に5つのチャネルに送信します。",
    "Facebook、Instagram、TikTok 等 5 个渠道自动发": "Facebook、Instagram、TikTok など5つのチャネルに自動送信",
    "每周回收数据，把预算挪到有反应的那条": "毎週データを収集し、反応のあるチャネルに予算を移動",
    "看 AI 营销怎么用": "AI マーケティングの使い方を見る",
    "多平台内容分发": "マルチプラットフォームでのコンテンツ配信",
    "更轻的起步方式": "より軽いスタート方法",
    "不想压货？先走代购": "在庫を抱えたくない？まずは代理購入から始める",
    "客户付外币，你只发国内快递。采购、集运、国际段都由平台办。": "顧客は外貨で支払い、あなたは国内配送のみを行います。調達、集荷、国際輸送はすべてプラットフォームが処理します。",
    "第一档 · 起步用这个": "第一段階 · スタートにはこれを使います",
    "代购模式": "代理購入モード",
    "不用备货、不用垫钱。客户下单后平台去买，你连货都不用碰。": "在庫を持つ必要はありませんし、資金を前払いする必要もありません。顧客が注文した後、プラットフォームが商品を購入し、あなたは商品に触れることさえありません。",
    "零压货，卖什么买什么": "在庫ゼロ、売れるものだけを買う",
    "外币收款由平台处理": "外貨の収受はプラットフォームが処理します",
    "适合刚起步、试品类": "新しく始める人やカテゴリを試す人に適しています",
    "跑通之后": "実行後",
    "第二档 · 放量用这个": "第二段階 · 大量注文用",
    "模式": "モード",
    "店铺直接收外币，采购、集运、出国际单都由平台办。你只负责选品和发国内快递。": "店舗で直接外貨を受け取り、調達、集荷、国際発送はすべてプラットフォームが担当します。あなたは商品選定と国内配送だけを担当します。",
    "利润归你，价格自己定": "利益はあなたのもの、価格は自分で設定",
    "多件合箱，运费更省": "複数の商品を一つの箱にまとめて、送料を節約",
    "适合已有稳定货源": "安定した供給源がある場合に適しています",
    "客户那一端看到的是这样": "顧客側にはこう表示されます",
    "在你的店铺看到商品，价格是你定的": "あなたの店舗で商品を見つけて、価格はあなたが設定したものです",
    "点「代购下单」，跳到代购平台，链接已预填": "「代行購入」をクリックして、リンクが事前に埋め込まれた代行購入プラットフォームに飛びます",
    "平台买手回你的店下普通国内订单": "プラットフォームのバイヤーがあなたの店舗で通常の国内注文をします",
    "你发国内快递到平台仓，国际段平台负责": "あなたは国内配送でプラットフォームの倉庫に商品を送り、国際配送はプラットフォームが担当します",
    "跑通了想自己赚利润，再切成 BuyLink 模式：店铺直接收外币，采购、集运、出国际单都由平台办。": "実行後に利益を得たい場合は、BuyLink モードに切り替えて：店舗で直接外貨を受け取り、調達、集荷、国際発送はすべてプラットフォームが担当します。",
    "三条路": "3つの道",
    "自己搭、找外包、用 Taoify": "自分で作る、外部委託、Taoifyを使う",
    "不比参数，比的是「多久能开卖」和「出问题谁管」。": "比較するのは「どれくらい早く販売できるか」と「問題があったときに誰が対応するか」です。",
    "对比项": "比較項目",
    "自己搭": "自分で作る",
    "找外包": "外部委託",
    "上线时间": "リリース時間",
    "1–2 个月": "1–2 ヶ月",
    "2–4 周，改一次再等一周": "2–4 週間、変更後はさらに1週間待ち",
    "当天": "当日",
    "前期投入": "初期投資",
    "服务器、插件、维护，几千起": "サーバー、プラグイン、メンテナンス、数千円から",
    "几万起": "数万円から",
    "佣金 3%–6%，按月成交额阶梯": "コミッション 3%–6%、月間売上額による段階制",
    "改一次样式": "スタイルを1回変更する",
    "找人重做": "誰かに再作成してもらう",
    "再付一次钱": "再度支払いが必要",
    "自己点两下，或跟 AI 说一句": "自分で2回クリックするか、AIに一言言うだけ",
    "多语言": "多言語対応",
    "装插件，翻译另买": "プラグインをインストールし、翻訳は別途購入",
    "加钱，通常只做一两种": "追加料金が必要、通常1～2言語のみ対応",
    "20 种语言内置，自动切换": "20言語内蔵、自動切り替え",
    "自己申请，被拒就卡住": "自分で申請し、拒否されたらそこで止まる",
    "自己申请": "自分で申請",
    "PayPal、Stripe、支付宝接上即用": "PayPal、Stripe、支付宝を接続すればすぐに使用可能",
    "国际物流": "国際物流",
    "自己找货代、自己算价": "自分で貨物代理店を探す、価格を自分で計算",
    "不在服务范围": "サービス範囲外",
    "云途、燕文、4PX 已接，自动比价出单": "雲途、燕文、4PX が受け付け、自動的に最安価格で出荷",
    "自己摸索": "自分で試す",
    "AI 诊断 + 30 天方案 + 五渠道": "AI ダイアグノスティック + 30 日間のプラン + 5つのチャネル",
    "客户归属": "顧客管理",
    "你的": "あなたの",
    "你的，邮箱和订单数据都在你后台": "あなたのもの。メールと注文データはすべてバックエンドにあります",
    "对比基于常见方案的平均情况，不代表任何具体服务商。": "一般的なプランに基づいた比較であり、特定のサービスプロバイダーを示すものではありません。",
    "怎么开始": "どのように始めればよいか",
    "三步，今天就能走完第一步": "3ステップ、今日中に1つ目のステップを完了できます",
    "填店铺名和邮箱，选一个模板。不用绑卡，不签合同。": "店舗名とメールアドレスを入力し、テンプレートを選択してください。カードの登録や契約は必要ありません。",
    "约 10 分钟": "約10分",
    "粘 1688 或淘宝链接，或用 Excel 批量导入。价格自己定。": "1688または淘宝のリンクを貼るか、Excelで一括インポートします。価格は自分で設定します。",
    "约 1 小时": "約1時間",
    "出第一单": "最初の注文を出す",
    "把链接发到你已有的群或朋友圈，或者让 AI 帮你发到海外渠道。": "既存のグループや友達の輪にリンクを共有するか、AIに海外チャネルへの投稿をお願いします。",
    "看你自己": "あなた次第",
    "不用一次全准备好": "一度に全て準備する必要はありません",
    "很多人以为要先把货备齐、把公司注册好、把英文练好。其实": "多くの人が商品を全部揃えたり、会社を設立したり、英語を習得したりしなければならないと考えていますが、実際には",
    "先上十个商品试一个月": "まず10個の商品を1ヶ月試してみましょう",
    "，你会发现问题根本不在这些地方。": "、問題の根本はこれらの場所にはないことに気づくでしょう。",
    "先开一间，比想清楚更重要": "まずは一歩踏み出すことが大切です",
    "免费的，不绑卡。跑通一单再决定要不要花钱。": "無料で、カード情報不要。1件試してからお金を払うかどうか決められます。",
    "给海外卖家": "海外の販売者向け",
    "在中国的货架上选品": "中国の商品棚から選べます",
    "在你自己的店里卖": "自分の店で販売できます",
    "不用飞中国、不用懂中文、不用先压一批货。": "中国に行かなくても、中国語がわからなくても、最初に大量に在庫を持つ必要もありません。",
    "你选好商品，": "あなたが商品を選んで、",
    "采购、检查、打包、发货我们来做": "購入、検品、梱包、発送は私たちが行います",
    "免费开店，先挑 3 件商品试试": "無料でお店を開き、まずは3つの商品を試してみてください",
    "先看看店长什么样": "まずはお店の様子を見てみましょう",
    "一件代发 · 不压库存 · 佣金低至 3%": "ドロップシッピング · 在庫不要 · コミッションは最低3%",
    "订单": "注文",
    "设置": "設定",
    "待处理": "処理待ち",
    "运输中": "配送中",
    "已签收": "受領済み",
    "物流全程可查": "物流状況は常に確認できます",
    "燕文 · 4PX · 集运合箱": "燕文 · 4PX · 集荷・合併",
    "中国的货架上有什么、怎么运到你手上，": "中国の棚に何があるのか、どうやって手元に届くのか、",
    "往下翻都能看到": "下にスクロールすればすべて見られます",
    "。先看你在第一步卡在哪。": "。まずは最初のステップでどこでつまづいているかを見てみましょう。",
    "从选品到客户收到货": "商品選定から顧客への配送まで",
    "这几步，我们替你做了": "これらのステップは私たちが代行します",
    "想卖中国货，不知道找谁拿货？": "中国製品を販売したいけど、どこから仕入れるべきかわからない？",
    "打开商品库，按品类、价格、销量筛。每件商品都有实拍图和规格，看中的直接加进你的店。": "商品データベースを開き、カテゴリー、価格、販売数で絞り込みます。各商品には実際の写真と仕様があり、気に入ったものは直接あなたの店に追加できます。",
    "不用自己跑工厂、不用加中间商": "自ら工場に行ったり、中間業者を通す必要はありません",
    "不会中文，怎么跟供应商谈？": "中国語がわからなくても、どのようにサプライヤーと交渉するのですか？",
    "不用谈。下单、检查、安排发货都由平台完成，你只跟平台说你的语言。": "交渉は不要です。注文、検品、発送手配はすべてプラットフォームが行います。あなたは自分の言語でプラットフォームと話すだけです。",
    "全程不需要一句中文": "中国語は一切必要ありません",
    "怕压一批货卖不掉？": "在庫を持ちすぎて売れ残る心配がありますか？",
    "一件代发。客户在你的店下单，我们才去采购和发货，你手上不压库存，也不占资金。": "一件代発。お客様があなたの店で注文したときに初めて購入と発送を行いますので、在庫を抱えたり資金を占用したりしません。",
    "零库存起步，卖不动不亏钱": "ゼロ在庫から始めて、売れなければ損失はありません",
    "怕收到的货跟图片不一样？": "受け取った商品が画像と異なることを心配していますか？",
    "商品由平台审核后进入商品库，出库前检查。坏损、错发按平台规则处理，不用你自己去跟工厂扯。": "商品はプラットフォームによって審査され、商品データベースに登録されます。出庫前に再度チェックし、不良品や誤配送についてはプラットフォームのルールに基づいて対応します。そのため、あなたが工場とやり取りする必要はありません",
    "出了问题有人负责": "問題が起きたときには誰かが責任を持ちます",
    "客户等不及，一直催单？": "お客様が待ちきれず、注文状況を急かしてくる？",
    "国际专线直发，全程可查。客户在你的店里就能看到货走到哪了，不用来问你。": "国際専用ラインでの直送で、全行程追跡可能です。お客様はあなたの店で荷物の位置を確認できるため、あなたに問い合わせる必要はありません。",
    "物流进度客户自己看": "物流の進捗状況はお客様自身で確認できます",
    "收款要等多久，平台抽多少？": "収款までどれくらいかかりますか？プラットフォームはどのくらい取りますか？",
    "客户用他们习惯的方式付款。平台不从你的销售里抽成，卖多少你收多少。": "顧客は彼らが慣れた方法で支払いをします。プラットフォームはあなたの売上から手数料を取りません、売った金額全額を受け取れます。",
    "佣金按阶梯，最高也只 6%": "コミッションは段階制で、最高でも6%です",
    "这一段叫「第一公里」": "この部分を「最初のキロ」と呼びます",
    "把货送出中国，是别人的问题": "商品を中国から送るのは他の人の問題です",
    "把货从工厂弄到你手上，才是你的问题": "工場からあなたのもとに商品を届けるのがあなたの問題です",
    "紫色是我们替你办的，灰色是你只需要做的那一步。": "紫色は私たちが代わりに行う作業、灰色はあなたが必要とするステップです",
    "中国工厂": "中国の工場",
    "按你的选品采购": "あなたの選んだ商品を購入",
    "先验资质再下单": "資格を確認してから注文",
    "平台仓": "プラットフォームの倉庫",
    "入库验货、称重、拍照": "入庫検品、重量測定、写真撮影",
    "不合格直接退回": "不合格の場合は直接返品",
    "国际段": "国際輸送",
    "燕文 / 4PX 专线": "燕文 / 4PX 専用便",
    "或集运合箱": "または集荷・合箱",
    "你的店": "あなたの店",
    "价格你定": "価格はあなたが決めます",
    "品牌是你的": "ブランドはあなたのものです",
    "你的客户": "あなたの顧客",
    "下单、付款、收货": "注文、支払い、受け取り",
    "数据留在你后台": "データはあなたのバックエンドに残ります",
    "紫色：我们替你办": "紫色：私たちが代行します",
    "灰色：你只需要做这一步": "灰色：あなたはこのステップだけを行います",
    "两档做法": "2つの方法",
    "先轻后重：先代发跑通，再备货放大": "まずは軽い方から：ドロップシッピングで流れを確認し、その後在庫を増やします",
    "同一个店，两种节奏。不用一上来就把钱压进去。": "同じ店舗でも2つのペース。最初から大量の資金を投入する必要はありません。",
    "一件代发": "ドロップシッピング",
    "轻": "軽い",
    "客户在你的店下单，我们采购、验货、出国际单，一直送到他手上。你只需要把商品挂上去。": "お客様があなたの店で注文をすると、私たちは商品を調達、検品、国際配送を行い、直接お客様のもとに届けます。あなたは商品を掲載するだけでいいです。",
    "零库存、零资金占用，卖不动就换品": "在庫ゼロ、資金占用ゼロ、売れなければ商品を変えることができます",
    "单件成本高一点，但不用赌": "単価は少し高くなりますが、リスクは低くなります",
    "适合新店、新品、没试过的品类": "新店舗、新商品、試していないカテゴリーに適しています",
    "适合：": "適しているのは：",
    "还没验证过的品": "まだ検証されていない商品",
    "备货到本地": "現地への在庫確保",
    "重": "重い",
    "卖得动的品批量采购，走集运合箱或海外仓，单件成本和到货时间都压下来。": "売れる商品をまとめて購入し、集荷・合併または海外倉庫を利用することで、単価と納期を抑えることができます。",
    "单件成本更低，利润更厚": "単価が低く、利益率が高い",
    "到货更快，客户体验和复购更好": "納期が短く、顧客体験とリピート購入が向上します",
    "需要一点备货资金和仓位": "少しだけ在庫資金とスペースが必要",
    "已经卖稳的爆款": "すでに安定して売れている人気商品",
    "不懂中文也能管店": "中国語がわからなくても店を管理できる",
    "18 位 AI 员工，替你处理日常": "18人のAIスタッフがあなたの日常業務を処理",
    "商品、订单、增长、经营四组，按需订阅，不需要一次全开。": "商品、注文、成長、運営の4つのグループ。必要なものだけを選んで契約できます。",
    "你不用雇人，也不用学会中文后台": "従業員を雇う必要も、中国語のバックエンドを学ぶ必要もありません",
    "——它们用你市场的语言干活。": "—あなたの市場の言語で作業します。",
    "商品文案官": "商品コピーライター",
    "用目标市场的语言写标题和描述，不是机翻": "ターゲットマーケットの言語でタイトルと説明を書く、機械翻訳ではありません",
    "AI 客服": "AIカスタマーサポート",
    "7×24，用客户的语言回复，常见问题直接解决": "24時間365日、顧客の言語で返信し、よくある質問を直接解決",
    "选品助手": "商品選定アシスタント",
    "看哪些品在你的市场真的卖得动": "あなたの市場で実際に売れる商品を見つける",
    "经营日报": "経営日報",
    "今天发生了什么，明天该做什么": "今日何が起こったか、明日何をするべきか",
    "三步，不用先付钱": "3ステップ、最初に支払いは不要",
    "第一步": "第1ステップ",
    "注册开店": "店舗登録",
    "几分钟注册，不需要信用卡。店名和域名随时能改。": "数分で登録でき、クレジットカードは不要です。店名とドメインはいつでも変更可能です。",
    "约 5 分钟": "約5分",
    "第二步": "第二ステップ",
    "挑商品": "商品を選ぶ",
    "从中国商品库挑，或者导入你自己的货源。看中就一键铺到店里。": "中国の商品リストから選ぶか、独自の供給源をインポートします。気に入った商品はワンクリックで店舗に追加できます。",
    "当天能挑完": "当日中に選べます",
    "第三步": "第三ステップ",
    "开卖": "販売開始",
    "客户下单，我们发货。物流他自己能查，售后有人接。": "お客様が注文すると、私たちは発送します。物流状況はお客様自身で確認でき、アフターサービスも対応しています。",
    "0 库存": "0 在庫",
    "你在中国，想把货卖出去？": "中国にいて、商品を売りたいですか？",
    "看这一页 →": "こちらのページをご覧ください →",
    "第一公里是最容易低估的一段": "最初の一キロメートルは最も見落とされやすい部分です",
    "工厂到仓、仓到口岸、口岸到干线——": "工場から倉庫へ、倉庫から通関地点へ、そして通関地点から主要輸送路へ——",
    "这三段任何一段卡住，后面全乱": "これらのどの段階でも滞ると、後続のすべてが混乱します",
    "。先把这一段跑顺，再谈增长。": "。まずはこの部分を円滑に運営し、その後成長について考えましょう。",
    "你挑货、定价、卖货，货从中国直接到客户手上。": "あなたが商品を選んで価格を設定し、販売するだけで、商品は直接中国からお客様のもとに届けられます。",
    "不需要仓库，不需要员工，也不需要会说中文。": "倉庫も従業員も必要ありませんし、中国語を話せる必要もありません。",
    "帮助中心": "ヘルプセンター",
    "有问题，先在这里找": "問題がある場合は、まずここを見てください",
    "常见问题按分类整理好了，搜不到就直接问 AI 客服，它会带着你的问题接着答。": "よくある質問はカテゴリ別に整理されています。検索できない場合は、AIカスタマーサポートに直接お聞きください。",
    "搜索：怎么改价格、退款怎么处理、忘记密码…": "検索：価格の変更方法、返金処理、パスワードを忘れた場合…",
    "搜索": "検索",
    "常搜：": "よく検索される：",
    "懒得翻？直接问 AI 客服": "探すのが面倒なら、AIカスタマーサポートに直接聞いてみましょう",
    "开店、选品、物流、结算都能问，答不上会转人工。": "店舗開設、商品選定、物流、決済について何でも聞けます。答えられない場合は、人間のサポートに転送します。",
    "开始提问": "質問を始める",
    "搜不到就直接问 AI 客服，": "検索できない場合は、AIカスタマーサポートに直接聞いてみてください。",
    "别自己在那儿猜。": "自分で推測しないでください。",
    "猜错一步，后面要多改三处。": "間違えると、後で3か所修正する必要があります。",
    "条": "件",
    "常见问题": "よくある質問",
    "大家问得最多的这些": "みんなが一番多く聞く質問",
    "当前筛选：": "現在のフィルター：",
    "清空筛选": "フィルターをクリア",
    "这条没解决，问 AI 客服": "この回答で解決しない場合は、AIカスタマーサポートに聞いてみてください",
    "没有找到这一条。": "該当する項目が見つかりませんでした。",
    "把这个问给 AI 客服": "この質問をAIカスタマーサポートに聞いてみてください",
    "没搜到，已经把「": "検索結果なし。「",
    "」发给 AI 客服了，在右下角继续聊。": "」をAIカスタマーサポートに送信しました。右下で会話を続けられます。",
    "还没解决": "まだ解決していません",
    "三条路，总有一条能通": "3つの方法があり、必ず一つは通ります",
    "AI 客服随时在线，工单最慢 4 小时回，邮件适合附合同和证件。": "AIカスタマーサポートはいつでもオンラインです。チケットへの返答は最長4時間以内、メールは契約書や証明書の添付に適しています。",
    "开店、选品、物流、结算的常见问题，它当场答；答不上会转人工。": "店舗開設、商品選定、物流、決済に関するよくある質問は即座に回答します。答えられない場合は、人間のサポートに転送します。",
    "打开对话": "会話を開始する",
    "提工单": "チケットを提出する",
    "描述清楚问题、附上订单号或截图，一般 4 小时内有人接。": "問題を明確に説明し、注文番号やスクリーンショットを添えてください。通常4時間以内に対応します。",
    "登录后提工单": "ログインしてチケットを提出",
    "发邮件": "メールを送る",
    "适合需要附合同、发票、证件的情况，附件不会丢。": "契約書、請求書、証明書などを添付する必要がある場合に適しています。添付ファイルは失われません。",
    "写邮件": "メールを作成",
    "开放接口": "オープンAPI",
    "有自己的系统？接进来就行": "独自のシステムがありますか？接続するだけです",
    "商品、库存、订单、物流轨迹都开放了 REST 接口和 Webhook。用 ERP 管货的，可以只同步库存；用自己后台管订单的，可以只拉订单。": "商品、在庫、注文、物流トラッキングについて REST API と Webhook を公開しています。ERPで在庫管理をしている場合は、在庫のみ同期できます。独自のバックエンドで注文を管理している場合は、注文のみ取得できます。",
    "REST API，Token 鉴权，支持分页与增量拉取": "REST API、Token認証、ページネーションと増分取得に対応",
    "Webhook 推送下单、付款、发货、退款事件": "Webhookで注文、支払い、発送、返金イベントのプッシュ通知",
    "沙箱环境，不影响正式店铺数据": "サンドボックス環境、本番店舗データには影響ありません",
    "向 AI 客服要接口文档": "AIカスタマーサポートにAPIドキュメントを要求",
    "接口按": "インターフェースは",
    "店铺维度隔离，": "店舗単位で隔離され、",
    "一个 Token 只能读自己店的数据。": "1つのTokenは自分の店のデータしか読み取れません。",
    "店铺前台访问": "店舗フロントエンドアクセス",
    "后台与订单接口": "バックエンドと注文インターフェース",
    "面单与轨迹回传": "伝票とトラッキング情報のアップロード",
    "AI 能力": "AI機能",
    "最近一次异常：10-21 02:10–02:26，物流轨迹回传延迟，已恢复。": "最近の異常：10-21 02:10–02:26、物流トラッキング情報の遅延、既に復旧済み。",
    "查看历史": "履歴を見る",
    "还是没解决？直接问 AI 客服": "まだ解決しない？AIカスタマーサポートに直接聞いてみましょう",
    "把店铺编号和截图一起发过去，通常当天就有回复。": "店舗番号とスクリーンショットを一緒に送ってください。通常、当日中に返信があります。",
    "还没开店？先开一间再来问": "まだ店を開いていないですか？まずは店を開いてからお問い合わせください。",
    "大部分问题，开完店自己就明白了。免费的，不绑卡。": "多くの問題は、店を開いたら自然と理解できるようになります。無料で、カードの登録も必要ありません。",
    "看功能": "機能を見る",
    "改价格": "価格変更",
    "退款": "返金",
    "绑定域名": "ドメインのバインド",
    "忘记密码": "パスワードを忘れた場合",
    "物流不更新": "物流情報の更新なし",
    "不管你在供应链的哪一端": "サプライチェーンのどの部分にいても",
    "中国货，卖全球": "中国の商品、世界中へ販売",
    "零代码开店 · 多语言商城 · 一键铺货 · 全球收付款": "ゼロコードで開店 · 多言語対応のオンラインショップ · 一括商品登録 · グローバル決済",
    "建站、翻译、收款、发货、获客，中间这几件麻烦事我们全包了。": "ウェブサイト作成、翻訳、決済、発送、顧客獲得、これらの複雑な手続きは全て私たちが引き受けます。",
    "如果你在中国": "もし中国にいるなら",
    "我在中国": "私は中国にいます",
    "要把货卖出去": "商品を売りたいなら",
    "不用会建站、不用懂外语、不用自己发国际快递": "ウェブサイト作成の知識や外国語、国際配送の手配が不要です",
    "如果你在海外": "もし海外にいるなら",
    "我在海外": "私は海外にいます",
    "要卖中国好货": "質の良い中国製品を売りたいなら",
    "直连中国供应链，一件代发、不用压货、不用懂中文": "中国のサプライチェーンと直接連携、一件代発、在庫リスクなし、中国語の知識不要",
    "看看能卖什么": "何を売れるか見てみる",
    "对号入座": "自分に合った選択をする",
    "你在哪一端？两条路都能走通": "あなたはどちら側にいますか？どちらの道も通じています",
    "两端缺的东西正好相反：一头缺把货送出去，一头缺把货弄到手。": "両端で不足しているものは逆です：一方では商品を出荷する手段が足りず、もう一方では商品を入手する手段が足りません。",
    "两条路都在下面，": "二つの道が下にあります。",
    "选你站在的那一端": "あなたが立っている方を選んでください。",
    "往下读就行。选错了也不打紧，开店后随时能改。": "読み進めるだけで大丈夫です。間違えても問題ありません、開店後でもいつでも変更できます。",
    "中国卖家": "中国の販売者",
    "有工厂或货源，想跳过中间商直接卖给老外": "工場や商品源があり、中間業者を飛ばして直接海外のお客様に売りたい",
    "在平台卖了很多年，怕一条规则下来店就没了": "プラットフォームで長年販売していて、規則の変更で店舗がなくなるのが怖い",
    "主要做国内生意，想有个自己的店，不再把利润分给平台": "主に国内ビジネスをしていて、自分の店を持ち、プラットフォームに利益を分配したくない",
    "看中国卖家怎么开始": "中国の販売者がどのように始めるかを見る",
    "海外卖家": "海外の販売者",
    "在当地已经有客源，想加点中国货但不想先压一批库存": "地元で顧客を持っていて、中国製品を追加したいが在庫を抱えたくない",
    "想创业，找不到靠谱的工厂，也不会做网站": "起業したいが、信頼できる工場を見つけられず、ウェブサイトを作ることもできない",
    "已经在做代购或微商，想把手上这些客户搬到一个正式的网站": "すでに代理購入やSNS販売をしていて、これらの顧客を正式なウェブサイトに移したい",
    "看海外卖家怎么开始": "海外の販売者がどのように始めるかを見る",
    "全链路闭环": "全工程閉環",
    "从工厂到客户手上": "工場からお客様の手元まで",
    "中间这几件麻烦事，我们全包": "これらの複雑な手続きは全て私たちが引き受けます",
    "不用再对接七八个系统，一个后台从头管到尾。": "複数のシステムと連携する必要はありません、一つのバックエンドで全て管理できます。",
    "快速建站": "迅速なサイト構築",
    "10 分钟，零代码": "10分、コード不要",
    "拥有专业品牌独立站": "プロフェッショナルなブランド独立サイトを持つ",
    "海量铺货": "大量商品の展開",
    "1688 / 淘宝一键采集": "1688 / 淘宝ワンクリック収集",
    "AI 翻译，批量上架": "AI翻訳、一括出品",
    "便捷收款": "簡単決済",
    "支持全球主流支付": "世界中の主要な支払い方法に対応",
    "资金安全直达": "資金の安全な送金",
    "智能物流": "スマートな物流",
    "多仓发货，合箱出库": "複数の倉庫からの発送、まとめて出庫",
    "实时跟踪，全球送达": "リアルタイム追跡、世界中への配送",
    "持续运营": "継続的な運営",
    "数据分析，SEO 优化": "データ分析、SEO最適化",
    "会员管理，长期复购": "会員管理、長期的なリピート購入",
    "平台特色": "プラットフォームの特長",
    "别的工具卖你一个网站": "他のツールはあなたにウェブサイトを売ります",
    "我们给你一整个团队": "私たちはあなたに一丸となったチームを提供します",
    "建站只是起点。真正难的是三件事：": "ウェブサイトの構築は始まりに過ぎません。本当に難しいのは3つのことです：",
    "没人干活、没人看见、货发不出去。": "作業者がいない、誰も見ていない、商品が発送できない。",
    "18 位员工": "18人のスタッフ",
    "你睡觉的时候，有人还在改标题、回差评、盯物流": "あなたが寝ている間も、誰かがタイトルを修正し、悪いレビューに返信し、物流を監視しています",
    "每天巡检全店：缺图、缺描述、踩违规词，直接改掉": "毎日全店舗を点検：画像不足、説明不足、違反ワード使用、直接修正",
    "按成本、运费和佣金算真实毛利，不靠感觉定价": "実際の粗利を計算し、感覚ではなく正確に価格設定",
    "差评回复、社媒文案、客服话术、对账报告，点一下出稿": "悪いレビューへの返信、ソーシャルメディアのコンテンツ、カスタマーサービスの対応、精算レポート、ワンクリックで作成",
    "看看这 18 位员工都干什么": "18人の従業員が何をしているか見てみよう",
    "5 大渠道": "5つの主要なチャネル",
    "店建好了没人来 —— 这比建站难十倍": "サイトはできても訪問者が来ない — これはサイト構築よりも10倍難しい",
    "先诊断再开方：标题还是中文，就先修标题，不急着发内容": "まず診断してから処方：タイトルがまだ中国語なら、まずはタイトルを修正し、コンテンツの発行は急がない",
    "30 天方案拆成每天 2–3 件事，做完打勾": "30日間のプランを1日に2-3のタスクに分割し、完了したらチェックを入れる",
    "Google、Meta、TikTok、Snapchat、Microsoft 一站接入，像素有没有生效能自己验": "Google、Meta、TikTok、Snapchat、Microsoftへの一括接続、ピクセルの有効性を自分で確認可能",
    "看 30 天推广方案长什么样": "30日間のプロモーションプランがどのようなものか見てみよう",
    "零门槛": "ゼロのハードル",
    "今天就能把淘宝、1688 的货，挂到自己站上卖": "今日から淘宝や1688の商品を自分のサイトで販売できる",
    "一条链接变一个商品页，图、价、规格自动填": "1つのリンクが自動的に商品ページになり、画像、価格、仕様が自動で埋まる",
    "买家点「代购下单」跳代购平台，商品链接已经填好": "購入者が「代理購入」を選択すると、既に商品リンクが入力された代理購入プラットフォームに飛ぶ",
    "你只发国内快递，跨境支付和国际物流都不用碰": "国内配送のみを行い、クロスボーダー決済と国際物流には触れず",
    "看懂这个模式": "このビジネスモデルを理解しよう",
    "生意做大了，整条链路攥在自己手里": "ビジネスが大きくなれば、全体の流れを自分自身で管理できる",
    "售价里含代购服务费，按比例或按固定金额收": "販売価格には代理購入手数料が含まれ、比率または固定額で収集される",
    "入库称重、多个包裹合箱出库，比单件直发省": "在庫の計量、複数のパッケージを一つにまとめて出荷することで、個別発送よりもコストが節約できる",
    "燕文、4PX 自动取号出单，轨迹自动回填给买家": "燕文、4PXによる自動的な出荷番号取得とトラッキング情報の自動更新",
    "对比它和 BuyLink 的区别": "それとBuyLinkとの違いを見てみよう",
    "这四件事，建站工具一件都做不了 —— 因为它们需要": "これらの4つのことは、建站工具ではできません —— それらは実際のリソースが必要だからです",
    "货源、仓库、承运商和真实数据，": "商品、倉庫、運送業者、そしてリアルなデータが求められます。",
    "不是几段代码。": "コードだけでは足りません。",
    "AI 营销 · 获客": "AI マーケティング · カスタマーアクイジション",
    "流量不是等来的，是一步一步算出来的": "トラフィックは待つものではなく、計算して獲得するものです",
    "四步，每一步都能看到做完之后的变化。": "4ステップ、それぞれのステップで成果が見えてきます。",
    "先说真话": "まず正直に",
    "商品标题还是中文？站是日语站、描述只有 1/65？先修地基，不急着发内容。": "商品タイトルはまだ中国語？サイトは日本語だけど、説明文は1/65しかありませんか？まずは基礎を整えましょう。",
    "30 天方案": "30日プラン",
    "按你的品类、市场、库存，拆成每天 2–3 件能做完的小事。": "あなたのカテゴリー、市場、在庫に応じて、毎日2-3件のタスクに分割します。",
    "AI 出稿": "AIによるコンテンツ作成",
    "社媒短文、短视频脚本、营销邮件、活动方案，点一下就有。": "SNS投稿、ショートビデオ脚本、マーケティングメール、キャンペーンプラン、クリック一つで生成されます。",
    "第四步": "第四ステップ",
    "投放追效果": "広告配信と効果追跡",
    "五渠道接入，商品 feed 自动生成，像素没生效能自己查出来。": "5つのチャネルに接続し、商品フィードを自動生成、ピクセルが効いていない場合も自分で確認できます。",
    "你的 AI 助手可以直接读你的店": "あなたのAIアシスタントは直接店舗情報を読み取れます",
    "豆包 · ChatGPT · Claude 接上就能取商品、取方案、存稿件，不用把账号密码交给任何插件": "豆包 · ChatGPT · Claude を接続すれば、商品情報やプランを取り出し、原稿を保存することができます。アカウントやパスワードをプラグインに渡す必要はありません。",
    "看怎么接": "接続方法を見る",
    "这四步不用一次做完": "この4ステップは一度に完了する必要はありません",
    "大部分人卡在第一步：连自己店里有多少条商品描述还是中文都不知道。先把这一步做完，后面三步才有意义。": "多くの人は最初のステップで止まります：自分の店舗にある商品説明がどれだけ中国語なのかさえ知らないのです。まずはこのステップを完了させ、その後の3ステップに進みましょう。",
    "想省事就让 AI 先扫一遍，": "AIに一度チェックさせて、手間を省きましょう。",
    "它会把该改的地方列出来。": "修正が必要な箇所をリストアップします。",
    "能拿产品事实说清楚的，就不吹数字": "製品の特徴で説明できるなら、数字は使わない",
    "种店铺语言": "店舗言語を設定",
    "位 AI 员工": "AIスタッフ",
    "大投放渠道": "主要配信チャネル",
    "全部为你现在就能打开后台看到的数字，不是宣传口径。": "あなたが今バックエンドで見られる数字すべてで、宣伝のためのものではありません。",
    "准备好把这门生意做起来了吗": "ビジネスを始めましょうか",
    "零代码 · 订阅制 · 10 分钟拥有自己的品牌独立站": "コードレス · サブスクリプション制 · 10分で自分のブランドサイトを構築",
    "立即免费开通": "今すぐ無料で始める",
    "不需要信用卡 · 随时可以关掉": "クレジットカード不要・いつでも解約可能",
    "跨境物流": "クロスボーダー物流",
    "从你手里到客户手里，": "あなたの手からお客様の手へ、",
    "中间这一段我们接": "この部分は私たちが引き受けます",
    "头程揽收、报关出境、干线运输、末端派送——": "発送元での集荷、通関、主要輸送、最終配送——",
    "四条线路按货物和时效选": "4つのルートから商品と配達時間で選択",
    "。面单在后台打，轨迹在后台看，出事有人管。": "。ラベルはバックエンドで印刷し、トラッキングもバックエンドで確認できます。何か問題が発生しても対応してもらえます。",
    "免费开店，先算一单运费": "無料で店舗開設、まずは送料を計算",
    "看三条线路": "3つのルートを見る",
    "美线专线 6–9 天": "米国専用線 6–9 日",
    "220+ 国家可达": "220+ 国に到達可能",
    "全程轨迹可查": "全行程の追跡が可能です",
    "以前要加三个货代微信、问四次价格。": "以前は3つの貨物代理店のWeChatを追加し、4回価格を確認する必要がありました。",
    "现在一个后台里比价下单": "今では1つのバックエンドで価格比較と注文ができます",
    "，单号自动回到订单里。": "、トラッキング番号が自動的に注文に反映されます。",
    "美线专线参考时效（天）": "米国向け専用ラインの参考所要日数（日）",
    "可送达国家与地区": "配達可能な国と地域",
    "国内揽收仓，就近交货": "国内収集倉庫、近隣での納品",
    "主力承运商实时比价": "主要な運送業者によるリアルタイム価格比較",
    "以上为常见线路的参考区间，具体时效与价格以系统按重量、目的地、品类算出的报价为准。": "以上は一般的なルートの参考範囲であり、具体的な所要時間と価格はシステムが重量、目的地、カテゴリーに基づいて計算した見積もりによります。",
    "三条线路": "3つのルート",
    "货不一样，走法也不一样": "商品によって配送方法も異なります",
    "轻小件走小包，多件合一起走集运，卖得快的备到海外仓。三条路可以同时用。": "軽量小物は小包便、複数の商品はまとめて集荷便、売れ行きの良い商品は海外倉庫に備蓄します。3つの方法を同時に使用することも可能です。",
    "直发小包": "直送小包",
    "一单一发，不用备货。适合刚起步、单量不大、品类还摸不准的时候。": "1つずつ発送、在庫不要。始めるばかりで、注文量が少なく、どの商品が売れるかまだわからない場合に適しています。",
    "按克计费，200g 起": "グラム単位で料金計算、200gから",
    "美国 6–9 天 / 欧洲 7–12 天": "アメリカ 6–9 日 / ヨーロッパ 7–12 日",
    "带全程跟踪号": "全行程の追跡番号付き",
    "适合：单价 $10–60 的轻小件": "適している商品：単価 $10–60 の軽量小物",
    "集运合箱": "集荷合箱",
    "同一个客户买了几件，先到国内仓，去掉外包装合成一箱再发。运费按一箱算，不是按四箱算。": "同じ顧客が複数の商品を購入した場合、国内倉庫に到着後、外装を取り除き1つの箱にまとめて発送します。送料は1箱分で計算されます。",
    "多件合并，省首重": "複数の商品をまとめて送ることで、初期重量料金を節約できます",
    "免费仓储 30 天": "30日間無料保管",
    "可代贴标、代加固": "ラベル貼りや補強代行も可能です",
    "适合：多件订单、批发小单": "適しています：複数商品注文、小ロットの卸売",
    "海外仓备货": "海外倉庫での在庫準備",
    "卖得动的款提前备到当地仓，客户下单当天就发。退换也能就地处理。": "売れ筋商品は事前に現地値段に備えておくことで、注文当日に発送可能。返品・交換も現地で処理できます。",
    "本地派送 2–4 天": "2–4日での地域内配送",
    "支持本地退换地址": "現地での返品・交換アドレスサポート",
    "库存和店铺同步": "在庫と店舗情報を同期",
    "适合：月销 100 单以上的爆款": "適しています：月100件以上のヒット商品",
    "一件包裹要过五道手": "1つのパッケージが5つの工程を経ます",
    "哪一段由谁负责，写清楚了，出问题才知道找谁。": "どの段階で誰が責任を持つか明確にしておくことで、問題が起きたときに誰に連絡すべきかわかります。",
    "你打包": "あなたが梱包",
    "后台打面单": "バックエンドで送り状を作成",
    "贴好交给快递": "ラベルを貼って宅配業者に引き渡す",
    "收货、验货": "受け取りと検品",
    "合箱、称重": "箱詰めと計量",
    "报关出境": "通関手続き",
    "资料代填": "資料代行記入",
    "清单预申报": "事前申告",
    "干线": "幹線",
    "空运为主": "主に空輸",
    "按线路排舱": "路線に基づく船積み",
    "末端派送": "末端配送",
    "当地邮政或快递": "現地の郵便または宅配便",
    "签收信息回传": "受領情報のフィードバック",
    "报价参考": "見積もり参考",
    "什么货、走哪条、多少钱": "何を、どのルートで、いくらで送るか",
    "下表按 200g 包裹估算，方便你先算一笔账。": "以下の表は200gのパッケージを基準に見積もりを計算するのに便利です。",
    "线路": "ルート",
    "参考时效": "参考納期",
    "200g 参考运费": "200gの参考送料",
    "可跟踪": "追跡可能",
    "美国": "アメリカ",
    "经济小包": "エコノミー小包",
    "8–12 个工作日": "8–12営業日",
    "¥26 起": "¥26 から",
    "全程": "全行程",
    "标准专线": "標準便",
    "6–9 个工作日": "6–9 営業日",
    "¥34 起": "¥34 から",
    "英国 / 德国": "英国 / ドイツ",
    "欧洲专线": "ヨーロッパ便",
    "7–12 个工作日": "7–12 営業日",
    "¥31 起": "¥31 から",
    "日本 / 韩国": "日本 / 韓国",
    "东亚专线": "東アジア便",
    "3–5 个工作日": "3–5 営業日",
    "¥22 起": "¥22 から",
    "澳大利亚": "オーストラリア",
    "澳洲专线": "オーストラリア便",
    "7–10 个工作日": "7–10 営業日",
    "¥30 起": "¥30 から",
    "中东 / 南美": "中東 / 南米",
    "偏远专线": "遠隔地便",
    "12–20 个工作日": "12–20 営業日",
    "¥45 起": "¥45 から",
    "仅关键节点": "重要なノードのみ",
    "表内为示意价格，不含燃油与偏远附加费。实际下单时系统按重量、体积重、品类实时报价。": "表内は示唆価格であり、燃料費と遠隔地追加料金は含まれていません。実際の注文時にシステムは重量、体積重、カテゴリーに基づいてリアルタイムで見積もりを提供します。",
    "轨迹": "トラッキング",
    "客户问「我的包裹到哪了」，你不用去翻聊天记录": "お客様が「私の荷物はどこにありますか」と質問した場合、チャット履歴を調べる必要はありません",
    "每单都有时间轴，从揽收到签收一条线拉下来。客户在你店里就能自己查，不用来问你。真出问题，系统会比客户先告诉你。": "各注文にはタイムラインがあり、取り扱いから受け取りまで一連の流れで表示されます。お客様は店舗内で自分で確認でき、あなたに聞く必要はありません。問題が発生した場合、システムがあなたよりも先にお知らせします。",
    "轨迹节点自动回传，中英文对照": "トラッキングポイントは自動的に送信され、日本語と英語で対照されます",
    "超时未更新、清关滞留、派送失败会自动标红": "更新が遅延したり、通関が滞留したり、配達に失敗した場合は自動的に赤色で表示されます",
    "异常件单独一列，处理完再归位": "異常なアイテムは別列に表示され、処理が完了したら元に戻されます",
    "Berlin, DE · 由收件人本人签收": "Berlin, DE · 受取人本人による受領",
    "派送中": "配達中",
    "Out for delivery · DHL 本地派送": "配達中 · DHL 本地配送",
    "清关完成": "通関完了",
    "法兰克福口岸放行": "フランクフルト港での放行",
    "干线运输中": "幹線輸送中",
    "深圳 → 法兰克福，航班已起飞": "深圳 → フランクフルト、フライト出発済み",
    "已入库合箱": "入庫・合箱済み",
    "深圳仓 · 2 件合并，减重 0.3kg": "深圳倉庫 · 2点を合併し、0.3kg軽量化",
    "出问题怎么办": "問題が起きたらどうすればいいですか",
    "丢件、破损、退回来，都有说法": "紛失、破損、返品についても対応があります",
    "跨境最怕的不是出事，是出了事没人认。": "クロスボーダーで最も怖いのは、問題が起こることではなく、問題が起こって誰も責任を取らないことです",
    "丢件赔付": "紛失時の補償",
    "承运商确认丢失后按申报价值赔付，上限写在报价单里，不用来回扯。": "運送会社が紛失を確認した場合、申告価値に基づいて補償します。上限は見積もりに記載されていますので、何度もやり取りする必要はありません。",
    "退换地址": "返品・交換先住所",
    "美国、德国、英国有本地退货地址，客户寄回不用付国际邮费。": "アメリカ、ドイツ、イギリスには現地の返品アドレスがあり、お客様は国際送料を支払う必要はありません。",
    "专人跟进": "専任スタッフが対応",
    "单票超过 15 天没更新，平台会主动开一张工单跟进，不用你催。": "15日以上更新がない場合、プラットフォームが自動的にチケットを作成して対応しますので、お客様から催促する必要はありません。",
    "时效表里的数字是常态，不是承诺": "タイムテーブルの数字は通常の目安であり、約束ではありません",
    "真卡住了，": "本当に詰まっています、",
    "先看轨迹再问人": "軌跡を見てから質問する",
    "。九成问题看单号就能定位：清关延误、地址不详、派送失败，轨迹上写得比客服说的清楚。": "。9割の問題は追跡番号で特定できます：通関遅延、住所不明、配達失敗、トラッキング情報の方がカスタマーサービスより明確です。",
    "先算一单，再决定走哪条线": "まずは見積もりをしてから、どの配送方法を選ぶか決めましょう",
    "开店后输入重量和目的地，三条线路的价格和时效会一起列出来。": "店舗開設後、重量と目的地を入力すると、3つの配送ルートの価格と納期が一覧で表示されます。",
    "免费开店试算": "無料でお店を開く試算",
    "看收款怎么走": "入金方法を見る",
    "客户怎么付得方便，": "お客様が便利に支払えるように、",
    "你就怎么收": "そのまま受け取ってください",
    "欧美人习惯刷卡、德国人爱用 PayPal、东南亚用本地钱包、中东还在转账——": "欧米人はカード払いを、ドイツ人はPayPalを、東南アジアでは地元のウォレットを使用し、中東ではまだ銀行振込が主流——",
    "多种收单方式接上就能用": "さまざまな決済方法をすぐに利用できます",
    "，后台统一看账。": "、バックエンドで一括して確認。",
    "免费开店，绑定收款": "無料で店舗開設、決済アカウントを連携",
    "看费率": "料金を見る",
    "不用自己申请商户号": "自分で加盟店番号を申請する必要なし",
    "T+7 自动结算": "T+7 自動決済",
    "最常被问的是「钱什么时候到我账上」。": "最もよく聞かれるのは「いつお金が口座に入るか」です。",
    "答案写在结算规则里": "答えは決済ルールに書いてあります",
    "，不用发邮件问。": "、メールで質問する必要はありません。",
    "种收单方式可选": "収納方法を選べます",
    "妥投后 7 天可提现": "妥結後 7 日で出金可能",
    "支持提现的币种": "出金可能な通貨",
    "T+7 是留出的退款与拒付窗口。已妥投且过了窗口的订单，余额可随时提现。": "T+7 は返金と拒否のための期間です。妥結済みで期間を過ぎた注文は、残高をいつでも出金できます。",
    "收单": "収納",
    "客户看到的付款方式，越多越容易成交": "顧客が見る支払い方法、多いほど成約率が高い",
    "结账页上少一个支付选项，就可能少一单。常用的这几种，默认都开着。": "チェックアウトページで支払いオプションが1つ減ると、1つの売上が失われる可能性があります。一般的なものは、デフォルトで有効になっています。",
    "欧美客户最认的一种，有买家保护，争议处理流程成熟。": "欧米の顧客が最も信頼しているもので、バイヤープロテクションがあり、紛争処理プロセスが成熟しています。",
    "覆盖 200+ 国家": "200以上の国をカバー",
    "支持信用卡无账号付款": "クレジットカード無アカウントでの支払いをサポート",
    "信用卡 / 借记卡": "クレジットカード / デビットカード",
    "通过 Stripe 收 Visa、Mastercard、Amex，3D 验证默认开启。": "Stripe を通じて Visa、Mastercard、Amex の受け入れ、3D 認証はデフォルトでオン。",
    "支持自动扣款与订阅": "自動引き落としとサブスクリプションをサポート",
    "拒付率低于纯 PayPal 通道": "純粋な PayPal チャネルよりも拒否率が低い",
    "本地钱包": "ローカルウォレット",
    "德国的 Klarna、荷兰的 iDEAL、巴西的 Pix，按市场自动出现。": "ドイツのKlarna、オランダのiDEAL、ブラジルのPixは、市場に応じて自動的に表示されます。",
    "按客户所在地展示": "顧客の所在地に基づいて表示",
    "不用单独签约": "個別の契約不要",
    "收款账户是你自己的": "収入口座はあなたのものです",
    "。平台不代收货款，钱从客户直接进你的 PayPal / Stripe 账户，我们不碰这笔钱。": "。プラットフォームは代金を預かりません。お金は直接顧客からあなたのPayPal / Stripeアカウントに入ります。私たちはこのお金を扱いません。",
    "资金流向": "資金の流れ",
    "一笔钱从客户到你的账上，走四步": "顧客からあなたの口座へのお金の移動は4つのステップで行われます",
    "客户付款": "顧客が支払い",
    "结账页选方式": "チェックアウトページで方法を選択",
    "按当地币种支付": "現地通貨で支払う",
    "进入你的账户": "あなたのアカウントに入る",
    "订单妥投": "注文が完了",
    "轨迹显示签收": "トラッキング情報で受け取り確認",
    "开始算 T+7": "T+7の計算開始",
    "提现到账": "出金完了",
    "提人民币或外币": "人民元または外貨を引き出す",
    "1–3 个工作日": "1-3営業日",
    "费率": "手数料率",
    "每一笔扣多少，写在明面上": "各取引に対する手数料は明示されています",
    "通道费由收单机构收，平台不在这上面加价。": "チャネル手数料は収納機関が徴収し、プラットフォームはこれに上乗せしません。",
    "收单方式": "決済方法",
    "参考费率": "参考レート",
    "到账时间": "入金時間",
    "提现费": "出金手数料",
    "争议处理": "紛争処理",
    "约 4.4% + $0.30": "約 4.4% + $0.30",
    "即时到 PayPal 余额": "即時 PayPal残高反映",
    "按提现通道": "出金チャネルによる",
    "买家保护，180 天": "バイヤープロテクション、180日間",
    "信用卡（Stripe）": "クレジットカード（Stripe）",
    "约 2.9% + $0.30": "約 2.9% + $0.30",
    "T+2 到 Stripe 余额": "T+2でStripe残高反映",
    "拒付 15–30 天内申诉": "15-30日以内の拒否支払い異議申し立て",
    "支付宝 / Alipay+": "Alipay / Alipay+",
    "约 1.2%": "約 1.2%",
    "免": "無料",
    "平台介入": "プラットフォーム介入",
    "约 1.5%–2.5%": "約 1.5%–2.5%",
    "按当地规则": "地域規則による",
    "Taoify 平台服务费": "Taoify プラットフォームサービス料",
    "费率为行业常见区间，实际以你与收单机构签约时的条款为准；不同国家、不同卡种会有差异。": "料率は業界標準の範囲内ですが、実際の料率は収納機関との契約内容によります。国やカード種類によっても異なります。",
    "风控": "リスク管理",
    "最怕的不是没单，是收了钱又被退回去": "最も怖いのは注文がないことではなく、受け取ったお金が戻されることです",
    "高风险订单在付款时就会被拦下来——地址和卡不一致、短时间多笔、代理 IP。与其事后申诉，不如事前不接。": "高リスクの注文は支払い時にブロックされます——住所とカードの不一致、短時間での複数回注文、プロキシIP。事後に対処するよりも、最初から受け付けない方が良いです",
    "高风险订单自动标记，可选择暂缓发货": "高リスクの注文には自動的にマークが付きます。発送を一時的に保留することも可能です",
    "每笔拒付的申诉材料模板，照着填就行": "各拒否請求に対する申立書のテンプレートがありますので、それに従って記入してください",
    "拒付率接近警戒线时提前提醒，避免被封号": "拒否率が警告ラインに近づいたときに事前に通知し、アカウント停止を防ぎます",
    "金额": "金額",
    "风险": "リスク",
    "建议": "提案",
    "正常发货": "通常通り発送",
    "核对地址": "住所確認",
    "暂缓 · 卡地不符": "保留 · カードと住所が一致しない",
    "高风险订单不会自动取消，": "高リスクの注文は自動的にキャンセルされません",
    "决定权还在你": "決定権はあなたにあります",
    "，系统只负责提醒。": "システムは通知のみを行います",
    "提现": "出金",
    "赚的钱，随时能拿出来": "いつでも出金可能",
    "提到银行卡": "銀行口座に送金",
    "人民币直接进国内储蓄卡，1–3 个工作日到账，单笔最低 100 元。": "人民元は直接国内の預金口座に入金され、1-3営業日で到着します。最低100元から。",
    "留在外币账户": "外貨口座に残す",
    "美元、欧元、英镑可以留着付广告费、付供应商，不用来回换汇。": "ドル、ユーロ、ポンドをそのまま広告費やサプライヤーへの支払いに使うことができます。為替手数料がかかりません。",
    "对账单": "取引明細",
    "每笔收入、退款、拒付都有流水，按月导出，报税和记账直接用。": "収入、返金、拒否された取引のすべてが記録され、月ごとにエクスポートできます。税務申告や会計に直接使用可能です。",
    "费率这块最容易看漏一句": "見落としがちな一文があります",
    "。钱从客户那里直接进你的账户，平台不代收，也就不存在压款、跑路、限额提不出来这些事。": "。お客様からのお金は直接あなたのアカウントに入金されるため、プラットフォームが代わりに受け取ることはありません。そのため、資金の引き出し制限や逃亡などの心配もありません。",
    "先把收款接上，再谈卖什么": "まずは決済手段を設定しましょう",
    "开店后绑定 PayPal 或 Stripe，当天就能收第一笔钱。": "店舗を開設後、PayPal または Stripe を紐付けすれば、その日のうちに最初の収入を得ることができます。",
    "价格": "価格",
    "订阅按店铺收费": "店舗単位での課金",
    "佣金按成交额往下走": "売上高に応じたコミッション",
    "套餐是固定的工具费，佣金只在你出单时收。": "パッケージ料金は固定のツール費用で、コミッションは注文が出たときにのみ発生します。",
    "卖得越多，费率越低": "売上が多いほどレートが下がります",
    "成交额越大费率越低，自动算，不用谈。": "取引額が大きいほど手数料率が低く、自動計算で交渉不要です。",
    "免费试用": "無料お試し",
    "逐项对比": "項目別比較",
    "试用不绑卡": "カード登録なしでお試し",
    "月 / 季 / 年随时换": "月/季/年いつでも変更可",
    "佣金封顶": "コミッション上限あり",
    "先领 {days} 天试用，跑通一单再选档。": "まずは{days}日間のトライアルを受けてから、1件成功させた後でプランを選んでください。",
    "佣金只有成交才收": "コミッションは成約時のみ",
    "，没出单一分不收。": "注文がなければ料金は発生しません。",
    "订阅套餐": "サブスクリプションプラン",
    "四档，按你开到第几家店来选": "4つのプラン、開設した店舗数に応じて選択",
    "价格以美元计，月付 / 季付 / 年付三档同权，只是单价不同。": "価格はドルで表示され、月払い/クォーターペイ/年払いの3つのオプションは権利が同じで、単価だけが異なります。",
    "多数人选这个": "多くの人がこれを選んでいます",
    "每店限领一次，不绑卡": "各店舗1回限り、カード登録不要",
    "季付": "四半期払い",
    "年付": "年払い",
    "领试用": "お試しを開始",
    "选这个": "こちらを選択",
    "价格取自平台计费中心，调整后本页同步。季付按 3 个月、年付按 12 个月计价，中途换档按剩余天数折算。": "価格はプラットフォームの課金センターから取得し、調整後このページで同期されます。クォーターペイメントは3ヶ月、年間払いは12ヶ月で計算され、途中でのプラン変更は残りの日数に応じて折算されます。",
    "交易佣金": "取引手数料",
    "成交额越大，抽成越低": "売上額が大きいほど、手数料率は低くなります",
    "按店铺自然月成交额（折算美元）命中档位，整月按该档比例计提。没成交就没有佣金。": "店舗の自然月の売上額（ドル換算）に基づいて段階が決定され、その月全体で該当する比率が適用されます。売上がなければ手数料はありません。",
    "只对已完成且未退款的订单计提，退款自动冲回。": "完了し返金されていない注文のみ対象となり、返金は自動的に差し引きされます。",
    "佣金与套餐档位无关，选哪档都是同一套阶梯。": "手数料はパッケージプランに関係なく、どのプランを選んでも同じ段階制です。",
    "账单每月 1 号出，后台可下载明细，逐单可查。": "請求書は毎月1日に発行され、バックエンドから明細をダウンロードでき、各注文を個別に確認できます。",
    "差在哪，一条条看": "違いを一つずつ見てみましょう",
    "额度": "クォータ",
    "月付价格": "月払い価格",
    "免费": "無料",
    "季付价格": "クォーターペイ価格",
    "年付价格": "年間価格",
    "可开店数": "開設可能店舗数",
    "可上架商品": "出品可能商品数",
    "文本翻译": "テキスト翻訳",
    "次": "回",
    "图片翻译": "画像翻訳",
    "AI 模板": "AI テンプレート",
    "套": "セット",
    "阶梯，与档位无关": "段階的で、レベルとは関係ありません",
    "额度按月计，用完可等次月重置，或升档补足；未用完不结转到下月。": "利用限度額は月単位で計算され、使い切った場合は翌月にリセットされるか、プランをアップグレードして補充できます。未使用分は翌月には持ち越されません。",
    "付钱之前，先把这些问清楚": "支払い前に、これらの点を確認しよう",
    "佣金到底怎么算？": "コミッションはどのように計算されますか？",
    "按店铺当月成交额（折算美元）落在哪一档，整月就按那一档的比例计提，档位和费率见上面的阶梯表。退款订单会把对应佣金冲回，不多收。": "その月の店舗の売上高（ドル換算）に基づいて、該当する段階のレートが適用されます。段階とレートは上の表をご覧ください。返品注文の場合、対応するコミッションが戻され、過剰な料金はかかりません。",
    "佣金是按订单金额还是按利润收？": "コミッションは注文金額に基づいて計算されるのか、それとも利益に基づいて計算されるのか？",
    "按订单实际成交金额（不含运费和税），不是按你的利润。所以亏钱卖的单也会产生佣金——定价时把这一项算进成本，后台的毛利计算器已经默认扣掉了。": "コミッションは実際の注文金額（送料と税抜き）に基づいて計算されます。そのため、損失が出る注文でもコミッションが発生します——価格設定時にこの項目をコストに含め、バックエンドの粗利計算機では既にこれを考慮しています。",
    "试用结束后会怎样？": "お試し期間終了後はどうなりますか？",
    "试用期不绑卡、不自动扣费。到期后店铺进入只读状态：商品和订单都还在，但不能接新单，选一档套餐付费后立即恢复。每个店铺只能领一次试用。": "試用期間中はカードの登録や自動課金はありません。期間終了後、ショップは読み取り専用状態になります：商品と注文はそのまま残りますが、新規注文を受け付けられません。プランを選んで支払うことですぐに復活します。各ショップは一度だけ試用できます。",
    "可以随时换档或退款吗？": "プランの変更や返金は可能ですか？",
    "可以。升档立即生效，按剩余天数折算差价；降档在下个账期生效，不会立刻断掉额度。月付随时取消，年付 7 天内未使用可全额退。": "可能です。アップグレードは即時有効になり、残りの日数に応じて差額が調整されます；ダウングレードは次の請求期から有効になり、直ちに制限がかかりません。月払いはいつでもキャンセルでき、年払いは7日以内に未使用の場合全額返金されます。",
    "换套餐，店铺数据会丢吗？": "プランを変更すると、ショップのデータは失われますか？",
    "不会。商品、订单、客户、模板都会保留。降档后超出新额度的部分变成只读，不会删除；再升回来立刻恢复。": "いいえ。商品、注文、顧客、テンプレートはすべて保持されます。ダウングレード後も新しい制限を超える部分は読み取り専用になりますが、削除されることはありません；再びアップグレードするとすぐに復活します。",
    "多开店铺怎么算？": "複数のショップを開設する場合どうなりますか？",
    "按套餐给的开店数算，档位越高能开的店越多。每家店独立域名、独立语言、独立客户数据，佣金也按店分别计算档位。": "パッケージによって提供される店舗数が決まります。段階が高いほど開設できる店舗数が増えます。各店舗は独立したドメイン、言語、顧客データを持ち、コミッションもそれぞれの店舗ごとに段階別に計算されます。",
    "先别挑最贵的": "まずは最も高価なものを選ぶ必要はありません",
    "大部分人是": "多くの人は",
    "先领 {days} 天试用，再选单店版跑一个月": "まずは{days}日間のトライアルを受けてから、単一店舗版で1ヶ月試してみてください",
    "，等单量稳定了才升档。升档按天折算，不用重新付一整月。": "、注文量が安定したら段階を上げることができます。段階の変更は日割り計算で、新たに1ヶ月分の料金を支払う必要はありません。",
    "先试 {days} 天，跑通一单再说": "まずは{days}日間試してから、1件成功させてから考えてみましょう",
    "不绑卡、不自动续费。试用到期店铺只读，数据不会丢。": "カードの登録や自動更新はありません。試用期間終了後、ショップは読み取り専用になりますが、データは失われません。",
    "领 {days} 天试用": "{days}日間のトライアルを受けてください",
    "还有问题": "他に質問がありますか",
    "月成交额 ＜": "月間取引額 ＜",
    "给想把中国货卖到全世界的人，一个能真正跑通生意的地方。": "世界中に中国の商品を売る人々に、ビジネスが実際に成功する場所を提供します。",
    "在线客服": "オンラインカスタマーサポート",
    "产品": "製品",
    "全部功能": "すべての機能",
    "模板市场": "テンプレートマーケット",
    "卖家": "販売者",
    "我在中国 · 把货卖出去": "中国から · 商品を売る",
    "我在海外 · 卖中国好货": "海外から · 中国の良質な商品を売る",
    "资源": "リソース",
    "开店教程": "店舗開設チュートリアル",
    "服务状态": "サービスステータス",
    "联系我们": "お問い合わせ",
    "公司": "会社",
    "关于 Taoify": "Taoifyについて",
    "加入我们": "私たちに参加する",
    "隐私政策": "プライバシーポリシー",
    "服务条款": "サービス条項",
    "退款政策": "返金ポリシー",
    "保留所有权利。": "全著作権所有。",
    "等 20 种语言": "20言語以上",
    "主导航": "メインナビゲーション",
    "语言": "言語",
    "20 种语言 · 买家看自己的母语": "20 言語 · バイヤーは自分の母語で閲覧",
    "登录": "ログイン",
    "模板中心": "テンプレートセンター",
    "用户": "ユーザー",
    "小店管理": "小さな店舗の管理",
    "退出登录": "ログアウト",
    "菜单": "メニュー",
    "欢迎回来": "おかえりなさい",
    "登录您的账户，继续您的建站之旅": "アカウントにログインして、ウェブサイト作成の旅を続けましょう",
    "电子邮件": "メールアドレス",
    "示例@mail.com": "例：mail@example.com",
    "登录密码": "ログインパスワード",
    "还没有账号": "まだアカウントを持っていませんか？",
    "注册": "登録",
    "专业主题网站模板": "プロフェッショナルなテーマのウェブサイトテンプレート",
    "我忘记登录密码了，怎么重置": "ログインパスワードを忘れてしまった、どうリセットすればいいですか？",
    "请输入电子邮件": "メールアドレスを入力してください",
    "请输入登陆密码": "ログインパスワードを入力してください",
    "选择店铺类型": "店舗タイプを選択",
    "开通即拥有 AI 运营团队，7×24 小时自动管理你的跨境商店": "AI運営チームが7×24時間自動であなたのクロスボーダー店舗を管理します",
    "在线商店": "オンラインストア",
    "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业": "ただウェブサイトを作るだけでなく、完全自動化でメンテナンス不要、無限に拡張・アップグレード可能なビジネスを構築します",
    "AI 员工代运营": "AIスタッフによる代行運営",
    "开通店铺即配备 AI 运营团队，自动上架商品、回复客户、处理订单，无需招人管理": "店舗を開設すると、AI運営チームが商品の掲載、顧客への返信、注文処理などを自動的に行い、人件費がかかりません",
    "AI 跨境获客": "AI クロスボーダー顧客獲得",
    "AI 自动生成多语言商品文案与营销素材，智能投放引流，帮你获取全球客户": "AI が自動的に多言語の商品説明とマーケティング素材を生成し、スマートな配信でグローバルな顧客を獲得します",
    "AI 智能客服": "AI スマートカスタマーサポート",
    "AI 客服 7×24 小时多语言应答，自动处理售前售后，转化率显著提升": "AI カスタマーサポートは7×24時間、多言語で対応し、自動的に販売前後の処理を行い、変換率を大幅に向上させます",
    "离开": "離れる",
    "下一步": "次へ",
    "店铺模板": "店舗テンプレート",
    "上百种精选电商主题模板一键应用，卡片式操作，无需设计能力，快速拥有一个能提现您品牌调性、安全、稳定的在线商店": "厳選された数百種類のECテーマテンプレートをワンクリックで適用。カード式操作で、デザインスキルがなくても、ブランドの調性を反映した安全で安定したオンラインストアを迅速に作成できます",
    "请选择您想要的模板~": "お好みのテンプレートを選んでください~",
    "全部": "すべて",
    "搜索模板名称": "テンプレート名を検索",
    "最低价": "最低価格",
    "最高价": "最高価格",
    "筛选": "フィルター",
    "重置": "リセット",
    "个模板": "個のテンプレート",
    "选择模板": "テンプレートを選択",
    "取消选择": "選択解除",
    "需付费使用": "有料使用",
    "可在模板市场购买": "テンプレートマーケットで購入可能",
    "预览": "プレビュー",
    "后退": "戻る",
    "完善店铺信息": "ショップ情報の補完",
    "填写店铺名称与域名，完成注册即可开店": "ショップ名とドメインを入力し、登録を完了すればすぐに店舗を開設できます",
    "店铺信息": "ショップ情報",
    "店铺名称": "ショップ名",
    "创建一个简单好记的店铺名称": "覚えやすいシンプルなショップ名を作成しましょう",
    "填写您的店铺名称": "ショップ名を入力してください",
    "店铺域名": "ショップドメイン",
    "设置简洁前缀，方便用户检索商店": "検索しやすい簡潔な接頭辞を設定しましょう",
    "字母或数字": "英数字",
    "个人信息": "個人情報",
    "填写您的电子邮箱": "メールアドレスを入力してください",
    "店铺密码": "ショップパスワード",
    "填写您的店铺密码": "ショップパスワードを入力してください",
    "邮箱验证码": "メール認証コード",
    "请输入邮箱验证码": "メール認証コードを入力してください",
    "电话号码": "電話番号",
    "区号": "市外局番",
    "搜索国家": "国を検索",
    "填写您的电话号码": "電話番号を入力してください",
    "我已阅读并同意以下法律文件：": "以下の法的文書を読み、同意しました：",
    "消费协议": "消費契約",
    "用户使用协议": "ユーザー使用契約",
    "请先阅读并勾选同意上述法律文件，才能开通店铺": "まずは上記の法的文書を読んで同意を選択し、店舗を開設してください",
    "创建": "作成",
    "开通": "開設",
    "法律文件": "法的文書",
    "我已阅读并同意": "私は読み、同意しました",
    "商城站": "ショッピングサイト",
    "代购站": "代理購入サイト",
    "创建一个电子商务网站，帮您在线采购中国商品，系统化订单管理，促进销售并管理您的日常工作。": "中国製品をオンラインで調達し、注文管理をシステム化し、販売を促進し、日常業務を管理するための電子商取引サイトを作成します。",
    "请填写有效的域名": "有効なドメインを入力してください",
    "请填写正确的邮箱": "正しいメールアドレスを入力してください",
    "请填写有效的电话号码": "有効な電話番号を入力してください",
    "点击发送验证码": "クリックして確認コードを送信",
    "不支持大写字母，请使用小写字母": "大文字はサポートされません。小文字を使用してください",
    "商店地址要求：4-50个字符，由小写字母、数字和连接符（-）组成，不能以数字或连接符开头或结尾，且不能包含大写字母或空格。": "店舗アドレスの要件：4-50文字、小文字、数字、ハイフン（-）で構成され、数字またはハイフンで始まり終われず、大文字やスペースは含まれてはなりません。",
    "电话号码需为7-15位数字": "電話番号は7-15桁の数字である必要があります",
    "电话号码格式正确": "電話番号の形式が正しくありません",
    "请填写店铺名称": "店舗名を入力してください",
    "请填写有效的电子邮箱": "有効なメールアドレスを入力してください",
    "请填写店铺密码": "店舗パスワードを入力してください",
    "请填写邮箱验证码": "メール認証コードを入力してください",
    "请选择区号": "市外局番を選択してください",
    "请填写有效的店铺域名": "有効な店舗ドメインを入力してください",
    "请选择店铺模板": "店舗テンプレートを選択してください",
    "关于我们": "私たちについて",
    "让想把中国货卖出去的人，都能自己开一家跨境店": "中国の商品を海外で販売したい人向けに、誰でも簡単にクロスボーダー店舗を開設できます",
    "Taoify 是一套跨境电商 SaaS：开店、装修、商品、订单、物流、收款、AI 客服，都在一个后台里管完。": "TaoifyはクロスボーダーECのSaaSです：開店、デザイン、商品管理、注文処理、物流、決済、AIカスタマーサポートまで、すべて1つのバックオフィスで管理できます。",
    "阶梯佣金，按成交额自动降": "段階的なコミッション制度で、売上額に応じて自動的に料金が下がります",
    "AI 客服在线接待": "AIカスタマーサポートによるオンライン対応",
    "个后台管完全流程": "1つのバックオフィスで全工程を管理",
    "我们是谁": "私たちについて",
    "一支做跨境电商系统出身的团队": "クロスボーダーECシステム開発に特化したチーム",
    "不是通用建站工具改出来的，是从代购、集运、清关这些真实环节里长出来的系统。": "汎用的なウェブサイトビルダーではなく、実際の代行購入、集荷、通関などのプロセスから生まれたシステムです。",
    "香港星橋國際貿易有限公司": "香港星橋インターナショナルトレーディング株式会社",
    "跨境行业全链路解决方案软件服务商": "クロスボーダー業界の全チェーンソリューションソフトウェアサービスプロバイダー",
    "公司以互联网信息技术开发与物联网 IOT 服务为核心，为跨境卖家提供从建站到履约的整套工具。": "インターネット技術とIoTサービスを中心に、クロスボーダー販売者向けにウェブサイト構築から履行までのツールを提供しています。",
    "依托自身服务体系与技术团队，我们把店铺系统、商品翻译、跨境物流、收款结算和 AI 客服做成了一条能跑通的链路——卖家不需要自己拼七八个系统。": "独自のサービス体系と技術チームを活用し、店舗システム、商品翻訳、クロスボーダー物流、決済処理、AIカスタマーサポートを一連の流れとして統合——販売者が複数のシステムを組み合わせる必要はありません。",
    "产品团队长期和一线卖家、物流商、支付机构一起打磨，形成 Taoify 对跨境场景的理解：能落地的功能，比看起来花哨的功能更重要。": "製品チームは長年にわたり、第一線の販売者、物流業者、決済機関と共に磨き上げ、Taoifyはクロスボーダーシーンにおける実践的な機能の重要性を理解しています。",
    "店铺与装修": "店舗とデザイン",
    "模板市场 + 可视化装修，装修不用等开发": "テンプレートマーケット + 可視化デザインツール、開発待ちなし",
    "商品、政策页、店铺界面一起翻，买家看母语": "商品情報、ポリシーページ、店舗インターフェースを一緒に翻訳し、買い手は母国語で閲覧可能",
    "面单、轨迹、异常件在一个后台处理": "配送ラベル、追跡情報、異常な配送状況を1つのバックオフィスで管理",
    "AI 员工与客服": "AIスタッフとカスタマーサポート",
    "按你的规则答客户，规则外自动转人工": "あなたのルールに基づいて顧客への回答を行い、ルール外の質問は自動的に人間に転送",
    "想聊合作、聊方案，直接找人": "パートナーシップやソリューションについて直接相談できます",
    "售前问题可以先问 AI 客服，它答不上会转给同事。": "事前問い合わせはまずAIカスタマーサポートに、答えられない場合は同僚に転送されます",
    "售前咨询": "事前コンサルティング",
    "工作日 9:00–21:00 有人接，急事直接打电话。": "平日 9:00-21:00 は対応しています。緊急の場合は直接電話してください。",
    "合作与入驻": "パートナーシップと出店",
    "渠道合作、代理、企业采购，发邮件说明来意即可。": "チャネルパートナーシップ、代理店、企業購買について、メールでご連絡ください。",
    "开店、选品、物流、结算的问题，随时问。": "出店、商品選定、物流、決済に関する質問はいつでもお気軽にお問い合わせください。",
    "做跨境这件事，我们一直在找懂业务、也愿意把细节做扎实的人。简历发到合作邮箱，标题写清岗位方向。": "クロスボーダー事業において、業務を理解し、細部までこだわる人材を探しています。履歴書をパートナーシップメールアドレスに送信し、件名に求めるポジションを明記してください。",
    "扫码添加客服": "QRコードをスキャンしてカスタマーサポートを追加",
    "扫码联系我们": "QRコードをスキャンしてご連絡ください",
    "先开一间店，比自己拼系统快": "まずは一店舗開設し、システム構築よりも早く始めましょう",
    "免费试用，不绑卡。跑通一单再决定用哪一档。": "無料でお試しいただけます。カード情報の登録は不要です。一回の取引を完了させてからプランを選んでください。",
    "Taoify用户注册协议": "Taoify利用規約",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户注册协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "注意：Taoifyプラットフォームのサービスを利用するには、《Taoify利用規約》を全文読んで厳守してください。特に免責事項、責任制限、違反処置などの内容に注目し、自分の権利、義務、使用規則及び違反責任を明確にしてください。プラットフォーム上で後続で導入されるすべての新機能や新ツールもこの利用規約によって拘束されます。",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoifyは定期的にまたは不定期的に本利用規約の内容を更新、修正する権利を持ち、Taoifyウェブサイト上で更新および修正を発表することができます。最新版は一括してショッピングモールページで公示されますので、定期的に条項の更新内容をご確認ください。条項の改訂内容に同意いただけない場合は、直ちにプラットフォームのすべてのサービスの使用を停止してください。",
    "本协议为《Taoify 服务条款》补充文件，全套文件还包括《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；针对主协议未予以明确的事项，适用本协议约定。": "本アグリーメントは《Taoify サービス条項》の補足文書であり、《Taoify ユーザープライバシーポリシー》なども含みます。主契約は《Taoify サービス条項》です。本アグリーメントと《Taoify サービス条項》が矛盾する場合、《Taoify サービス条項》が優先されます。主契約で明確に定められていない事項については、本アグリーメントが適用されます。",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "本アグリーメントで明確に定められていないすべての権利、義務、ルールは、《Taoify サービス条項》《Taoify ユーザー使用協定》《Taoify 消費協定》などに基づきます。",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括本协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》《Taoify 消费协议》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "アカウント登録を完了することで、Taoify プラットフォームのすべての協定、条項（本協定、《Taoify ユーザー使用協定》《Taoify サービス条項》《Taoify ユーザープライバシーポリシー》《Taoify 消費協定》など）を十分に理解し、自発的に受け入れたことを示します。Taoify プラットフォームのすべての協定、条項に同意しない場合は、すぐに登録を停止してください。",
    "定义": "定義",
    "1、本协议通用术语定义均与《Taoify 服务条款》保持一致，不再重复释义，仅针对一件代发、店铺代运营、商品存储作出专项释义。": "1、本協定における一般的な用語の定義は《Taoify サービス条項》と一致しており、再定義はしません。一件代発、店舗代運営、商品保管についてのみ特別な定義を行います。",
    "2、一件代发服务：指经您书面申请，Taoify平台审批通过，您办理完毕一件代发所需手续（包括但不限于签订协议等）后，Taoify平台为您采购中国境内一个或多个商品并在打包完成后寄送到您的指定收货地址的整个服务流程。": "2、一件代発サービス：お客様の書面による申請に基づき、Taoify プラットフォームが承認し、一件代発に必要な手続き（契約締結など）を完了した後、中国国内の一つまたは複数の商品を購入し、梱包してお客様の指定された配送先に送る一連のサービスです。",
    "3、店铺代运营服务：指经您书面申请，Taoify平台审批通过，您办理完毕店铺代运营服务所需手续（包括但不限于签订店铺代运营合同/SOP）后，基于您选择的店铺服务项对您的店铺进行代运营操作的整个过程。": "3、店舗代運営サービス：お客様の書面による申請に基づき、Taoify プラットフォームが承認し、店舗代運営サービスに必要な手続き（店舗代運営契約/SOPの締結など）を完了した後、お客様が選択した店舗サービス項目に基づいて店舗を代わりに運営する一連のプロセスです。",
    "4、商品存储服务：指经您书面申请，Taoify平台审批通过，您办理完毕商品存储开通所需手续（包括但不限于您与平台另行签署协议）后，寄送至Taoify仓库的商品提供存储服务。": "4、商品保管サービス：お客様の書面による申請に基づき、Taoify プラットフォームが承認し、商品保管開設に必要な手続き（別途契約の締結など）を完了した後、Taoify 倉庫に送られた商品の保管サービスを提供します。",
    "二、服务内容": "二、サービス内容",
    "（一）基础服务": "（一）基本サービス",
    "1、建店/关联店铺，支持绑定Shopify/Taoify店铺平台。Taoify为您一键创建独立站店铺，同时Taoify能支持绑定您的独立站店铺并提供选择商品、订单管理、包裹管理和国际物流等全流程电商服务。": "1、店舗の作成/関連付け、Shopify/Taoify 店舗プラットフォームとの連携をサポートします。Taoify はワンクリックで独立した店舗を作成し、同時に独立した店舗との連携をサポートし、商品選択、注文管理、パッケージ管理、国際物流などのフルプロセスのECサービスを提供します。",
    "2、Taoify为每位用户提供一定的免费次数，您需为超出的次数付费。包括对接的第三方平台，商品搜索/编辑、订单同步到Taoify全球寄送等基础服务。": "2、Taoify は各ユーザーに一定の無料回数を提供します。超過分については有料となります。これには、対接するサードパーティプラットフォーム、商品検索/編集、Taoify への注文同期、グローバル配送などの基本サービスが含まれます。",
    "3、海量商品搜索、上架，支持中国电商平台(淘宝、天猫、1688)。": "3、大量の商品検索、上架、中国のECプラットフォーム（淘宝、天猫、1688）をサポートします。",
    "（二）增值服务": "（二）付加価値サービス",
    "1、商品采购、仓储打包、国际物流发货过程中发生的商品、包裹等增值服务，包括但不限于到付件代付、修剪线头、商品盘点、商品个性化贴标、EPE泡沫填充物、纸护角卡条、拉伸膜、木架加固等。": "1、商品購入、保管、梱包、国際物流発送過程で発生する商品、パッケージなどの付加価値サービス。これには、着払い代行、糸頭のトリミング、商品点検、商品の個別化ラベル貼り、EPEフォーム充填材、紙コーナープロテクター、ストレッチフィルム、木枠補強などが含まれます。",
    "2、店铺运营中增值服务，包括但不限于Taoify为您提供多样化的店铺装修、商品管理、订单管理、店铺搭建托管、产品托管、订单托管、店铺运营托管等。": "2、店舗運営中の付加価値サービス。これには、多様な店舗装飾、商品管理、注文管理、店舗構築・託管、製品託管、注文託管、店舗運営託管などが含まれます。",
    "3、商品存储。经您书面申请、Taoify 平台审批通过，并另行签署相关协议办妥全部入库手续后，您寄送至 Taoify 仓库的商品方可入库存储。仓储完整收费标准、入库规则、库存管理、催告处置、损毁责任、付费仓储细则等全部权利义务，以双方另行签署的相关协议约定为准。商品自仓库签收当日起享有30天免费存储周期；免费存储到期前3日，平台将通过站内信、绑定邮箱向您发送到期提醒，您可选择将商品出库寄送，或选购付费仓储套餐延长存储期限。若免费存储期限届满后，您未在3日内完成商品出库、亦未办理付费仓储延期，且经平台再次催告后仍未处置滞留商品的，平台有权按照另行签订的协议约定对超期商品统一销毁处理；商品一经销毁无法找回、补发，因逾期未处置产生的全部损失、清运处置费用均由您自行承担，Taoify不承担任何赔偿责任。": "3、商品保管。お客様の書面による申請に基づき、Taoify プラットフォームが承認し、別途関連契約を締結してすべての入庫手続きを完了した後、Taoify 倉庫に送った商品が入庫保管されます。保管料金、入庫規則、在庫管理、催告処理、損壊責任、有料保管詳細などの全権利義務は、双方が別途締結する関連契約に基づきます。商品は倉庫での受領日から30日間無料保管されます。無料保管期間満了の3日前に、プラットフォームはサイト内メッセージや登録メールアドレスを通じて期限切れのお知らせを送信します。商品を出庫して送るか、有料保管パッケージを選んで保管期間を延長することができます。無料保管期間満了後3日以内に出庫または有料保管延期の手続きをせず、プラットフォームからの再度の催告にも応じない場合、プラットフォームは別途締結した契約に基づいて超期商品を統一的に廃棄処理することができます。廃棄された商品は取り戻すことができず、再発送もできません。遅延による全損失、清掃処理費用はお客様が負担し、Taoify は賠償責任を負いません。",
    "三、注意事项": "三、注意事項",
    "1、为了您的账号安全，在使用账号服务时，请您事先自行核实操作规则或谨慎决定是否授权给代运营团队操作。": "1、アカウントの安全のために、アカウントサービスを使用する際は、操作ルールを事前にご確認いただくか、代運営チームへの操作権限の委任を慎重に決定してください。",
    "2、您用户账户的使用记录和交易数据等均以我们的系统记录为准，如您对该等数据存有异议的，可及时向我们提出，我们会根据您提供的相关证据积极予以核实。": "2、ユーザーのアカウント使用記録や取引データは、当社システムの記録を基準とします。これらのデータに疑問がある場合は、すぐにご連絡いただき、提出された関連証拠に基づいて積極的に確認いたします。",
    "3、平台可选择以网站公告、电子邮件、站内信等方式向您发送通知。": "3、プラットフォームはウェブサイトの公告、電子メール、サイト内メッセージ等方式でお客様に通知を送信することが選べます。",
    "4、为了保护您及他人的合法权益，如您被他人投诉或投诉他人，我们可能会将您的姓名及身份信息和联系方式，企业经营范围和投诉相关内容等提供给第三方，以便及时解决投诉纠纷。": "4、お客様や他の人の合法的な権益を保護するために、お客様が他者からクレームをつけられた場合や、お客様が他者に対してクレームをつけた場合、我々はあなたの名前、身分情報、連絡先、企業の経営範囲、およびクレームに関連する内容などを第三者に提供する可能性があります。これにより、クレームの紛争をタイムリーに解決することができます。",
    "5、Taoify销售的商品均采购自中华人民共和国，符合中华人民共和国有关商品质量、安全、卫生、环保、标识等标准，可能与您所在国家的标准存在差异或冲突，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "5、Taoifyで販売されている商品はすべて中華人民共和国から調達され、中華人民共和国の商品品質、安全、衛生、環境保護、表示などの基準を満たしていますが、お客様の所在国と異なる基準や矛盾があるかもしれません。お客様ご自身で判断し、関連するリスクを負っていただきます。Taoifyプラットフォームはいかなる賠償責任も負いません。",
    "6、Taoify销售的商品主要符合中华人民共和国的相关知识产权，但因知识产权的地域性因素影响，可能会侵犯您所在国家的相关知识产权，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "6、Taoifyで販売されている商品は主に中華人民共和国の関連知的財産権を満たしていますが、知的財産権の地域性の影響により、お客様の所在国の関連知的財産権を侵害する可能性があります。お客様ご自身で判断し、関連するリスクを負っていただきます。Taoifyプラットフォームはいかなる賠償責任も負いません。",
    "7、如果任何组织或个人认为Taoify网站上的任何内容可能侵犯其知识产权，可以通过在线客服及时通知我们，我们会在收到通知后核实。": "7、もし組織または個人がTaoifyウェブサイト上のコンテンツがその知的財産権を侵害していると考える場合は、オンラインカスタマーサービスを通じてすぐに私たちに通知することができます。通知を受け取った後、私たちは確認を行います。",
    "四、其他": "四、その他",
    "1、平台有关条款（包括但不限于本注册协议等）可能会有除中文以外的其他版本。如果不同语言版本的注册协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本注册协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本注册协议，予以明确排除。": "1、プラットフォームに関する条項（本登録協定を含むがそれに限定されない）には中国語以外のバージョンがあるかもしれません。異なる言語版の登録協定間に差異、不一致、または曖昧さがある場合、中国語テキストが優先されます。他のテキストは参考用であり、中国語テキストの意味を抵触または変更することはできません。本登録協定条項の締結、効力、解釈、履行及び紛争解決は全て中華人民共和国法に基づき、国外の法律衝突規則は除外されます。《国連国際物品売買契約条約》は本登録協定には適用されず、明確に除外されます。",
    "2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2、本協定によって生じるまたは本協定に関連する一切の紛争については、両者は友好に解決を図るべきです。協議が成立しない場合、当事者のいずれかはTaoifyプラットフォームの所在地にある管轄権を持つ人民法院に訴訟を提起する権利があります。",
    "3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。": "3、紛争処理期間中、紛争事項を除いて、両者は本協定の他の約束を引き続き履行しなければなりません。",
    "4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "4、本協定の一部の条項が廃止され、無効または実行不能となったとしても、他の条項の効力には影響しません。",
    "商店已经准备就绪": "店舗が準備できました",
    "电子邮箱": "電子メール",
    "店铺地址": "店舗住所",
    "请确认基本的商店信息，之后您可以在管理中更改订阅": "基本的な店舗情報を確認してください。その後、管理画面でサブスクリプションを変更できます。",
    "去修改": "修正する",
    "进入我的店铺": "私の店舗へ",
    "管理后台": "管理画面",
    "查看您的商店业务概述": "店舗ビジネスの概要をご覧ください",
    "多达": "最大",
    "一键上传到你的商店，销售什么商品由你来决定": "ワンクリックであなたの店舗にアップロードし、何を販売するかはあなた次第です",
    "数10种类付款方式，您的顾客在选择好商品之后，可以选择当地的安全支付方式为您快捷收款": "10種類以上の支払い方法があり、お客様が商品を選んだ後、安全な現地の支払い方法で迅速にお支払いいただけます",
    "灵活的物流渠道选择，把货物安全的交付给您的顾客": "柔軟な物流チャネルを選択し、商品を安全に顧客へお届けします",
    "简化订单，跟踪付款和查看实时业务，因此您可以更专注于建立您的业务": "注文の簡素化、支払いの追跡、リアルタイムのビジネス状況の確認により、ビジネス構築に集中することができます",
    "直接在商店里与消费者沟通，提升千倍销量，接触并留住消费者": "店舗内で直接消費者とコミュニケーションを取り、売上を千倍に引き上げ、消費者との接点を増やし、リテンションを高めます",
    "点击进入我的店铺": "私のショップへ",
    "激活成功": "アクティベーション成功",
    "去购物": "買い物に行く",
    "Taoify消费协议": "Taoify利用規約",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify消费协议》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本消费协议约束。": "注意：Taoifyプラットフォームのサービスを利用するには、《Taoify利用規約》を全文読み、厳格に遵守し、自身の権利、義務、使用規則及び違反責任を明確に理解する必要があります。プラットフォーム上で後続で導入されるすべての新機能、新ツールは本利用規約に基づいて管理されます。",
    "Taoify有权不定期更新、修改本消费协议里的内容，有权在 Taoify 网站上发布更新和修改本消费协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoifyは定期的に本利用規約の内容を更新、修正する権利を持ち、Taoifyウェブサイト上でこれらの更新と修正を発表する権利があります。最新版はショッピングモールで一括して公示されますので、定期的に条項の更新内容をご確認ください。条項の改訂内容に同意しない場合は、直ちにプラットフォームの全サービスの使用を停止してください。",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》等为准。": "本協定は《Taoifyサービス条項》の補足文書であり、全体的な文書には《Taoifyユーザー使用協定》《Taoifyユーザープライバシーポリシー》などが含まれています。主契約は《Taoifyサービス条項》です。本協定の内容が《Taoifyサービス条項》と矛盾する場合、《Taoifyサービス条項》が優先されます。本協定で明示的に規定されていない全ての他の権利、義務、規則制約は《Taoifyサービス条項》《Taoifyユーザー使用協定》《Taoifyユーザープライバシーポリシー》等に基づきます。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本消费协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "アカウント登録を完了することで、Taoifyプラットフォームの全ての協定、条項（本利用規約、《Taoifyユーザー使用協定》《Taoifyサービス条項》《Taoifyユーザープライバシーポリシー》など）について十分に認識し、自発的に受け入れたことを意味します。Taoifyプラットフォームの全ての協定、条項に同意しない場合は、すぐに登録を停止してください。",
    "本协议中所有术语定义，均与《Taoify 服务条款》保持统一，不再重复释义。": "本協定中の全ての用語の定義は《Taoifyサービス条項》と統一され、再解説は行われません。",
    "一、消费须知": "一、消費に関する注意事項",
    "1、Taoify 将向用户提供 Taoify 官网所展示的电商建站服务、相关的技术支持以及网络支持等服务。用户需按平台公示标准支付对应费用，具体包括但不限于订阅费用、保证金、交易佣金等。": "1、Taoifyはユーザーに対して、Taoify公式ウェブサイトで展示されているECサイト構築サービス、関連する技術サポートおよびネットワークサポートなどのサービスを提供します。ユーザーはプラットフォームで公表された基準に基づき対応する費用を支払う必要があります。具体的にはサブスクリプション料金、保証金、取引手数料などが含まれますがこれらに限定されません。",
    "2、所有服务收费标准都在订购页面予以列明公示，您可自行选择具体服务类型、服务套餐，并按列明的价格支付费用。您可以登录店铺后台，依次点击「后台设置」>「账单」>「账单管理」进行查看付费明细。": "2、全てのサービス料金の基準は購入ページで明示されています。具体的なサービスタイプ、サービスパッケージを選択し、明示された価格で支払いを行ってください。ショップのバックエンドにログインし、「バックエンド設定」>「請求」>「請求管理」をクリックして支払い詳細を確認できます。",
    "二、服务费用与付费方式": "二、サービス料金と支払い方法",
    "1、服务费用": "1、サービス料金",
    "您可以按照您的需求，根据方案计价选择相应的套餐类型，并根据所选择的套餐类型支付服务费用。": "ニーズに応じてプランの料金に基づき適切なパッケージタイプを選択し、選択したパッケージタイプに基づいてサービス料金を支払います。",
    "2、付费方式": "2、支払い方法",
    "2.1 预付制": "2.1 事前払い制",
    "2.1.1 店铺订阅费用采用预付模式，系统将在服务到期前5个自然日自动发起续费扣款。续费、扣款失败、退回等完整规则见《Taoify 服务条款》。": "2.1.1 店舗のサブスクリプション料金は事前払い制で、サービス期間満了の5日前に自動的に更新料金が引き落とされます。更新、引き落とし失敗、返金などの詳細なルールは《Taoify サービス条項》をご覧ください。",
    "2.1.2 保证金采用预付制，用户完成账户注册时，须一次性足额缴纳经营保证金1000元，保证金不得抵扣订阅费、税费。保证金支付、退回等完整规则见《Taoify 服务条款》。": "2.1.2 保証金も事前払い制で、ユーザーがアカウント登録を完了する際には、一括で営業保証金1000元を支払う必要があります。この保証金はサブスクリプション料金や税金の支払いには使用できません。保証金の支払い、返金などの詳細なルールは《Taoify サービス条項》をご覧ください。",
    "2.1.3 费用支付后，平台提供服务。若因付款异常导致支付中止，您可在商城「后台设置」>「账单」>「账单管理」中查看处理结果，并手工完成支付。": "2.1.3 料金を支払った後、プラットフォームがサービスを提供します。支払い異常により支払いが中断された場合、「バックエンド設定」>「請求書」>「請求管理」から処理結果を確認し、手動で支払いを完了することができます。",
    "2.2 付费": "2.2 有料",
    "2.2.1 佣金": "2.2.1 コミッション",
    "2.2.1.1 用户按平台公示标准向平台支付佣金；平台现行阶段暂未计收佣金，具体费率以平台届时公示为准。": "2.2.1.1 ユーザーはプラットフォームが公表する基準に基づいてコミッションを支払います。現行ではコミッションは課されていませんが、具体的なレートはプラットフォームの公示によるものです。",
    "2.2.1.2 Taoify收取的佣金基于订单的付款状态计取，每月销售付款金额以平台后台生成的订单截图为准，若由于后续订单产生退款等，不退还该笔订单的佣金。": "2.2.1.2 Taoifyが徴収するコミッションは注文の支払い状況に基づいて計算されます。月間売上額はプラットフォームのバックエンドで生成された注文スクリーンショットを基準とします。その後の注文により返金が発生した場合でも、その注文のコミッションは返金されません。",
    "2.2.1.3 平台于每月月底向用户出具当月付款销售业务的结算报告（包括销售付款金额及相应佣金金额）并交付给用户。用户在收到结算报告后2日内提出异议，若未提出异议视为认可结算报告。用户须于收到结算报告后5日内，单独向平台付清该月佣金。若用户在收到结算报告后2日内提出书面异议的，就无争议佣金须于收到结算报告5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期佣金暂按平台原结算报告金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.2.1.3 プラットフォームは毎月末に当月の売上業務の精算報告（売上額および対応するコミッション額を含む）を作成し、ユーザーに提供します。ユーザーは精算報告を受け取った後2日以内に異議を申し立てることができ、異議がない場合は精算報告を認めたものとみなされます。ユーザーは精算報告を受け取った後5日以内に、当月のコミッションを個別にプラットフォームに支払う必要があります。ユーザーが精算報告を受け取った後2日以内に書面で異議を申し立てた場合、無争議部分については受け取った精算報告から5日以内に個別に支払う必要があります。争議部分については、ユーザーが異議を申し立てた日から15日以内に対照確認を行い、全ビジネス証拠を提出し、調整額を確認しなければなりません。ユーザーが異議を申し立てた日から15日以内に金額について合意できない場合、該当期のコミッションはプラットフォームの元の精算報告額に基づいて先行して支払い、その後の確認、調停、訴訟を通じて差額が確定次第、次の精算で多寡を調整します。",
    "2.3 其他费用": "2.3 その他の費用",
    "2.3.1 除订阅费用、保证金、佣金外，经用户申请，平台自行内部审核通过后，用户可与Taoify平台另行签约开通后付费模式，签约后用户可以先使用Taoify为您提供的服务，平台再清算您店铺内所产生的费用，并通过线下交易的形式收取。": "2.3.1 サブスクリプション料金、保証金、コミッション以外に、ユーザーの申請に基づきプラットフォーム内部審査を通過した場合、ユーザーはTaoifyプラットフォームと別途契約を結び、後払いモードを有効にすることができます。契約後、ユーザーはまずTaoifyが提供するサービスを利用し、その後プラットフォームが店舗内で発生した費用を清算し、オフライン取引の形で回収します。",
    "2.3.2 Taoify 后付费的具体流程：用户申请；平台自行内部审核通过；Taoify 在每月结束后通过 Taoify 客服通知您的账单；如您对账单有任何异议的，应于下月15日之前向 Taoify 客服书面提出，未在上述期限提出书面异议的，视为认可该账单及发票。用户须于收到账单后5日内，单独向平台付清。若用户在收到账单后2日内提出书面异议的，就无争议部分须于收到账单5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期费用暂按平台原账单金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.3.2 Taoify 後払いの具体的な流れ：ユーザー申請；プラットフォーム内部審査通過；Taoify は毎月終了後にTaoifyカスタマーサポートを通じてあなたの請求書を通知します。請求書に異議がある場合は、翌月15日までにTaoifyカスタマーサポートへ書面で申し立てなければなりません。上記期限内に書面での異議申し立てがない場合は、請求書及び領収書を認めたものとみなされます。ユーザーは請求書を受け取った後5日以内に、個別にプラットフォームに支払う必要があります。ユーザーが請求書を受け取った後2日以内に書面で異議を申し立てた場合、無争議部分については受け取った請求書から5日以内に個別に支払う必要があります。争議部分については、ユーザーが異議を申し立てた日から15日以内に対照確認を行い、全ビジネス証拠を提出し、調整額を確認しなければなりません。ユーザーが異議を申し立てた日から15日以内に金額について合意できない場合、該当期の費用はプラットフォームの元の請求書額に基づいて先行して支払い、その後の確認、調停、訴訟を通じて差額が確定次第、次の精算で多寡を調整します。",
    "三、费用支付": "三、費用の支払い",
    "1、您必须向平台提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1、プラットフォームに対して有効かつ利用可能な支払い方法を提供する必要があります。これにより、支払い失敗による店舗使用への影響を避けることができます。複数のクレジットカードをバインドし、自動支払いを許可することをお勧めします。請求書の支払い技術は第三者の専門金融会社によってサポートされています。",
    "2、账单生成后，系统将通过您授权的支付方式自动扣款，该扣款流程持续至本服务终止。若您设置默认支付卡，系统将优先从默认卡完成扣费。除另行约定外，所有费用均以美元作为结算及支付币种。": "2、請求書が生成された後、システムはあなたが許可した支払い方法を通じて自動的に引き落としを行います。この引き落としプロセスは本サービスが終了するまで継続します。デフォルトの支払いカードを設定している場合、システムは最初にデフォルトカードから引き落としを行います。別段の合意がない限り、すべての費用はドルで決済および支払われます。",
    "3、费用将显示在账单上，并通过提供的电子邮件发送至商店所有者。如果您对账单存在疑问，可以与 Taoify 的相关业务部门进行联系。后续将通过电子邮件的形式与您取得联系，账单争议内容将发送至您所提供的店铺财务邮箱。": "3、費用は請求書に表示され、提供されたメールアドレスに電子メールで送信されます。請求書に疑問がある場合は、Taoifyの関連部門に連絡してください。その後、電子メールを通じて連絡を取り、請求書に関する争議内容はあなたが提供した店舗財務メールアドレスに送られます。",
    "4、针对 Taoify 自身收取的平台服务费，可联系平台对应业务部门办理，发票将通过邮件发送至您预留的店铺财务邮箱；第三方收取的款项，您应直接对接第三方主体办理，Taoify 可予以必要配合。": "4、Taoify自身が徴収するプラットフォームサービス料については、対応する部門に連絡して手続きを行うことができます。領収書はメールで店舗財務メールアドレスに送られます。第三者が徴収する費用については、直接第三者と連絡を取り、Taoifyは必要な協力を提供します。",
    "5、平台提前30日发出服务费用变更通知后即可调整服务收费标准，平台可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "5、プラットフォームはサービス料金の変更について30日前に通知を出し、その後サービス料金を調整することができます。通知はプラットフォーム公式ウェブサイトまたは店舗バックエンド管理ページを通じて配信されます。",
    "6、平台不就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "6、プラットフォームはサービスのいかなる修正、価格変動、一時停止または終了について、あなたまたは第三者に対して責任を負いません。",
    "7、若平台无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。平台每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，平台有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "7、プラットフォームが認証済みの銀行カードからサブスクリプション料金を成功裏に引き落とせない場合、所有者にメールで引き落とし失敗を通知し、支払い用銀行カードの更新を促します。プラットフォームは24時間ごとに最大3回（初回を含む）引き落としを試みます。3回目の引き落としが失敗した場合、プラットフォームはあなたのアカウントの使用権限を一時停止し制限することができます。未払い分と次の課金周期のサブスクリプション料金を支払った後、アカウントのアクセス権限が正常に戻ります。",
    "8、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "8、サービス期間の満了前に更新料を支払わなかった場合、サービスは自動的に終了します。サービスが停止されてから10日経っても更新料が支払われない場合、Taoify プラットフォームはウェブサイトの全データを削除する権利を持ちます。関連する損失はユーザーが自己負担となります。",
    "9、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本消费协议中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向平台提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "9、Taoify が独自に徴収するプラットフォーム利用料には、各種政府が課す税金、規費その他の費用（本消費契約では「税金等」と総称）は含まれません。プラットフォーム利用料以外に、Taoify の製品およびサービスの購入・サブスクリプションにより発生する全ての適用される税金等は、お客様が自己負担となります。税金等は、お客様が提供した請求先住所に基づく税率で計算され、お客様が指定したカードから自動的に引き落とされます。免税資格がある場合は、有効な免税証明書をプラットフォームに提出する必要があります。一部の司法管轄区域では、地元の法規に準拠した公式証明書を提出することが求められることがあります。免税政策は、提出された資料が審査を通った日から有効となります。Taoify が代わりに税金等を計算しなかった場合、お客様自身で納税義務を判断し、税務当局に対して申告および納税を行う必要があります。",
    "10、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本消费协议约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "10、Taoify が代わりに徴収し、税務当局に納める税金等を除き、法律や規則で定められた各種税金の控除、源泉徴収義務はすべてお客様が自己負担となり、対応する税務当局に対して納税を行う必要があります。上記の税金の控除または源泉徴収要件が存在するかどうかに関わらず、Taoify は本消費契約に基づいて、お客様が指定したカードから全額の支払いを引き落とす権利を持ちますが、Taoify には積極的な引き落としの義務はありません。",
    "11、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "11、お客様の店舗運営による売買行為によって発生する全ての適用される税金等は、お客様が自己負担で法的に納税する必要があります。",
    "12、平台订阅费用、交易佣金应用费、模板费、罚金等均不支持退款；用户主动注销、中途终止服务、违规封禁账号，已缴纳全部费用不予返还；订单售后退款、退货的，对应订单已扣除佣金不予退还。": "12、プラットフォーム利用料、取引手数料、テンプレート料、罰金などは返金不可です。ユーザーが自発的にアカウントを解約したり、途中でサービスを終了したり、違反によりアカウントが封鎖された場合、既に支払われた全額の返金は行われません。注文のキャンセルや返品の場合でも、該当する注文からすでに控除された手数料は返還されません。",
    "四、罚金政策": "四、罰金政策",
    "1、商家应确保及时、准确地处理订单、并将物流单号同步到后台。超时发货的订单采取了严格的处罚措施，具体处罚措施：付款30天内没有上传物流单号，每单额外收取0.5美元罚金。": "1、商家は注文をタイムリーかつ正確に処理し、物流番号をバックエンドに同期することを確認する必要があります。遅延出荷の注文には厳しい罰則が設けられており、具体的な罰則は：支払い後30日以内に物流番号をアップロードしない場合、1注文につき0.5ドルの罰金が課されます。",
    "2、对于定制类、预售等可能需要超过30天的类目，须向 Taoify 书面提出申请延长发货申请，审批通过后不予处罚。": "2、カスタムメイドや予約販売など、30日以上かかる可能性のあるカテゴリーについては、Taoify に書面で出荷延期申請を行い、承認された場合は罰則が適用されません。",
    "3、Taoify 系统只提供基础建站功能，不提供、不负责买家与用户的资金处理与结算，资金相关的服务由第三方支付机构处理，相应风险由用户承担。": "3、Taoify システムは基本的なウェブサイト構築機能のみを提供し、買い手とユーザー間の資金処理や決済は行いません。資金関連のサービスは第三者の決済機関が処理し、それに関連するリスクはユーザーが負います。",
    "4、若用户店铺单个自然月超时发货订单满5笔，或同一自然年度内累计超时发货订单满20笔的，用户除按约定向平台支付对应罚金外，平台亦有权依据平台公示协议及规则，暂停店铺经营服务、单方终止双方合作，且用户已向平台缴纳的全部费用不予退还。": "4、ユーザーの店舗が1ヶ月間に遅延出荷の注文が5件を超える場合、または同一自然年内に累積して遅延出荷の注文が20件を超える場合、ユーザーは規定通りにプラットフォームに罰金を支払うとともに、プラットフォームは公開されている協定およびルールに基づき、店舗の営業サービスを一時停止し、一方的に両者の協力を終了する権利を持ちます。また、ユーザーがプラットフォームに支払った全額の返金は行われません。",
    "五、服务到期或欠款": "五、サービス期限切れまたは未払い",
    "1、服务到期": "1、サービス期限切れ",
    "1.1 按时计费": "1.1 時間制",
    "1.1.1 免费试用版：服务期限自平台为用户开通试用当日起算，到期未付费自动关闭站点。": "1.1.1 無料試用版：サービス期間はプラットフォームがユーザーに試用を開始した日から算出され、期限切れで未払いの場合、サイトは自動的に閉鎖されます。",
    "1.1.2 付费版：服务期自用户支付服务费用付费或套餐支付费用后激活之日起计算，到期时间以店铺后台公示为准。": "1.1.2 有料版：サービス期間はユーザーがサービス料金を支払いまたはパッケージ料金を支払ってアクティベートした日から算出され、期限は店舗バックエンドの表示に基づきます。",
    "2、按量计费：若您使用的是先付费服务，即先购买服务次数/条数再使用的，在服务项目服务次数/条数在使用过程中消耗至零时，即视为服务到期。": "2、使用量制：事前払いサービスを使用している場合、つまりサービス回数/単位を先に購入してから使用する場合、サービス項目の回数/単位が使用中にゼロになると、サービス期限切れとみなされます。",
    "第六条 争议解决": "第六条 争議解決",
    "1、平台有关条款（包括但不限于本消费协议等）可能会有除中文以外的其他版本。如果不同语言版本的消费协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本消费协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本消费协议，予以明确排除。": "1、プラットフォームに関する条項（本消費契約などを含む）には、中国語以外の言語版が存在する場合があります。異なる言語版の消費契約間に相違、不一致、または曖昧さが存在する場合、中国語テキストが基準となります。他のテキストは参考としてのみ使用され、中国語テキストの意味を抵触または変更することはできません。本消費契約条項の成立、効力、解釈、履行、および争議解決は、中華人民共和国の法律を準拠法とし、海外の法律の競合を排除します。《国際物品売買契約に関する国連条約》は本消費契約には適用されず、明確に除外されます。",
    "第七条 其他约定": "第七条 その他",
    "1、运营主体：本平台由香港星橋國際貿易有限公司（https://aitaoify.com，以下简称\"Taoify\"或\"平台\"）运营。您可通过邮箱 liutaotao@taocarts.com 或微信号 zzsist666 与平台取得联系。": "1、運営主体：本プラットフォームは香港星橋國際貿易有限公司（https://aitaoify.com、以下「Taoify」または「プラットフォーム」という）によって運営されています。メール liutaotao@taocarts.com または WeChat zzsist666 でプラットフォームに連絡することができます。",
    "2、未成年人使用：本平台服务面向具有完全民事行为能力的主体。未成年人应在监护人陪同、指导下阅读本协议并在监护人同意后方可注册、使用本平台服务；监护人应就未成年人使用平台的行为承担相应法律责任。": "2、未成年者の利用：本プラットフォームのサービスは完全な民事能力を持つ主体を対象としています。未成年者は保護者の同伴と指導のもとで本契約を読み、保護者の同意を得た上で登録および利用することが必要です；保護者は未成年者がプラットフォームを利用する際の行動について法的責任を負います。",
    "3、知识产权：Taoify平台的商标、标识、页面设计、文案、软件、代码等知识产权均归平台或相关权利人所有，未经书面许可，任何人不得复制、修改、传播或用于商业用途。用户对其自行上传的内容依法享有权利，并保证该内容不侵犯第三方合法权益。": "3、知的財産権：Taoifyプラットフォームの商標、ロゴ、ページデザイン、文章、ソフトウェア、コードなどの知的財産権はすべてプラットフォームまたは関連権利者に帰属します。書面による許可なく、誰もそれらを複製、改変、伝播または商業目的で使用することはできません。ユーザーが自身でアップロードしたコンテンツについては法に基づいて権利を有し、その内容が第三者の合法的な権利を侵害しないことを保証します。",
    "4、通知送达：平台通过您预留的注册邮箱、店铺后台公告、站内消息或短信发出的通知，于发出之日即视为送达。您应保持联系方式有效，因联系方式变更未及时通知平台导致的后果由您自行承担。": "4、通知の送達：プラットフォームからの通知は、登録時に残されたメールアドレス、店舗バックエンドの告知、サイト内メッセージ、またはSMSを通じて行われ、発信日には到達したものとみなされます。連絡先情報を有効に維持してください。連絡先情報の変更をプラットフォームに適時通知しなかったことにより生じる結果は、ユーザー自身が責任を負います。",
    "5、完整协议：本协议连同《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》构成您与平台之间关于使用本平台服务的完整约定，取代此前双方就同一事项达成的口头或书面约定。": "5、完全な契約：本契約は《Taoify サービス条項》《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》と共に、ユーザーとプラットフォーム間におけるプラットフォームサービスの利用に関する完全な合意を構成し、これ以前に同一事項について締結された口頭または書面での合意を置き換えます。",
    "6、本协议更新日期：2026年1月1日；生效日期：2026年1月1日。": "6、本契約の更新日：2026年1月1日；施行日：2026年1月1日。",
    "版权所有": "著作権所有",
    "Taoify用户隐私政策": "Taoifyユーザープライバシーポリシー",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify用户隐私政策》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本用户隐私政策约束。": "注意：Taoifyプラットフォームのサービスを登録または利用する場合、《Taoifyユーザープライバシーポリシー》を全文読み、厳格に遵守し、自身の権利、義務、使用規則及び違反責任を明確に理解する必要があります。プラットフォームで後続で導入される全ての新機能や新ツールも、このユーザープライバシーポリシーによって制約されます。",
    "Taoify有权不定期更新、修改本用户隐私政策里的内容，有权在 Taoify 网站上发布更新和修改本用户隐私政策。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoifyは定期的にユーザープライバシーポリシーの内容を更新、修正する権利を持ち、Taoifyウェブサイト上にこれらの更新と修正を公表することができます。最新版は一括してショッピングモールで公示されますので、定期的に条項の更新内容をご確認ください。条項の改正内容に同意できない場合は、直ちにプラットフォームの全サービスの利用を停止してください。",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify消费协议》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "本契約は《Taoifyサービス条項》の補足文書であり、全体の文書には《Taoifyユーザー使用協定》《Taoify消費協定》等も含まれています。《Taoifyサービス条項》が主契約となります。本契約の内容が《Taoifyサービス条項》と矛盾する場合、《Taoifyサービス条項》が優先されます；本契約で明示的に規定されていない他の全ての権利、義務、ルールは《Taoifyサービス条項》《Taoifyユーザー使用協定》《Taoify消費協定》等に基づきます。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本用户隐私政策、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify消费协议》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "アカウント登録を完了することで、Taoifyプラットフォームの全ての契約、条項（ユーザープライバシーポリシー、《Taoifyユーザー使用協定》《Taoifyサービス条項》《Taoify消費協定》等）を十分に理解し、自発的に受け入れることを表明します。Taoifyプラットフォームの全ての契約、条項の内容に同意できない場合は、直ちに登録を停止してください。",
    "一、适用范围": "一、適用範囲",
    "1、本政策适用于所有注册、访问、使用 Taoify 独立站建站平台的用户（商店所有者、员工账号）；": "1、本ポリシーはTaoify独立站建站プラットフォームに登録、アクセス、利用する全てのユーザー（店舗所有者、従業員アカウント）に適用されます；",
    "2、本政策规范两类信息处理：2.1 用户自身注册资质、经营信息；2.2 用户店铺面向境外消费者收集的个人信息；": "2、本ポリシーは以下の2種類の情報処理を規制します：2.1 ユーザー自身の登録資格、経営情報；2.2 ユーザーの店舗が海外消費者から収集する個人情報；",
    "3、本政策不适用于其他第三方（如支付、物流、广告服务商），第三方隐私规则由其自身政策约束，与平台无关。": "3、本ポリシーは他の第三者（支払い、物流、広告サービスプロバイダーなど）には適用されません。第三者のプライバシールールはそれぞれのポリシーによって制約され、プラットフォームとは関係ありません。",
    "4、您完成账户注册，将被视为接受、同意、确认：您在自愿下同意向我们披露个人资料；您会遵守本隐私政策的全部条款和限制；您在我们的网站上作登记、资料会被收集；您同意日后我们对隐私政策的任何修改；您同意我们的分公司、附属公司、雇员，就您可能会感兴趣的产品和服务与您联络。": "4、アカウント登録を完了することで、次のことを受諾、同意、確認したことになります：自発的に私たちに個人情報を開示することに同意します；本プライバシーポリシーの全条項と制限を遵守します；私たちのウェブサイトで登録すると、情報が収集されることに同意します；今後のプライバシーポリシーのいかなる修正にも同意します；私たちの子会社、関連会社、従業員があなたが興味を持ちそうな商品やサービスについて連絡することに同意します。",
    "二、个人信息的收集": "二、個人情報の収集",
    "1、收集用户（平台注册用户）信息": "1、ユーザー（プラットフォーム登録ユーザー）情報の収集",
    "1.1 在您注册我们的服务、获取使用我们的服务或者以其他方式向我们提供信息时，我们会收集您的个人信息。": "1.1 あなたが私たちのサービスに登録したり、サービスを利用したり、または他の方法で情報を提供する際に、私たちはあなたの個人情報を収集します。",
    "1.2 经您同意，我们会收集、管理和监控个人资料。为了向您提供我们的各项服务，您需要提供个人资料，包括但不限于：企业名称、地址、联系电话、邮箱、营业执照、经营资质等，用于账户核验、资质审核、账单通知、售后对接、履约担保。": "1.2 あなたの同意のもと、私たちは個人情報を収集、管理、監視します。私たちの各種サービスを提供するために、企業名、住所、電話番号、メールアドレス、事業許可証、経営資格などの個人情報を提供する必要があります。これらはアカウント検証、資格審査、請求通知、アフターサービス対応、履行担保のために使用されます。",
    "1.3 我们收集您访问 Taoify 上的网页的相关数据。我们还会收集有关您访问账号的方式和时间的相关数据，包括您使用的设备和浏览器，网络连接以及您的IP地址、设备型号、登录时间、操作记录等信息，用于账户安全风控、异常登录识别、平台功能优化。": "1.3 私たちはあなたがTaoify上のウェブページを訪問する際の関連データを収集します。また、アカウントへのアクセス方法や時間に関するデータ、使用しているデバイスやブラウザ、ネットワーク接続、IPアドレス、デバイスモデル、ログイン時間、操作記録などの情報を収集します。これらはアカウントのセキュリティリスク管理、異常ログインの識別、プラットフォーム機能の最適化のために使用されます。",
    "1.4 我们收集与支付相关信息，包括但不限于支付和处理订单、绑定信用卡等。": "1.4 支払い関連情報（支払い処理、クレジットカードの紐付けなど）を収集します。",
    "2、收集用户店铺的终端消费者信息：Taoify 仅作为技术工具存储数据，收集访客姓名、邮箱、电话、收货地址、支付订单、物流信息，用于订单履约、发货售后、订单对账。": "2、ユーザーの店舗のエンド消費者情報：Taoifyは技術ツールとしてデータを保存し、訪問者の名前、メールアドレス、電話番号、配送先住所、注文情報、物流情報を収集し、注文履行、発送後のサポート、注文照合に使用します。",
    "3、Cookie及非身份信息收集": "3、Cookieおよび非個人情報の収集",
    "3.1 我们将通过您的IP地址来收集您的部分非个人化信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集该信息，我们将进行客流量统计，从而改进网站的管理和服务。": "3.1 IPアドレスを通じて、ブラウザの種類、オペレーティングシステム、ISPのドメイン名などの一部の非個人化情報を収集し、画面表示を最適化します。この情報収集により、サイトの管理とサービスを改善します。",
    "3.2 Cookies是一种技术，当您访问设有Cookies装置的本网站时，本网站之服务器会自动发送Cookies至您浏览器内，并储存到您的电脑硬盘内，此Cookies便负责记录日后您到访本网站的种种活动、个人资料、浏览习惯、消费习惯、信用记录。": "3.2 Cookieは、サイトを訪問した際の活動、個人情報、閲覧習慣、消費傾向、信用記録などを記録する技術です。",
    "3.3 运用Cookies技术，本网站能够为您提供更加周到的个性化服务。本网站将会运用Cookies追访您的购物喜好，从而向您提供感兴趣的信息资料或储存密码，以便您造访本网站时不必每次重复输入密码。": "3.3 Cookie技術を使用することで、当サイトはよりパーソナライズされたサービスを提供できます。Cookieを使ってお客様の購入履歴を追跡し、興味のある情報やパスワードの保存を行い、毎回パスワードを入力する手間を省きます。",
    "3.4 您可自行在浏览器中关闭、清除 Cookie，关闭后部分平台功能将无法正常使用。": "3.4 ブラウザでCookieを無効にしたり削除したりすることができますが、その場合、一部の機能が利用できなくなることがあります。",
    "三、个人信息的用途": "三、個人情報の用途",
    "通常情况，本网站将采取合理的措施保护您的个人信息，使其避免未经授权的披露。在遵守相关法律的前提下，我们可能会与以下实体（可能包括境内和境外）分享使用您的个人信息。": "通常、当サイトは合理的な措置を講じて、お客様の個人情報が不正な開示から保護されるようにします。関連法規を遵守しつつ、以下のエンティティ（国内・国外含む）と個人情報を共有することがあります。",
    "1、供应商：包括但不限于为了满足您网站需求的供货商、软件商、结汇收款、仓储物流、活动展会服务、代理商等。这些供应商可能根据需要与您联系，以完成相关产品服务；": "1、サプライヤー：ウェブサイトのニーズを満たすための供給元、ソフトウェア会社、決済サービス、倉庫物流、イベント展示会サービス、代理店などが含まれます。これらのサプライヤーは必要に応じてお客様に連絡し、関連製品サービスを完了します；",
    "2、金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等；": "2、金融機関と第三者決済機関：予約、返金申請、保険購入時、特定の注文情報を金融機関または第三者決済機関と共有します。詐欺検知と防止のためにIPアドレスなどの他の必要な情報をさらに共有することがあります；",
    "3、业务第三方：我们可能与第三方为您提供产品或者服务，包括快递业务、通讯服务、客户服务、市场推广、广告投放等；": "3、ビジネスパートナー：配送、通信、カスタマーサービス、マーケティング、広告配信などのサービスを提供するために、第三者と情報を共有することがあります；",
    "4、我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用；": "4、あるサービスからの個人情報と他のサービスからの情報を組み合わせて、よりパーソナライズされたサービスを提供することがあります；",
    "5、经您许可的其他用途。": "5、お客様の許可を得たその他の用途。",
    "四、个人信息的管理": "四、個人情報の管理",
    "1、客户信息使用限制：作为 Taoify 平台商家，未经您书面明确许可，Taoify 不会主动单独联系您的客户，亦不会利用您店铺客户信息开展营销推广。但是如果我们是从其他渠道获取到您客户的信息，比如客户自己提供给我们，Taoify 可能会联系或向这些客户营销。": "1、顧客情報使用制限：Taoifyプラットフォームの商家として、書面による明確な許可がない限り、Taoifyは個別にあなたの顧客に連絡したり、あなたの店舗の顧客情報を用いてマーケティングを行ったりすることはありません。ただし、他のチャネルから顧客情報を取得した場合は、Taoifyはこれらの顧客に連絡したりマーケティングを行う可能性があります。",
    "2、信息安全防护措施：Taoify 将落实物理、电子、流程、多维度技术安全防护机制，对平台存储的个人信息采取加密存储、访问权限管控、操作日志留痕等保护手段，防范个人信息泄露、篡改、丢失、非法访问。在我们网站上所搜集的一切资料都由我们所拥有，Taoify 不会向无关第三方共享、出租、出售您及您客户的任何个人信息。": "2、情報セキュリティ保護措置：Taoifyは物理的、電子的、プロセス的な多層的な技術セキュリティ保護メカニズを実施し、暗号化保管、アクセス権限管理、操作ログの記録等の手段により、個人情報の漏洩、改ざん、紛失、不正アクセスを防ぎます。当サイトで収集したすべての情報はTaoifyが所有しており、無関係の第三者と個人情報を共有、貸与、販売することはありません。",
    "3、网络传输风险提示：互联网传输环境存在固有安全风险，Taoify无法承诺网络传输过程实现绝对无风险。对因未经授权而接触您个人资料所发生的事件平台一概不承担责任，对于产生或导致的任何损失或损害，平台也不负责赔偿。": "3、ネットワーク伝送リスクの注意喚起：インターネット伝送環境には固有のセキュリティリスクがあり、Taoifyは絶対的な無リスクを保証することはできません。不正アクセスによる個人情報への接触について、当サイトは一切の責任を負いません。これによって生じる損害についても賠償責任を負いません。",
    "4、用户自身安全保管义务：您需妥善保管账号、登录密码、员工账号权限、支付相关信息，不得向无关第三方泄露；在公用设备、他人设备登录平台后，务必及时退出登录。因您未妥善保管账号、随意下放员工数据权限、主动泄露信息引发的数据泄漏、财产损失、行政处罚、第三方索赔，全部责任由您自行承担，平台不承担任何责任。": "4、ユーザー自身の安全保管義務：アカウント、ログインパスワード、従業員アカウント権限、支払い関連情報は適切に保管し、無関係の第三者に漏らさないようにしてください。公共の端末や他人の端末でログインした後は必ずログアウトしてください。アカウントの不適切な管理、従業員データ権限の乱発、情報の自主的な漏洩により引き起こされるデータ漏洩、財産損失、行政罰、第三者からの請求については、全ての責任はお客様が負います。",
    "5、您对个人信息的自主管理权利：您依法享有个人信息的访问、查阅、更正、补充、限制使用、申请删除等权利。您可在店铺后台「账户设置」中自主编辑更新账户联系邮箱、联系电话、绑定支付卡片等基础信息。您可联系平台客服并提交对应证明材料申请更新营业执照、经营资质、历史备案主体等后台无法直接修改的信息。您可申请平台对非法定留存类个人信息进行删除。若您申请删除业务信息、限制订单/支付/风控所需信息的使用，店铺建站、收款、订单履约、账单推送等基础服务无法正常使用，由此产生的经营损失由您自行承担。": "5、個人情報に対する自主管理権利：お客様は個人情報の閲覧、訂正、補足、使用制限、削除申請などの権利を持っています。店舗バックエンドの「アカウント設定」で連絡先メールアドレス、電話番号、支払いカードの紐付けなどの基本情報を自主的に編集更新できます。事業者登録証、営業資格、過去の登録主体等、バックエンドで直接変更できない情報の更新については、対応する証明資料と共にプラットフォームのお客様サポートに連絡して申請できます。法定保存期間外の個人情報の削除も申請可能です。業務情報、注文/支払い/リスク管理に必要な情報の削除や使用制限を申請した場合、店舗構築、収款、注文履行、請求書送付などの基本サービスが正常に利用できなくなり、これにより生じる経営上の損失はお客様が自己負担となります。",
    "6、配套规则指引：本条未约定的员工数据权限管控、服务注销后信息留存、信息泄露赔付、第三方数据责任等全部事宜，均按照《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 消费协议》执行。": "6、配套規則ガイドライン：本条で定められていない従業員データ権限管理、サービス解約後の情報保存、情報漏洩賠償、第三者データ責任等のすべての事項は、《Taoify サービス条項》《Taoify ユーザー使用協定》《Taoify 消費者契約》に従って執行されます。",
    "7、信息限制：7.1 平台面向跨境商家，不主动收集未成年人信息，若您店铺收集未成年人信息，由您自行承担合规责任。7.2 用户店铺面向境外消费者收集的境外个人信息，由用户自行满足当地数据出境合规要求，平台仅提供存储技术服务。": "7、情報制限：7.1 当プラットフォームはクロスボーダー商家向けであり、未成年者の情報を積極的に収集しません。あなたの店舗が未成年者の情報を収集する場合、あなた自身がコンプライアンス責任を負います。7.2 あなたの店舗が海外消費者から収集した海外個人情報については、ユーザー自身が現地のデータ輸出コンプライアンス要件を満たす必要があります。プラットフォームは単にストレージ技術サービスを提供します。",
    "8、信息储存与留存：服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "8、情報の保管と保存：サービスがどのような理由で終了しても、あなたは店舗運営の全資料（注文記録、商品資格、購販売契約、ブランド認証、物流証明、顧客取引台帳、品質検査報告書など）を完全に保存し、自らで備案存檔を行う必要があります。当方はこれらの資料の保管、整理、備案の義務はありません。",
    "五、我们如何共享信息": "五、私たちはどのように情報を共有するか",
    "Taoify 对您及您店铺消费者的全部个人信息承担严格保密义务，不会以营销为目的向任何第三方出售、出租、共享您的个人信息。仅在以下法定、约定情形下，可依规共享相关信息：": "Taoify はあなたとあなたの店舗の消費者の全ての個人情報について厳格な秘密保持義務を負い、マーケティング目的でいかなる第三者にもあなたの個人情報を販売、貸与、共有することはありません。以下の法定または約定の場合のみ、関連情報を規則に基づいて共有することが可能です：",
    "1、事先取得您明确、书面的同意或授权；": "1、事前に明確かつ書面による同意または許可を得た場合；",
    "2、依据生效法律文书、监管部门法定调查要求，配合司法、行政机关依法调取；": "2、有効な法的文書、監督当局の法定調査要求に基づき、司法・行政機関の法的調査に協力する場合；",
    "3、向 Taoify 母公司、子公司、全资关联主体共享信息，关联方同样受本隐私政策约束，仅可用于平台配套经营服务，不得对外二次泄露；": "3、Taoify の親会社、子会社、完全関連主体との間で情報を共有する場合。関連者は同様にこのプライバシーポリシーの拘束を受け、プラットフォームの付随的な経営サービスにのみ使用され、外部への二次的な漏洩は禁止されています；",
    "4、向可信第三方服务商（支付、物流、风控、建站插件等）提供必要信息，服务商仅能按照 Taoify 指令处理数据，且需遵守同等保密、安全义务，超出服务范围不得使用、披露您的信息；": "4、信頼できる第三者サービスプロバイダー（支払い、物流、リスク管理、ウェブサイト構築プラグインなど）に必要な情報を提供する場合。サービスプロバイダーはTaoifyの指示に従ってデータを処理し、同等の秘密保持および安全義務を遵守しなければならず、サービス範囲を超えてあなたの情報を使用または開示することはできません；",
    "5、为保护 Taoify、平台其他用户、终端消费者的人身、财产、数据合法权益，确有必要披露相关信息；": "5、Taoify、プラットフォームの他のユーザー、エンド消費者の人身、財産、データの合法的権益を保護するために、関連情報を開示することが必要である場合；",
    "6、发生平台合并、收购、业务转让等情形，承接主体将继续受本隐私政策约束，若数据处理规则发生重大变更，平台将提前公示告知您。": "6、プラットフォームの合併、買収、事業譲渡などの状況が発生した場合、引き継ぎ主体は引き続きこのプライバシーポリシーの拘束を受けます。データ処理ルールに重大な変更がある場合、プラットフォームは事前に公示してあなたに通知します。",
    "7、用户存在违反中华人民共和国法律法规、平台协议及平台规则的行为；": "7、ユーザーが中華人民共和国の法律、規則、プラットフォームの協定及び規則に違反する行為を行った場合；",
    "8、为保护 Taoify、其关联主体、平台其他用户及终端消费者的合法权益。": "8、Taoify、その関連主体、プラットフォームの他のユーザー及びエンド消費者の合法的権益を保護するため。",
    "六、争议解决": "六、紛争解決",
    "1、平台有关条款（包括但不限于本用户隐私政策等）可能会有除中文以外的其他版本。如果不同语言版本的用户隐私政策之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本用户隐私政策条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本用户隐私政策，予以明确排除。": "1、プラットフォームの関連条項（本ユーザーのプライバシーポリシーなどを含む）には中国語以外の言語版が存在する可能性があります。異なる言語版のユーザーのプライバシーポリシー間に何らかの差異、不一致、または曖昧さが存在する場合、中国語テキストが基準となります。他のテキストは参考用であり、中国語テキストの意味を抵触または変更することはできません。本ユーザーのプライバシーポリシー条項の成立、効力、解釈、履行及び紛争解決は、中華人民共和国の法律を準拠法とし、国外の法律の競合を排除します。《国連国際物品売買契約条約》は本ユーザーのプライバシーポリシーには適用されず、明確に除外されます。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本政策更新日期：2026年1月1日。": "本プラットフォームは香港星橋國際貿易有限公司（https://aitaoify.com）によって運営されており、連絡先メールアドレス：liutaotao@taocarts.com、WeChat ID：zzsist666です。本ポリシーの更新日：2026年1月1日。",
    "Taoify 服务条款": "Taoify サービス条項",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 服务条款》（以下简称\"本服务条款\"），重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本服务条款约束。": "注意：Taoify プラットフォームの登録または利用を希望する場合は、《Taoify サービス条項》（以下「本サービス条項」という）を全文読み、厳格に遵守する必要があります。特に免責声明、責任制限、違反処置などの内容に注目し、自身の権利、義務、使用規則及び違反責任を明確に理解してください。プラットフォームで後続で導入されるすべての新機能、新ツールは、本サービス条項の拘束を受けます。",
    "Taoify有权不定期更新、修改本服务条款里的内容，有权在 Taoify 网站上发布更新和修改更新本服务条款。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify は本サービス条項の内容を定期的に更新、修正する権利を持ち、Taoify ウェブサイト上で更新と修正を発表することができます。最新版は一括してショッピングモールで公示されますので、定期的に条項の更新内容をご確認ください。条項の改訂内容に同意しない場合は、すぐにプラットフォームのすべてのサービスの使用を停止してください。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify用户隐私政策》。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "アカウント登録を完了することで、あなたはTaoify プラットフォームのすべての協定、条項、《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》を十分に理解し、自発的に受け入れることを表明します。Taoify プラットフォームのすべての協定、条項の内容に同意しない場合は、すぐに登録を停止してください。",
    "一、定义": "一、定義",
    "1、服务：Taoify 为您提供独立站搭建、店铺管理、订单收款、配套工具等建站经营服务，用于商户面向境外消费者销售商品、提供服务。": "1、サービス：Taoifyは独立サイトの構築、店舗管理、注文受付、関連ツールなどのサービスを提供し、事業者が海外の消費者向けに商品やサービスを販売するための支援を行います。",
    "2、用户或您：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织，包括但不限于商店所有者及\"员工账户\"下的用户。": "2、ユーザーまたはあなた：Taoifyプラットフォームに登録し、プラットフォームの各種サービスを利用している自然人、法人、その他の組織を指します。これには、店舗所有者および「従業員アカウント」下のユーザーが含まれます。",
    "3、平台：指Taoify 运营企业及平台软硬件系统、网站、服务端口等整体服务载体。": "3、プラットフォーム：Taoify運営企業とプラットフォームのソフトウェア・ハードウェアシステム、ウェブサイト、サービスポートなど全体的なサービスキャリアを指します。",
    "二、通用运营规则": "二、一般的な運用ルール",
    "1、Taoify 服务相关的技术支持仅对已完成注册的有效商户开放。": "1、Taoifyサービスに関連する技術サポートは、登録が完了した有効な事業者に対してのみ提供されます。",
    "2、因法律法规调整、服务优化、平台运营调整等，我方有权修订、增补本服务条款、用户使用协议、隐私政策等全部 Taoify 平台规则，亦有权调整或关停平台服务、终止您账户；服务终止不影响终止日前双方已产生的各项权利与义务。": "2、法令の変更、サービスの最適化、プラットフォームの運用調整等により、当方は本サービス条項、利用者使用契約、プライバシーポリシー等の全Taoifyプラットフォーム規則を改訂、追加する権利を持ち、またプラットフォームサービスを調整または停止し、あなたのアカウントを終了する権利も持っています。サービス終了は終了日前に生じた双方の権利と義務には影響を与えません。",
    "3、您认可并同意 Taoify 可以通过在商城发布相关的修正或新增的任何条款，修订提前1个工作日在平台公示，资费调整提前1个月公示，在网站公示后的七（7）日公示期后生效。如果您在公示期间没有提出异议或在生效日后继续使用服务即表示您同意并接受此修订版。": "3、あなたは商城で公開される改正または追加された条項を通じてTaoifyが改正することに同意し、改正は1営業日前にプラットフォームで公示され、料金調整は1ヶ月前に公示されます。ウェブサイトでの公示後7日間の公示期間後に効力が発生します。公示期間中に異議申し立てを行わなかった場合、または効力発生日以降に引き続きサービスを使用することで、あなたはこの改正版に同意し受け入れることを示しています。",
    "4、您不得将服务用于任何非法目的，您在使用本服务期间须严格遵守经营所在地、客户所在地及中华人民共和国全部现行法律法规（包括但不限于版权相关法律）。": "4、あなたは本サービスをいかなる違法目的にも使用してはならず、サービス利用期間中は経営地、顧客所在地及び中華人民共和国の全ての現行法令（著作権に関する法律を含むがこれらに限られない）を厳格に遵守しなければなりません。",
    "5、您须对本人名下 API 证书的使用行为承担全部责任，并妥善保管 API 证书，保障其使用安全。": "5、あなたは自身名義のAPI証明書の使用行為について全責任を負い、API証明書を適切に保管し、その使用安全を確保しなければなりません。",
    "6、未经 Taoify 书面许可，您不得对Taoify 平台、服务的任何部分进行任何形式的再生产、修改、编辑、破解、反编译、反向工程、拆解、改编、衍生开发等操作；不得修改源代码、默认模板、自带文档、功能模块、接口程序等与系统相关的任何内容；不得复制、销售、转售或以此牟利。": "6、Taoifyからの書面による許可がない限り、Taoifyプラットフォーム、サービスのどの部分に対しても再製造、修正、編集、クラック、逆コンパイル、逆エンジニアリング、分解、改作、派生開発等の操作を行うことはできません。ソースコード、デフォルトテンプレート、添付ドキュメント、機能モジュール、インターフェースプログラム等、システムに関連する内容を変更することはできません。また、複製、販売、転売またはそれらから利益を得ることも禁止されています。",
    "7、您不得注册、购买或使用包含 Taoify、Taoify 商标，以及该商标衍生变体、近似错拼词汇的域名；亦不得将前述相关词汇用于搜索引擎推广或其他按点击付费广告（如谷歌广告）。": "7、Taoify、Taoify商標、およびこれらの商標の派生形、類似の誤字の単語を含むドメインを登録、購入、または使用することはできません。また、上記の関連単語を検索エンジン広告またはクリック課金型広告（Google広告など）に使用することも禁止されています。",
    "8、有关本服务条款的任何问题，请发邮件到 liutaotao@taocarts.com。": "8、本サービス条項に関する質問は、liutaotao@taocarts.comまでメールでお問い合わせください。",
    "9、您知晓您的资料（不包括信用卡信息）可能未经加密转移，并涉及通过各种网络传输。": "9、あなたの情報（クレジットカード情報は除く）が暗号化されずに移転され、様々なネットワークを介して送信されることをご理解ください。",
    "10、平台有关条款（包括但不限于本服务条款等）可能会有除中文以外的其他版本。如果不同语言版本的服务条款之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本服务条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本服务条款，予以明确排除。": "10、プラットフォームの条項（本サービス条項を含むがこれらに限られない）には中国語以外の言語版がある場合があります。異なる言語版のサービス条項間に相違、不一致、または曖昧さがある場合は、中国語テキストが基準となり、他のテキストは参考用であり、中国語テキストの意味を抵触または変更するために使用することはできません。本サービス条項の締結、効力、解釈、履行及び紛争解決は、中華人民共和国法に基づき、国外の法的衝突規則は適用外となります。国連国際物品売買契約条約は本サービス条項には適用されず、明確に除外されます。",
    "11、本服务条款对双方、双方各自的继承人、权利义务承继人、合法受让方及法定代表人均具备约束力。Taoify 可无需向您发出通知、亦无需取得您同意，自行转让本服务条款项下全部权利义务。未经 Taoify 事先书面许可，您不得将本服务条款，或您在本协议项下享有的任何权利、承担的任何义务转让、变相转移予任何第三方。": "11、本サービス条項は両当事者、それぞれの相続人、権利義務承継者、合法的な譲受人及び法定代理人に対して拘束力を有します。Taoifyは通知なしに、またあなたの同意を得ることなく、本サービス条項に基づく全権利義務を譲渡することができます。Taoifyの事前の書面による許可がない限り、あなたは本サービス条項、または本契約に基づいて享有する権利、または負担する義務を第三者に譲渡または実質的に移転することはできません。",
    "12、若因任何事由致使本服务条款任一完整条款或条款部分内容无效，仅该条款或对应部分丧失效力，其余所有条款效力不受影响。": "12、何らかの理由により本サービス条項のいずれかの完全な条項または条項の一部が無効となった場合、その条項または対応する部分のみが効力を失い、他のすべての条項の効力には影響を与えません。",
    "13、无论您申请注销账号、还是平台因违规终止合作，本服务条款商业秘密保护约定、权责划分与损失赔偿规则、第三方服务风险兜底、知识产权相关约定、争议管辖与法律适用、费用结算、侵权赔付、数据合规相关全部条款仍具备法律效力，不受服务终止影响。": "13、アカウントの削除申請やプラットフォームによる違反による協力終了に関わらず、本サービス条項における商業秘密保護の約定、権利義務の分配と損害賠償の規定、サードパーティーサービスリスクの底割れ、知的財産権に関する約定、紛争管轄と法的適用、費用決済、侵害賠償、データコンプライアンスに関する全条項は依然として法的効力を有し、サービス終了の影響を受けません。",
    "三、账户管理规范": "三、アカウント管理規範",
    "1、您注册 Taoify 账号时必须提供合法完整姓名、现地址、电话号码、有效的电子邮件地址以及其他所需的任何信息。Taoify 有权基于任何理由拒绝您的账号申请或注销现有账户。": "1、Taoifyアカウントを登録する際には、合法かつ完全な氏名、現在の住所、電話番号、有効な電子メールアドレス、および必要なその他の情報を提供する必要があります。Taoifyは任意の理由でアカウント申請を拒否したり、既存のアカウントを削除することができます。",
    "2、您必须年满18岁或达到您使用本服务所在地或经营所在地的法定成年的年龄。": "2、あなたは18歳以上であるか、本サービスを使用する地域または事業を行う地域の法定成人年齢に達している必要があります。",
    "3、您承诺是为经营之商业目的使用Taoify 服务，不得将账号、店铺用于个人日常消费、家庭自用等非经营场景。": "3、Taoify サービスは営業目的でのみ使用することを約束し、アカウントや店舗を個人的な日常消費や家庭用などの非営業用途には使用しないでください。",
    "4、店铺的创建与运营过程中的全部负责由您自行承担。": "4、店舗の作成と運営に関連するすべての責任はあなたが負います。",
    "5、Taoify 仅提供独立站建站技术工具，不介入您与第三方之间的订单、售后、货款往来，您与第三方进行的直接交易，相关纠纷均与 Taoify 无关，我方不承担任何调解、赔付责任。": "5、Taoify は独立したウェブサイト構築技術ツールのみを提供し、あなたと第三者間の注文、アフターサービス、支払いに関する介入は行いません。直接取引による紛争は全て Taoify とは関係ありません。当方は調整や賠償の責任を負いません。",
    "6、您对账户内所有操作行为，以及账户内上传、收集、生成、存储、展示、分发、传输的全部内容（包括图片、视频、图文素材、音频、代码、信息、数据等）承担全部责任。": "6、アカウント内のすべての操作およびアップロード、収集、生成、保存、表示、配布、送信される全コンテンツ（画像、動画、テキスト素材、音声、コード、情報、データなど）について、あなたが全責任を負います。",
    "7、若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "7、ユーザーが本契約に違反したことにより、プラットフォームが第三者から請求、訴訟、仲裁を受けたり、行政機関から罰金、賠償命令を受けた場合、その全責任はユーザーが単独で負うものとします。ユーザーは、プラットフォームがこれによって生じる全直接的・間接的損失を十分に賠償しなければなりません。損失範囲には、プラットフォームが第三者に支払う賠償金、和解金、補償金、違約金；行政機関、司法機関が徴収する罰金、延滞金、訴訟費、仲裁費、保全費、執行費、鑑定費、評価費；プラットフォームが権利保護のために支出する弁護士費、公証費、調査費、旅費、保証料；プラットフォームの商誉損失、業務中断損失、得べくして得られなかった利益の損失、第三者からの追加賠償要求等、すべての関連費用が含まれます。",
    "四、账户管理": "四、アカウント管理",
    "1、Taoify 账户商店所有者": "1、Taoify アカウントの店舗所有者",
    "1.1 完成注册服务的用户将是商店所有者，并且将被授权使用我方提供给商店所有者的相关服务。您需保证营业执照、行政许可、审批、备案、资质等注册资料，在店铺页面清晰公示，供监管部门、消费者核验。": "1.1 登録サービスを完了したユーザーは店舗所有者となり、当方が店舗所有者に提供する関連サービスを利用することができます。営業許可証、行政許可、承認、登録、資格などの登録資料を店舗ページで明確に公開し、監督部門や消費者が確認できるようにしてください。",
    "1.2 若您代表第三方注册本服务，则第三方为商店所有者。您必须使用第三方名下或者指定的邮箱完成注册，同时声明并保证已取得第三方合法书面授权且有效，提交授权许可手续，明确已授权范围，包括但不限于授权注册、日常登录、授权认可并自愿接受Taoify 平台所有协议、条款等。": "1.2 第三者を代表して本サービスに登録する場合は、第三者が店舗所有者となります。第三者名義または指定されたメールアドレスを使用して登録し、第三者から合法的な書面による有効な許可を得ていることを宣言し、保証しなければなりません。許可手続きを提出し、許可範囲を明確に示す必要があります。これには、登録、日常的なログイン、Taoify プラットフォームのすべての契約や条項への同意などが含まれます。",
    "1.3 注册账户后，若您需在店铺内上架、展示、销售第三方品牌商品或服务，您须提前向平台提交品牌授权书、经销许可、使用许可等合法有效手续，并保证相关授权、许可持续有效。未按要求提供手续或授权失效的，平台有权下架对应商品、暂停服务直至终止账户，由此产生的全部法律责任与损失由您自行承担。": "1.3 アカウント登録後、店舗内で第三者ブランドの商品やサービスを販売する場合は、事前にプラットフォームにブランド許可書、販売許可、使用許可などの合法的な手続きを提出し、関連する許可やライセンスが継続的に有効であることを保証しなければなりません。必要な手続きを提供しない、または許可が無効になった場合、プラットフォームは対応する商品を削除し、サービスを停止し、アカウントを終了する権利を持ちます。これにより生じる全法的責任と損失はあなたが負います。",
    "1.4 一个 Taoify 商店只能有一名商店所有者，一名商店所有者可以有多家 Taoify 商店。\"商店\"表示与账户相关联的在线商店或者实体零售地点。": "1.4 一つの Taoify 店舗には一人の店舗所有者のみが存在し、一人の店舗所有者は複数の Taoify 店舗を持つことができます。「店舗」とは、アカウントに関連付けられたオンラインショップまたは実店舗を指します。",
    "2、员工账户": "2、従業員アカウント",
    "2.1 根据您订阅的 Taoify 套餐，您可以创建一个或多个员工账户，商店所有者必须设置权限，限制员工账户对业务数据、店铺功能的访问范围（例如限制查看销售报表、禁止修改店铺基础设置等）。": "2.1 あなたが購読する Taoify パッケージに基づいて、一つ以上の従業員アカウントを作成できます。店舗所有者は、従業員アカウントのビジネスデータや店舗機能へのアクセス範囲（例えば、売上レポートの閲覧制限、店舗基本設定の変更禁止など）を設定する必要があります。",
    "2.2 凡使用本平台为门店开立的员工账号所实施的全部行为，由此产生的一切法律责任、经济损失及相应后果，均由商店所有者承担；前述员工账号操作行为，视同商店所有者作出的行为。": "2.2 本プラットフォームを通じて開設された従業員アカウントを使用して行われるすべての行為により生じる法的責任、経済的損失、及びそれらに伴う結果は全て店舗所有者が負います。従業員アカウントによる操作は、店舗所有者が行ったものとみなされます。",
    "3、收款结算账户": "3、収款決済アカウント",
    "3.1 注册成功后，Taoify 将提供多家支付服务商供您进行选择。您可以从中选择收取顾客款项的渠道。": "3.1 登録成功後、Taoify は複数の支払いサービスプロバイダーを選択できるよう提供します。お客様は、これらのプロバイダーから顧客からの支払いを受けるチャネルを選択することができます。",
    "3.2 您须自行负责注册、激活及维护收款账户，自行承担收款账户需承担费用。如果您不再需要这些收款账户，您须自行关停账户。支付服务商属于本服务条款中的第三方服务。": "3.2 収款アカウントの登録、アクティベーション、メンテナンスはあなた自身で行い、収款アカウントに関連する費用も自己負担となります。収款アカウントが必要なくなった場合は、自分でアカウントを停止する必要があります。支払いサービスプロバイダーは本サービス条項における第三者サービスです。",
    "3.3 您在店铺内使用收款账户，即视为您同意遵守对应支付服务商的服务条款与规则；支付服务商可随时修订条款，修订内容一经公示即刻生效。若您在条款修订公示完成后，继续使用店铺收款账户开展业务操作，即代表您认可并完全接受修订后的全部条款内容。若您不认可条款变更，须立即注销收款账户，并停止使用该支付服务。": "3.3 店舗内で収款アカウントを使用することは、対応する支払いサービスプロバイダーのサービス条項と規則に同意したものとみなされます。支払いサービスプロバイダーはいつでも条項を改訂でき、改訂内容は公示され次第即時に効力を発揮します。改訂後の条項が公示された後も引き続き店舗収款アカウントを使用する場合は、改訂後の全条項を認識し完全に受け入れることを意味します。条項の変更に同意しない場合は、直ちに収款アカウントを解約し、該当する支払いサービスの使用を停止する必要があります。",
    "五、Taoify权利": "五、Taoifyの権利",
    "1、我方保留随时修改、暂停、终止全部或部分平台服务的权利，且无需提前通知用户。部分服务、功能并非在所有国家/地区使用，我方无义务在任意区域提供指定服务。": "1、当社はいつでもプラットフォームのサービスを全部または一部を修正、一時停止、終了する権利を持ち、ユーザーへの事前通知は不要です。すべてのサービスや機能がすべての国/地域で利用可能であるとは限らず、当社には特定のサービスを任意の地域で提供する義務はありません。",
    "2、Taoify 拥有自主选择权，保留拒绝向任意主体提供平台服务的权利。": "2、Taoify は独自の裁量で、任意の主体に対してプラットフォームのサービスを提供しない権利を留保します。",
    "3、如果我方判定店铺提供的商品或服务或者发布到店铺的资料违反了 Taoify 的协议，包括但不限于《Taoify 用户使用协议》《Taoify用户隐私政策》、本服务条款等，我方有权要求整改、删除违规内容、暂停或永久终止全部服务，用户已缴纳的所有费用不予退还。": "3、当社が店舗が提供する商品またはサービス、または店舗に投稿された資料が Taoify の契約（《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》、本サービス条項など）に違反していると判断した場合、当社は是正を求め、違反内容の削除、サービスの一時停止または永久的な終了を行うことができます。ユーザーが既に支払った費用は返金されません。",
    "4、凡以口头、书面其他任何形式辱骂 Taoify 客户、员工、工作人员，或打击报复类威胁言论的，其账户将被立即永久终止使用，用户已缴纳的所有费用不予退还。": "4、口頭、書面、その他の形式で Taoify の顧客、従業員、スタッフに対する罵詈雑言、または報復の脅しを行うアカウントは、直ちに永久的に使用停止となります。ユーザーが既に支払った費用は返金されません。",
    "5、平台内容由您负责、承担责任，Taoify 不预先审核用户发布内容，我方有权自行裁量，单方拒绝展示或删除平台内任意内容，Taoify 无提前告知义务。": "5、プラットフォームのコンテンツはユーザーが責任を持ちます。Taoify はユーザーが投稿するコンテンツを事前に審査しませんが、独自の裁量でプラットフォーム内の任意のコンテンツの表示を拒否したり削除したりする権利を持ち、事前の通知は不要です。",
    "6、Taoify 可向您的同业竞争者提供服务，不向任何用户授予细分市场独家合作权益。您确认并同意，Taoify 的合作方及员工均有可能成为 Taoify 平台客户或入驻，前述主体可能与您开展同业竞争，但严禁擅自使用您保密信息。": "6、Taoify は競合他社に対してもサービスを提供することができます。どのユーザーにも市場独占の権利は与えられません。あなたは、Taoify のパートナーおよび従業員が Taoify プラットフォームの顧客または入居者となり、あなたと競合する可能性があることを確認し同意しますが、あなたの機密情報の不適切な使用は禁止されています。",
    "7、若就商店所有者权属产生争议，我方有权要求相关方提交权属证明文件，包括但不限于营业执照扫描件、政府机关核发的有效身份证件、信用卡后四位卡号、在职证明等资料。": "7、店舗所有権に関する争いが発生した場合、当社は関係者に対して所有権証明書（営業許可証のスキャンコピー、政府機関から発行された有効な身分証明書、クレジットカードの下4桁、在職証明などの資料）の提出を求めることができます。",
    "8、依据现有材料，我方有权判定账户的商店所有者，并有权根据我方的单方判断将账户转让给商店所有者，若您有异议，请及时提出转让异议。如果我方无法判定账户合法所有者或者收到转让异议，Taoify 有权临时冻结该账户，直至争端双方直至争议各方达成纠纷解决方案。": "8、現在の資料に基づいて、当社はアカウントの店舗所有者を判定し、独自の判断でアカウントを店舗所有者に移転することができます。異議がある場合は、すぐに移転異議を提出してください。当社がアカウントの合法的な所有者を判定できない場合、または移転異議を受け取った場合、Taoify はアカウントを一時的に凍結し、争端当事者が紛争解決策に達するまで維持することができます。",
    "9、Taoify平台无需就您遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "9、Taoify プラットフォームは、あなたが被った直接的または間接的な損失、評判の損失、期待利益の損失、営業利益の損失等について、いかなる賠償責任も負いません。",
    "10、若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "10、法定またはその他の理由により Taoify が賠償責任を負うべき場合、Taoify がユーザーに対して負う累積賠償責任（違約金、賠償金、権利保護費を含む）の上限は、損失事件が発生した対応するサービス期間中に、あなたが実際に Taoify に支払ったサービス料金の総額となります。請求理由の数や損失額に関わらず、合計賠償額はこの上限を超えることはありません。",
    "六、责任限制": "六、責任制限",
    "1、您保证符合合法经营资质（包括但不限于营业执照、行政审批等）、保证商品质量合格、保证图文与实际物品规则、质量、功能等一致，不存在虚假宣传、不正当竞争等；": "1、あなたは合法的な経営資格（営業許可証、行政承認などを含む）、商品品質の適合性、図文と実際の物品の規則、品質、機能等の一貫性、虚偽の宣伝、不当な競争がないことを保証します；",
    "2、在现行法律允许的最大范围内，因平台服务无法使用、系统故障产生的各类经营损失，平台及服务商均无需承担赔偿，包括经营收入减少、客户流失、品牌口碑受损、数据丢失、预期收益下滑等各类直接、间接经济损耗与衍生损失。": "2、現行法で許される最大限の範囲内で、プラットフォームサービスの利用不能、システム障害による各種の経営損失については、プラットフォーム及びサービスプロバイダーは賠償責任を負いません。これには、収益減少、顧客の流出、ブランド評判の低下、データの喪失、期待利益の低下等の直接的・間接的な経済的損失と派生的な損失が含まれます。",
    "3、若您存在违反本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》、违反法律法规或侵害第三方合法权益的行为，您须保障 Taoify及其关联主体、合作方、员工及供应商免受一切索赔追责，并须全额赔付 Taoify 及其关联方、合作方、员工、供应商遭受的全部损失、诉讼费、律师费。": "3、あなたが本サービス条項、《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》、法律法規、または第三者の正当な権利を侵害する行為を行った場合、あなたは Taoify 及びその関連主体、パートナー、従業員、サプライヤーを一切の請求から守り、Taoify 及びその関連方、パートナー、従業員、サプライヤーが被った全損失、訴訟費、弁護士費を全額賠償しなければなりません。",
    "4、您使用本服务需要自担风险。平台以\"现状\"提供服务，不作出任何书面、口头经营收益、系统稳定类承诺。": "4、あなたは自己のリスクで本サービスを利用します。プラットフォームは「現状」でサービスを提供し、経営収益、システム安定性に関する書面または口頭での約束は一切行いません。",
    "5、Taoify 不保证服务及时、安全、零差错、不间断运行。": "5、Taoify はサービスがタイムリー、安全、エラー無く、中断なく動作することを保証しません。",
    "6、Taoify 不保证使用本服务所输出、取得的结果具备准确性与可靠性。": "6、Taoify は本サービスを通じて得られる結果の正確性と信頼性を保証しません。",
    "7、因您使用本服务产生的全部税费缴纳义务，均由您自行承担并缴纳，Taoify 不承担任何相关责任。": "7、本サービスの利用によって発生する全ての税金の納付義務は、あなたが自ら負担し、支払います。Taoify はこれに関連する責任を負いません。",
    "8、Taoify 不保证平台产品、服务、信息符合您的预期，亦无义务修复服务内全部漏洞、差错。": "8、Taoify はプラットフォームの製品、サービス、情報があなたの期待に適合することを保証せず、またサービス内の全ての欠陥や誤りを修正する義務もありません。",
    "七、知识产权约定": "七、知的財産権の取り決め",
    "1、您上传至 Taoify 服务平台的图片、文案、商标、素材知识产权、所有权归您所有，您须保证上传图片、文案、商标、素材不侵犯任何第三人知识产权等权益，须确保前述内容符合全部法律法规。您可随时注销账户，同步清除其 Taoify 店铺内全部相关素材，清除后即无法恢复。": "1、Taoifyサービスプラットフォームにアップロードした画像、文章、商標、素材の知的財産権と所有権はお客様に帰属します。アップロードする内容が第三者の知的財産権を侵害しないことを保証し、法規制に適合していることを確認してください。アカウントをいつでも削除でき、同時にTaoify店舗内の関連素材もすべて削除されます。削除後は復元できません。",
    "2、您上传内容即视为同意下述约定：2.1 允许其他主体免费查阅您上传至 Taoify 店铺的全部内容；2.2 就您公开发布的内容，授予 Taoify 存储、免费展示及免费使用该等内容；2.3 Taoify 有权核查、删除您上传至本平台服务的任意内容，但并无开展前述操作的强制性义务。2.4 Taoify可免费使用与您店铺相关的商号、注册商标、服务标识及品牌标识，用于推广、宣传 Taoify 平台服务。": "2、コンテンツをアップロードすることで以下の約束に同意したことになります：2.1 他のユーザーが無料でTaoify店舗にアップロードされた全内容を閲覧できるようにすること；2.2 公開された内容については、Taoifyが保存、無料表示、無料使用を行う権利を付与すること；2.3 Taoifyはプラットフォームサービス上にアップロードされた任意のコンテンツを確認または削除する権利を持ちますが、その義務はありません。2.4 Taoifyは、お客様の店舗に関連する商号、登録商標、サービスマーク、ブランドマークを無料で使用し、Taoifyプラットフォームサービスのプロモーションや宣伝に利用することができます。",
    "3、平台系统、程序（包括但不限于源代码、框架、设计、文档）、界面、官方文档等所有知识产权归平台所有，未经书面授权不得复制、传播、二次开发。": "3、プラットフォームシステム、プログラム（ソースコード、フレームワーク、デザイン、ドキュメントを含む）、インターフェース、公式ドキュメント等の全ての知的財産権はプラットフォームに帰属します。書面による許可なく複製、配布、二次開発することは禁止されています。",
    "八、商品发货与物流规则": "八、商品発送と物流ルール",
    "对于您Taoify商铺所售出的商品，您可以在发货时选择联系第三方承运商提供商处购买运输标签。商品发货、物流运输相关事宜、费用、风险均由您自行负责，Taoify不承担任何责任。": "Taoifyショップで販売された商品について、発送時にサードパーティの運送業者から配送ラベルを購入することができます。商品の発送、物流に関する事項、費用、リスクはすべてお客様自身の責任となります。Taoifyはこれらについて一切の責任を負いません。",
    "九、商店主题规范": "九、店舗テーマ規範",
    "1、平台提供的店铺模板页面可展示平台官方标识；如模板内页面内容违反平台各项管理规则，平台有权单方面调整页面内容，无义务提前通知商家，但平台无开展前述操作的强制性义务。": "1、プラットフォームが提供する店舗テンプレートページにはプラットフォームの公式ロゴを表示できます。テンプレート内ページの内容がプラットフォームの管理規則に違反する場合、プラットフォームは一方的にページ内容を調整する権利を持ちますが、事前に通知する義務はありません。ただし、このような操作を行う強制的な義務はありません。",
    "2、平台主题模版的知识产权仍属于设计者。您仅可在授权范围内使用；若超出授权范围使用，设计者可依法追责，平台亦有权修改店铺内容或关停账户，不利后果由您承担，Taoify 不承担任何责任。": "2、プラットフォームテーマテンプレートの知的財産権はデザイナーに帰属します。お客様は認証された範囲内でしか使用できません。認証範囲を超えて使用した場合、デザイナーは法的に追及することが可能であり、プラットフォームも店舗内容を修正またはアカウントを停止する権利があります。不利な結果はお客様が負担し、Taoifyは一切の責任を負いません。",
    "3、技术支持工作由设计者负责，Taoify 不承担提供此类支持的责任，但 Taoify 可帮助您联系设计者。": "3、技術サポートはデザイナーが担当します。Taoifyはこの種のサポートを提供する責任はありませんが、デザイナーとの連絡を手助けすることは可能です。",
    "4、您安装新模板时，必须自行做好数据备份，Taoify 无备份义务。因安装模板导致原有主题、界面、数据等内容损坏的，Taoify 不承担赔偿责任。": "4、新しいテンプレートをインストールする際は、データバックアップを自分で行う必要があります。Taoifyはバックアップの義務はありません。テンプレートのインストールにより既存のテーマ、インターフェース、データなどが損傷した場合、Taoifyは賠償責任を負いません。",
    "十、费用支付规则": "十、料金支払い規則",
    "1、您必须向我方提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1、有効かつ利用可能な支払い方法を提供していただく必要があります。これにより、引き落とし失敗による店舗使用への影響を避けることができます。複数のクレジットカードを登録し、自動支払いを許可することをお勧めします。請求処理の技術はサードパーティの専門金融会社によって提供されます。",
    "5、订阅费用采用预付制，系统将在服务到期前5个自然日自动发起续费扣款。例：服务到期时间为2022-01-06 23:59:59，则预计续费扣费时间为2022-01-01 23:59:59。": "5、サブスクリプション料金は前払い制です。サービス終了前の5日間以内に自動的に更新料金の引き落としが行われます。例：サービス終了日が2022-01-06 23:59:59の場合、予定される更新料金の引き落とし日は2022-01-01 23:59:59です。",
    "6、我方提前30日发出服务费用变更通知后即可调整服务收费标准，我方可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "6、当方はサービス料金の変更について30日前に通知します。通知はプラットフォーム公式ウェブサイトやお客様の店舗管理ページを通じて行われます。",
    "7、我方不会就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "7、サービスのいかなる変更、価格変動、一時停止または終了について、お客様または第三者に対して当方は一切の責任を負いません。",
    "8、若我方无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。我方每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，我方有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "8、認証済みの銀行カードからサブスクリプション料金の引き落としができない場合、オーナーにメールで通知し、支払いカード情報を更新するよう促します。24時間ごとに最大3回（初回を含む）引き落としを試みます。3回目の引き落としも失敗した場合、当方はお客様のアカウント使用権限を一時停止および制限する権利があります。未払い分と次の課金期間のサブスクリプション料金を支払った後、アカウントは正常にアクセス可能になります。",
    "9、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "9、サービス期間満了前にサブスクリプション料金を更新しない場合、サービスは自動的に終了します。サービス終了から10日経ってもサブスクリプション料金を更新しない場合、Taoifyプラットフォームはウェブサイト上の全データを削除する権利を持ちます。関連する損失はユーザーが自己負担します。",
    "10、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本服务条款中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向我方提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "10、Taoifyが独自に徴収するプラットフォームサービス料には、各種政府が徴収する税金、規費、その他の料金（本サービス条項では「税金」）は含まれていません。プラットフォームサービス料以外に、Taoifyの製品・サービスの購入・サブスクリプションにより生じる適用される全税金は、お客様が自己負担します。税金はお客様が提供した請求先住所に基づく税率で計算され、認証済みの支払いカードから自動的に引き落とされます。免税資格がある場合は、有効な免税証明書を提出してください。一部の司法管轄区域では、地元の法規制に準拠した公式証明書が必要となる場合があり、免税政策は資料審査通過日から適用されます。Taoifyが関連税金を代わりに計算・納付していない場合、お客様は自らの納税義務を判断し、税務当局へ申告・納税を行う必要があります。",
    "11、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本服务条款约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "11、Taoifyが代わりに徴収し税務当局に納付する税金以外、法律で規定される各種税金の控除、源泉徴収義務はすべてお客様が自己負担し、対応する税務機関へ単独で納付しなければなりません。これらの税金控除または源泉徴収要件が存在するかどうかに関わらず、Taoifyは本サービス条項に基づき、お客様が認証した支払いカードから全額の支払いを引き落とす権利を持ちますが、Taoifyには積極的に引き落とす義務はありません。",
    "12、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "12、お客様の店舗運営活動によって生じる全適用税金は、お客様が自己負担し、法に基づいて納税する必要があります。",
    "十一、保证金支付": "十一、保証金の支払い",
    "1、您完成 Taoify 账户注册时，须一次性足额缴纳经营保证金1000元。": "1、Taoifyアカウントの登録が完了した際、一括で営業保証金1000元を全額納める必要があります。",
    "2、保证金仅用于担保您履行本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》等全部 Taoify 平台规则、全部义务，不能抵扣服务费用、税费。": "2、保証金は本サービス条項や《Taoify ユーザー使用協定》《Taoifyユーザープライバシーポリシー》など、すべてのTaoifyプラットフォームルールと義務を担保するためのものであり、サービス料金や税金の支払いには充当できません。",
    "3、若您出现商品质量违规、虚假宣传、侵害消费者权益、侵权、行政处罚、违约欠款、第三方索赔、产生赔付款项、依据平台规则须向我方赔偿等情形，您同意我方有权直接从您已缴纳的保证金中抵扣对应赔偿金、罚款、欠款、维权支出、律师费、诉讼费等全部应付费用。保证金经抵扣后余额不足约定标准金额的，您须在我方发出补缴通知后3个自然日内补足差额，恢复保证金足额标准；逾期未足额补缴的，Taoify 有权暂停店铺全部经营功能、限制账户操作，直至保证金足额补齐。": "3、商品の品質違反、虚偽の宣伝、消費者権利侵害、権利侵害、行政罰、債務不履行、第三者からの請求、賠償金発生、プラットフォームルールに基づく当社への賠償等の場合、当社は既に納めた保証金から対応する賠償金、罰金、未払い金、権利保護費用、弁護士費、訴訟費などの全額を直接控除することに同意します。保証金が控除後不足する場合、補填通知から3日以内に差額を補充し、保証金の全額を回復しなければなりません；期限内に足りない分を補充しない場合、Taoifyは店舗の全機能を停止し、アカウント操作を制限する権利があります。",
    "4、在您主动申请注销账户、结清全部欠款、无未了结客诉、质量纠纷、行政处罚、侵权索赔后，我方将无息退还剩余保证金。存在未结清赔付、纠纷、处罚的，平台有权扣除对应款项后再无息退还剩余部分，不足部分平台保留向您追偿的权利。保证金不产生任何利息，我方无义务为保证金支付利息。": "4、自発的にアカウントの削除を申請し、全ての未払い金を清算し、未解決の客訴、品質紛争、行政罰、権利侵害請求がない場合、当社は残高の保証金を利息なしで返還します。未解決の賠償、紛争、罰金がある場合、プラットフォームは対応する金額を控除後に残りを無利息で返還します。不足分については、プラットフォームは追徴する権利を留保します。保証金には利息は発生せず、当社は保証金に対する利息支払いの義務はありません。",
    "十二、账户注销与服务终止": "十二、アカウントの削除とサービス終了",
    "1、服务期内您主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "1、サービス期間中に自発的にサービス終了を申請する場合、1ヶ月前までに書面でTaoifyプラットフォームへ通知する必要があります；既に支払った費用は返金されません；ユーザーが一方的に協定を終了することでTaoifyプラットフォームに損失を与えた場合、直接的・間接的な損失、弁護士費などを含む損害賠償を行う必要があります。",
    "2、您在暂停使用、注销账户或终止服务前，须自行备份留存账户内全部数据，Taoify 无义务保管您账户相关数据资料。": "2、アカウントの利用停止、削除またはサービス終了前に、アカウント内の全データをバックアップして保存する必要があります。Taoifyはあなたのアカウントに関連するデータの保管義務はありません。",
    "3、无论因何种事由任意一方终止本服务，Taoify 将即刻停止提供服务，您亦无法继续登录使用账户。除本服务条款另有约定外，您已缴纳费用不再退还。您因使用平台服务所欠付 Taoify 的全部款项立即届至清偿期，须一次性全额付清，同时您的 Taoify 店铺将被关停下架。": "3、何らかの理由によりいずれかの当事者が本サービスを終了する場合、Taoifyは即座にサービス提供を停止し、あなたもアカウントにログインできなくなります。本サービス条項に別段の定めがない限り、既に支払った費用は返金されません。プラットフォームサービス利用によるTaoifyに対する全額の未払い金は直ちに支払い期日を迎え、一括で全額支払う必要があります。同時に、あなたのTaoify店舗は閉鎖されます。",
    "4、服务终止后，与域名相关的全部事宜由您自行对接域名服务商处理。": "4、サービス終了後、ドメインに関する全ての事項は、あなた自身がドメインサービスプロバイダーと対応する必要があります。",
    "5、服务终止当日，若您存在未结清款项，我方将通过邮件向您发送最终账单，我方不再另行收取任何费用，也不再提供任何服务。": "5、サービス終了当日、未払い金がある場合、最終的な請求書をメールでお送りします。これ以上の費用は発生せず、サービスも提供されません。",
    "6、服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "6、どのような理由であれサービスが終了した場合、店舗運営に関する全資料（注文記録、商品資格、購入販売契約、ブランド認証、物流証明、顧客取引台帳、品質検査報告など）を完全に保存し、自己で備案する必要があります。当方はこれらの資料の保管、整理、備案の義務はありません。",
    "7、即便服务终止，若您销售的商品、提供的服务存在质量缺陷、侵权、售后纠纷、行政处罚、消费者索赔等全部问题，相关法律责任、赔偿责任、整改义务仍全部由您独立承担，我方不承担任何责任。": "7、サービス終了後でも、販売商品や提供サービスの品質欠陥、権利侵害、アフターサービス紛争、行政罰、消費者請求など全ての問題について、関連する法的責任、賠償責任、改善義務は全部あなたが独立して負担し、当方は一切の責任を負いません。",
    "8、如果我方怀疑您涉嫌任何欺诈行为（通过判决、和解、保险、托管调查或其他方式），我方有权暂停或终止您的账户，且我方可采取任何其他补救措施。": "8、あなたが詐欺行為に関与していると疑われる場合（判決、和解、保険、エスクローアンケートその他の方法を通じて）、当方はあなたのアカウントを一時停止または終了する権利があり、その他の救済措置を講じることができます。",
    "十三、第三方工具、支付服务商规则": "十三、サードパーティツール、支払いサービスプロバイダールール",
    "1、Taoify可提供并开放第三方软件、应用程序、产品、服务接口及网站链接（前述统称\"第三方服务\"，下同），您自主选择开通使用，您与第三方服务商形成独立合作关系，平台不参与双方权利义务约定，不对第三方产品做背书或质量担保，不存在联营、隶属合作关系。": "1、Taoifyはサードパーティソフトウェア、アプリケーション、製品、サービスインターフェース、ウェブサイトリンク（以下、「サードパーティサービス」と総称します）を提供し開放します。これらは自主的に選択して使用できます。あなたとサードパーティサービスプロバイダーとの間には独立した協力関係が形成され、プラットフォームは両者の権利義務の約定には参加せず、サードパーティ製品の背書や品質保証を行わず、共同経営や所属関係も存在しません。",
    "2、对于使用第三方服务产生的风险，由您自行承担，您在使用第三方服务前先阅读第三方隐私政策、服务条款。Taoify 会从第三方服务提供商处获得收益份额，但该收益获取行为不代表 Taoify 需对第三方服务承担任何担保、赔偿等相关责任。": "2、サードパーティサービスを使用することで生じるリスクは、あなた自身が負います。サードパーティサービスを使用する前に、サードパーティのプライバシーポリシーとサービス条項を読んでください。Taoifyはサードパーティサービスプロバイダーから収益を得ることがありますが、これはTaoifyがサードパーティサービスに対して何らかの保証や賠償責任を負うことを意味しません。",
    "3、Taoify有权自主决定随时限制、关闭第三方服务访问权限，且无需提前通知；因暂停或禁用第三方服务产生的一切损失，Taoify 不向任何主体承担责任。第三方服务仅作参考，不可替代专业咨询。": "3、Taoifyは独自の判断でいつでもサードパーティサービスへのアクセスを制限または閉鎖する権利を持ち、事前の通知は必要ありません。サードパーティサービスの中断または禁止によって生じるすべての損失について、Taoifyはいかなる主体に対しても責任を負いません。サードパーティサービスは参考情報としてのみ使用され、専門的な助言の代替とはなりません。",
    "4、您绑定第三方工具并开启数据互通后，第三方可读取对应店铺经营数据，您与第三方之间的数据交互仅约束双方数据传输，存储风险由您自行承担，平台不会为第三方的数据泄露、篡改行为承担赔偿责任。": "4、サードパーティツールをバインドしデータ連携を開始すると、サードパーティは対応する店舗の運営データを読み取ることができます。あなたとサードパーティ間のデータ交換は両者のデータ転送に限定され、保存リスクはあなた自身が負います。プラットフォームはサードパーティによるデータ漏洩や改ざんについて賠償責任を負いません。",
    "5、Taoify 有权直接或间接获取您与第三方服务商往来的全部邮件内容。Taoify 可向第三方服务商披露、共享您提交的联络方式及相关背景资料。": "5、Taoifyは直接または間接的にあなたとサードパーティサービスプロバイダーとの間のメール内容全体を取得する権利があります。Taoifyはサードパーティサービスプロバイダーにあなたの連絡先情報および関連背景情報を開示または共有することができます。",
    "6、因第三方或您与第三方服务商合作关系引发的一切直接、间接以及其他损失，Taoify 均不承担任何赔偿责任。即便提前告知风险，该免责条款仍有效。": "6、第三者またはあなたと第三者サービスプロバイダーとの関係によって生じるすべての直接的、間接的、その他の損失について、Taoifyは一切の賠償責任を負いません。事前にリスクを通知した場合でも、この免責条項は有効です。",
    "7、您与第三方产生纠纷引发平台被起诉、索赔、行政处罚的，您需全额赔偿平台全部损失、维权开支，保障平台各方不受追责。": "7、あなたと第三者との間に紛争が生じ、それがプラットフォームが訴訟や賠償請求、行政処分を受ける原因となった場合、あなたはプラットフォームの全損失と権利擁護費用を全額賠償し、プラットフォームに関わる全ての当事者が追及を受けないようにする必要があります。",
    "十四、内测Beta功能规则": "十四、ベータ機能のルール",
    "1、平台不定期定向邀请商户体验未正式上线的Beta内测功能，内测使用需同步遵守单独下发的内测补充规则。内测相关资料、沟通记录属于平台保密信息，适用本条款保密有关约定。": "1、プラットフォームは定期的に特定の商家に未公開のベータ機能を体験するための招待を行います。ベータテスト中は別途提供される追加規則も遵守する必要があります。ベータテストに関する資料やコミュニケーション記録はプラットフォームの機密情報であり、本条項の機密保持に関する規定が適用されます。",
    "2、未经平台书面许可，商户不得在任何社交平台等渠道发布内测截图、功能细节等与内测有关的内容，禁止向任何第三方泄露内测相关内容。": "2、プラットフォームからの書面による許可がない限り、商家はソーシャルメディアなどのチャネルでベータテストのスクリーンショットや機能詳細など、ベータテストに関連する情報を公開したり、第三者に漏らしたりすることは禁止されています。",
    "3、Taoify不对Beta测试服务的功能作出任何明示或默示陈述或保证。内测功能不代表最终上线版本，平台有权根据开发需求调整、下线甚至永久放弃该功能上线；商家自愿参与测试产生的店铺故障、经营损耗等全部风险由商家自行承担，平台不提供补偿或赔付。": "3、Taoifyはベータテストサービスの機能について、明示的または黙示的な表明または保証を行いません。ベータテスト中の機能は最終リリース版を代表するものではなく、開発の必要性に基づき調整、削除、さらには永久的にリリースを見送ることがあります；商家が自発的にテストに参加することで生じた店舗の障害や経営上の損失等の全リスクは商家が自己責任で負担し、プラットフォームは補償または賠償を行いません。",
    "十五、商户评价规范": "十五、商家評価の規範",
    "1、Taoify 欢迎您提交功能优化创意、经营改进建议、第三方工具评价。您向 Taoify 提供的全部创意、建议、配套资料、评价，Taoify 无需保密，无需向您支付任何报酬或补偿。您主动提交反馈、公开评价，即同意Taoify 无偿参考、落地优化相关方案，可按需修改后商用。": "1、Taoifyは機能改善のアイデア、経営改善提案、第三者ツールの評価をお待ちしております。あなたがTaoifyに提供する全てのアイデア、提案、関連資料、評価については、Taoifyは機密保持の義務を負わず、報酬または補償を支払う必要はありません。あなたが自主的にフィードバックを提出し、公開評価を行うことで、Taoifyは無償でそれらを参考にし、必要に応じて修正して商用化することができます。",
    "2、您向 Taoify 提交的所有评论，均须如实撰写，不得包含违法、低俗色情、恐吓、诽谤、侵害知识产权以及其他损害第三方权益、引人不适的内容。Taoify有权自主删除违规评价，但无必须开展删除、编辑操作的义务；同时 Taoify 不承担定期核查用户已发布反馈内容的责任。": "2、Taoifyに提出する全てのコメントは、真実に基づいて書くことが求められます。違法、下品な内容、脅迫、誹謗中傷、知的財産権侵害、その他第三者の権利を侵害する、または不快感を与えるような内容を含んではなりません。Taoifyは独自の判断で違反する評価を削除することができますが、削除または編集を行う義務はありません。また、Taoifyはユーザーが投稿したフィードバック内容を定期的に確認する責任を負いません。",
    "十六、第三方权利限制": "十六、第三者の権利制限",
    "除Taoify、Taoify关联企业、注册商户、合法权利受让方以外，未参与本协议签约的自然人、企业，无权依据本条款向平台主张任何权利，不能要求平台强制履行协议约定。": "Taoify、Taoifyの関連企業、登録商家、正当な権利譲渡先以外の自然人または企業は、本契約に署名していないため、本条項に基づいてプラットフォームに対して何らかの権利を主張することはできません。つまり、プラットフォームに対して契約履行を強制することはできません。",
    "十七、隐私和数据保护": "十七、プライバシーとデータ保護",
    "Taoify 非常重视对您的个人信息的隐私保护，您使用平台服务即认可平台按照《隐私政策》收集、存储、使用客户个人信息。若商户面向欧盟经济区消费者经营、向欧盟客户销售商品、需要遵守 GDPR 法规，双方另行签署《数据处理补充协议》规范跨境数据传输行为。": "Taoifyはあなたの個人情報のプライバシー保護を非常に重視しています。プラットフォームのサービスを使用することにより、《プライバシーポリシー》に基づいてお客様の個人情報が収集、保管、使用されることに同意したことになります。商家がEU経済圏の消費者向けに事業を展開し、EUのお客様に商品を販売し、GDPR規則を遵守する必要がある場合、両者は別途《データ処理補足協定》を締結し、クロスボーダーでのデータ転送行為を規範化します。",
    "十八、商业秘密保护": "十八、ビジネスシークレットの保護",
    "1、商业秘密：指双方获取、接触到的对方未对外公开的经营与技术资料，涵盖客户资源、潜在客户联系方式、产品研发方案、定价体系、经营成本、营销方案、内部运营流程、专属技术方案、未对外公示财务数据等一切具备商业价值的非公开资料，无论资料是否标注\"保密\"字样。平台内部运维方案、系统安全机制等内部资料同样属于平台商业秘密。": "1、ビジネスシークレット：これは、双方が取得または接触した、相手方が外部に公開していない経営および技術資料を指し、顧客リソース、潜在的な顧客の連絡先、製品開発計画、価格体系、経営コスト、マーケティングプラン、内部運営フロー、専門技術案、非公開の財務データなどを含みます。「機密」のラベルが付いていなくても、これらの情報はすべて商業価値を持つ非公開情報として扱われます。プラットフォームの内部運用計画やシステムセキュリティメカニズムなどの内部資料もプラットフォームのビジネスシークレットに含まれます。",
    "2、保密义务要求：仅能基于履行本协议约定经营事项使用对方商业秘密，同时采取与自身内部保密同等力度的防护手段，严防商业秘密泄露、复制、擅自对外流转：2.1 仅允许岗位必需员工接触涉密资料，并通过内部制度约束员工保守商业秘密；2.2 如收到法院、监管机关强制调取涉密资料的通知，在法律允许范围内第一时间书面告知资料持有方，并尽可能缩小信息披露范围。": "2、機密保持義務：本契約に基づく業務遂行のためにのみ相手方のビジネスシークレットを使用し、自社内の機密保持と同じレベルの保護措置を講じ、ビジネスシークレットの漏洩、複製、勝手な外部への流出を厳しく防ぐこと：2.1 必要な職位の従業員のみが機密情報を扱うことを許可し、内部制度を通じて従業員がビジネスシークレットを守るように管理します；2.2 法院または監督機関から機密情報を提出するよう命じられた場合、法律で認められる範囲内でできるだけ早く情報保有者に書面で通知し、情報開示の範囲を可能な限り狭めます。",
    "3、豁免保密责任情形：3.1 在接触时已全网公开，或注册平台前就已合法持有该信息；3.2 合作方完全依靠自有资源、不参考对方涉密资料独立研发得到同类信息；3.3 合作方从无违约第三方渠道合法取得该信息，且该第三方不存在保密违约行为。": "3、機密保持責任免除の状況：3.1 接触時点で既にインターネット上で公開されていた情報、またはプラットフォーム登録前から合法的に所有していた情報；3.2 協力者が完全に自社の資源を基に、相手方の機密情報を参照せずに独立して得た同種の情報；3.3 協力者が契約違反のない第三者から合法的に取得した情報であり、その第三者が機密保持違反をしていない場合。",
    "十九、争议解决规则": "十九、紛争解決ルール",
    "1、本服务条款为本平台主协议；《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议均为该主协议补充文件，整套文件共同构成您与平台完整约定。若任一补充文件条款与本主协议内容存在冲突、不一致，一律以本服务条款约定为准。针对本主协议未作出细化、未明确约定的事项，以《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议约定内容为准。": "1、本サービス条項は当プラットフォームの主要契約です；《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》などの他の協定はこの主要契約の補完文書であり、一連の文書全体があなたとプラットフォームとの完全な合意を構成します。補完文書のいずれかの条項が本主要契約の内容と矛盾または一致しない場合、常に本サービス条項の規定が優先されます。本主要契約で細分化または明確に定義されていない事項については、《Taoify ユーザー使用協定》《Taoify ユーザープライバシーポリシー》などの他の協定の内容が適用されます。",
    "2、商户经营过程中产生的、与本服务条款相关的所有争议、索赔，统一由Taoify 平台运营主体所在地人民法院管辖。": "2、商家の経営活動中に生じ、本サービス条項に関連する全ての紛争や請求は、Taoifyプラットフォーム運営主体所在地の人民法院が管轄します。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本条款更新日期：2026年1月1日。": "本プラットフォームは香港星橋国際貿易有限公司（https://aitaoify.com）によって運営されています。連絡先メールアドレス：liutaotao@taocarts.com、WeChat ID：zzsist666。本条項の更新日：2026年1月1日。",
    "Taoify 用户使用协议": "Taoify ユーザー使用協定",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户使用协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "注意：Taoify プラットフォームのサービスを登録または利用する場合、《Taoify ユーザー使用協定》を全文読み、特に免責声明、責任制限、違反処置などの内容に注目し、自身の権利、義務、使用規則及び違反責任を明確に理解してください。プラットフォームで後続でリリースされるすべての新機能、新ツールも本使用協定により拘束されます。",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify 网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify は定期的にまたは不定期に本使用協定の内容を更新、修正する権利を持ち、Taoify ウェブサイト上でこれらの更新と修正を発表することができます。最新版はショッピングモールで統一して公示されますので、定期的に条項の更新内容をご確認ください。条項の改訂内容に同意しない場合は、直ちにプラットフォームのすべてのサービスの使用を停止してください。",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify消费协议》等为准。": "本協定で明示的に約定された内容以外の双方のすべての他の権利義務、ルールの制約は《Taoify サービス条項》《Taoify 消費協定》等に基づきます。",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "アカウントの登録を完了した時点で、あなたはTaoify プラットフォームのすべての協定、条項を十分に認識し、自発的に受け入れたことを意味します。これには《Taoify ユーザー使用協定》《Taoify サービス条項》《Taoify ユーザープライバシーポリシー》などが含まれます。Taoify プラットフォームのすべての協定、条項の内容に同意しない場合は、直ちに登録を停止してください。",
    "用户：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织。": "ユーザー：Taoify プラットフォームの登録を完了し、プラットフォームの各種サービスを利用する自然人、法人、その他の組織を指します。",
    "平台：指Taoify 平台运营主体及平台软硬件系统、网站、服务端口等整体服务载体。": "プラットフォーム：Taoify プラットフォームの運営主体およびプラットフォームのソフトウェア・ハードウェアシステム、ウェブサイト、サービスポートなど全体的なサービスキャリアを指します。",
    "二、账户注册与使用规范": "二、アカウントの登録と使用規範",
    "（一）用户资质与信息管理": "（一）ユーザー資格と情報管理",
    "1. 用户注册时，须向平台提交真实、合法、有效的身份信息、注册地址、实际经营地址、联系电话等资料，不得伪造、变造、隐瞒、虚报注册及资质资料。若用户依托本平台开展经营活动，除法律法规明确可不予登记的情形外，必须依法完成市场主体登记，取得有效营业执照，并在登记经营范围内开展业务。经营项目依法需要行政许可、审批、备案、资质认证的，用户须提前取得对应资质并保证资质持续有效，同时将相关文件提交平台留存。若许可资质被撤销、吊销、到期失效，用户须立即停止对应经营活动并同步告知平台，否则视为严重违约，由此产生的全部法律责任、经济损失由用户自行承担；造成平台损失的，用户须足额赔偿。平台依据监管要求中断、终止服务的，已收取费用不予退还。": "1. ユーザーが登録する際、実際の、合法的で有効な身分情報、登録住所、実際の事業所住所、連絡先電話番号などの情報をプラットフォームに提出しなければなりません。虚偽、変造、隠蔽、虚報の登録や資格情報を提出することは禁止されています。ユーザーが本プラットフォームを利用して事業活動を行う場合、法律で明確に登録不要と規定されている場合を除き、法に基づいて市場主体の登録を行い、有効な営業許可証を取得し、登録された事業範囲内で業務を行う必要があります。事業項目が行政許可、承認、備案、資格認証を必要とする場合、ユーザーは事前に対応する資格を取得し、その資格が継続的に有効であることを保証し、関連文書をプラットフォームに提出して保存する必要があります。許可資格が取り消され、失効した場合、ユーザーは直ちに対応する事業活動を停止し、同時にプラットフォームに通知する必要があります。それ以外の場合、重大な違反とみなされ、これにより生じるすべての法的責任と経済損失はユーザーが自己負担します。プラットフォームが監督要件に基づいてサービスを中断または終了する場合、既に支払われた費用は返金されません。",
    "用户须及时完善账户基础信息，因信息错误、失联产生的所有后果，由用户自行负责。用户信息、资质发生变更的，需在变更3个工作日内主动在平台完成更新备案。因资料虚假、失效、未及时更新引发的一切风险与责任，均由用户自行承担。用户需自行妥善保管账户资料、账号、密码等私密信息，不得向无关第三方泄露、转借。因保管不当、信息外泄造成的资金损失、财产损害及法律责任，全部由用户承担。": "ユーザーはタイムリーにアカウントの基本情報を完成させる必要があります。情報の誤りや連絡不能により生じるすべての結果は、ユーザーが自己責任で対応します。ユーザー情報や資格が変更された場合、変更後3営業日以内に積極的にプラットフォームで更新登録を行う必要があります。資料が虚偽、無効、またはタイムリーに更新されていないことから生じるすべてのリスクと責任は、ユーザーが自己負担します。ユーザーはアカウント情報、アカウント名、パスワードなどの機密情報を適切に保管し、関係のない第三者に漏洩または貸与してはなりません。不適切な保管や情報漏洩により生じる資金損失、財産損害、および法的責任は全てユーザーが負担します。",
    "（二）平台使用限制": "（二）プラットフォーム使用制限",
    "1. 用户需严格按照所购服务档位的资源限额使用平台服务，超出限制的，平台有权采取限流、关停网站等管控措施，相关损失由用户自行承担，已支付费用不予退还。": "1. ユーザーは購入したサービスプランのリソース制限に厳格に従ってプラットフォームサービスを使用する必要があります。制限を超えた場合、プラットフォームは制御措置としてトラフィック制限やウェブサイトの停止を行うことができます。関連する損失はユーザーが自己負担し、既に支払われた費用は返金されません。",
    "2. 用户严禁实施以下违规行为：": "2. ユーザーは以下の違反行為を厳禁します：",
    "（1）通过群发垃圾邮件、商业广告等方式推广站点；": "（1）大量のスパムメールや商業広告などを通じてサイトを宣伝すること；",
    "（2）运行违规程序、进程，恶意占用服务器内存、CPU、宽带等资源，造成服务器卡顿、宕机，影响平台及其他用户正常使用；": "（2）違法プログラムやプロセスを実行し、サーバーのメモリ、CPU、帯域幅などのリソースを悪意を持って占有し、サーバーの遅延やダウンを引き起こし、プラットフォームや他のユーザーの正常な使用に影響を与えること；",
    "（3）发起网络攻击、篡改系统配置、破坏平台网络与信息安全；": "（3）ネットワーク攻撃を開始し、システム設定を改ざんし、プラットフォームのネットワークと情報セキュリティを破壊すること；",
    "（4）运行干扰服务器正常运行的程序、软件；": "（4）サーバーの正常な動作を妨げるプログラムやソフトウェアを実行すること；",
    "（5）泄露自身及其他客户身份、隐私信息；": "（5）自身や他の顧客の身元やプライバシー情報を漏洩すること；",
    "（6）提供、售卖与未成年人相关的违规商品及服务；": "（6）未成年者に関連する違法な商品やサービスの提供、販売；",
    "（7）发布、提供带有骚扰、诽谤性质的商品与服务；": "（7）嫌がらせや誹謗中傷の性質を持つ商品やサービスの発表、提供；",
    "（8）借助平台宣传、售卖基于种族、民族、肤色、宗教信仰等歧视他人、侵犯人权的商品或服务；": "（8）人種、民族、肌の色、宗教的信条に基づく差別や人権侵害を助長する商品やサービスの宣伝、販売；",
    "（9）侵犯任何第三方知识产权；": "（9）第三者の知的財産権を侵害すること；",
    "（10）售卖危险品、管制物品、侵权商品等国内外法律法规明令禁止流通、进出口的商品；": "（10）危険物、規制品、著作権侵害品など国内外の法律で明確に流通や輸出入が禁止されている商品の販売；",
    "（11）利用平台开展洗钱、逃税、非法交易等各类违法活动；": "（11）プラットフォームを利用してマネーロンダリング、脱税、違法取引などの違法活動を行うこと；",
    "（12）开展超出服务范围及国家法律法规禁止的其他行为。": "（12）サービス範囲を超えるまたは国家の法律で禁止されているその他の行為を行うこと。",
    "（三）用户基本义务": "（三）ユーザーの基本的な義務",
    "数据安全义务：用户须遵守国家数据保护相关法律法规，建立数据安全防护机制，妥善存储、管理平台数据，严禁泄露、篡改、非法使用数据。因用户行为引发数据安全违规的，由用户独立承担全部法律责任。": "データセキュリティ義務：ユーザーは国のデータ保護に関する法律を遵守し、データセキュリティ保護メカニズムを設立し、プラットフォームのデータを適切に保管・管理しなければなりません。データの漏洩、改ざん、不正使用を厳禁します。ユーザーの行動によりデータセキュリティ違反が発生した場合、ユーザーは全責任を負います。",
    "商品与服务合规义务：用户上架、销售、提供的商品及服务，必须符合国家安全、生产、环保等法律法规与行业标准，不得提供存在安全隐患、污染环境、危害公众健康的产品及服务。因商品、服务问题引发投诉、处罚、民事赔偿的，责任由用户全部承担。平台收到投诉后，可根据情节采取警示、下架商品、删除内容、暂停服务、封禁账号等处置措施。": "商品とサービスのコンプライアンス義務：ユーザーが掲載、販売、提供する商品及びサービスは、国家安全保障、生産、環境保護などの法律と業界標準に準拠している必要があります。安全上の問題、環境汚染、公衆衛生への危害をもたらす可能性のある製品やサービスの提供は許されません。商品やサービスの問題により苦情、罰則、民事賠償が発生した場合、責任はユーザーが全額負担します。プラットフォームは、状況に応じて警告、商品の削除、コンテンツの削除、サービスの一時停止、アカウントの封鎖などの措置を講じることができます。",
    "税务与票据义务：用户开展经营活动须依法纳税，如实申报税费，按规定向交易方开具正规发票，严禁偷税、漏税、逃税、虚开发票、拒开发票，不得参与走私、变相避税等违法活动。平台有权核验票据及纳税凭证，用户违规的，平台可暂停或终止全部服务。": "税務と領収書の義務：ユーザーは事業活動において法に基づいて納税し、正確に税金を申告し、取引相手に対して正式な請求書を発行しなければなりません。脱税、未払い税、虚偽の請求書の作成、請求書の拒否、密輸、間接的な税回避などの違法活動には参加してはなりません。プラットフォームは領収書と納税証明書を確認する権利を持ち、ユーザーが違反した場合、プラットフォームはすべてのサービスを一時停止または終了することができます。",
    "信息发布义务：用户发布内容需严格遵守法律法规，不得制作、复制、发布、传播违法违规、损害公共利益及他人合法权益的信息，不得为违规内容提供跳转、链接等便利。用户收到平台整改通知后须立即整改；拒不整改的，平台有权暂停或终止全部服务。因用户或其客户发布违规内容造成平台损失的，由客户、用户承担全部赔偿责任。": "情報発信の義務：ユーザーが発信する内容は法律を厳格に遵守し、違法、公共利益や他人の合法的権益を損なう情報を制作、複製、発信、伝播することはできません。また、違法なコンテンツへのジャンプやリンクを提供することは許されません。ユーザーはプラットフォームからの改善通知を受け取った後直ちに対応しなければなりません。対応しない場合、プラットフォームはすべてのサービスを一時停止または終了することができます。ユーザーまたはその顧客が違法なコンテンツを発信したことによりプラットフォームに損害を与えた場合、顧客およびユーザーは全額の賠償責任を負います。",
    "个人信息保护义务：用户收集、使用、存储、传输客户个人信息，需严格遵守法律法规，严禁非法收集、泄露、出售、篡改他人隐私信息。若发生信息泄露、侵权事件，用户承担全部民事、行政及刑事责任。": "個人情報保護の義務：ユーザーは顧客の個人情報を収集、使用、保存、送信する際には法律を厳格に遵守し、他人のプライバシー情報を不法に収集、漏洩、販売、改ざんすることは厳禁です。情報漏洩や権利侵害事件が発生した場合、ユーザーは全額の民事、行政、刑事責任を負います。",
    "知识产权保护义务：用户在平台上传、发布的文字、图片、视频、商标、设计等内容，需拥有知识产权或取得权利人授权，不得侵犯第三方著作权、商标权、专利权等合法权益。用户因侵权引发投诉、诉讼、索赔、行政处罚的，赔偿金、诉讼费、律师费、罚款等所有费用由用户承担，同时用户需赔偿平台方直接、间接损失。": "知的財産権保護の義務：ユーザーがプラットフォームにアップロード、発信する文章、画像、ビデオ、商標、デザインなどのコンテンツについては、知的財産権を所有しているか、または権利者の許可を得ている必要があります。第三者の著作権、商標権、特許権などの合法的権利を侵害してはなりません。ユーザーが権利侵害により苦情、訴訟、賠償要求、行政処分を受けた場合、賠償金、訴訟費用、弁護士費用、罰金などの全ての費用はユーザーが負担し、同時にプラットフォームに対する直接的、間接的な損失を賠償しなければなりません。",
    "账号安全义务：用户全权负责账号、站点内容、登录密码的安全保管，因账号外泄、保管不当造成的损失，由用户自行承担。用户需向平台报备对接人员及联系方式，相关人员行为产生的后果由用户承担。": "アカウントセキュリティの義務：ユーザーはアカウント、サイトの内容、ログインパスワードの安全な保管について全責任を負います。アカウントの漏洩や不適切な管理による損失はユーザーが自己負担します。ユーザーはプラットフォームに担当者と連絡先を報告しなければならず、関連する人物の行動によって生じる結果はユーザーが責任を負います。",
    "平台知识产权约定：平台所有技术资料、软件、系统、技术服务的知识产权均归 Taoify 平台所有，用户不得擅自复制、传播、转让、授权第三方使用，违者承担相应法律责任。": "プラットフォームの知的財産権に関する約定：プラットフォームのすべての技術資料、ソフトウェア、システム、技術サービスの知的財産権はTaoifyプラットフォームに帰属します。ユーザーはこれらを無断で複製、伝播、譲渡、第三者への使用許諾することはできません。違反した場合は、該当する法的責任を負います。",
    "服务使用规则：站点开通后，用户须及时登录会员中心完成基础配置。用户可同时订购多项平台服务，各项服务周期自购买当日起计算，服务期内不支持暂停。": "サービス利用規則：サイト開通後、ユーザーは会員センターにログインして基礎設定を完了する必要があります。ユーザーは複数のプラットフォームサービスを同時に注文できます。各サービスの期間は購入日から計算され、サービス期間内での一時停止はサポートされません。",
    "订单履约义务：用户收到平台警告后须及时优化发货效率、完成整改，长期拒不整改的，平台有权单方面终止服务。": "注文履行の義務：ユーザーはプラットフォームからの警告を受け取った後、出荷効率の最適化と改善を行わなければなりません。長期にわたって改善を拒否した場合、プラットフォームは一方的にサービスを終了することができます。",
    "投诉处置规则：若平台收到第三方针对用户发布内容、在售商品、提供服务、隐私侵权、知识产权侵权、违法违规等投诉或实名举报，平台有权不经用户同意，直接对用户相关内容、页面、商品、链接进行删除、屏蔽、下架处理；情节严重、拒不整改的，平台可直接暂停、终止全部服务，用户已缴纳的所有费用不予退还。": "苦情処理規則：プラットフォームがユーザーが発信した内容、販売中の商品、提供するサービス、プライバシー侵害、知的財産権侵害、違法行為等に関する第三者からの苦情または実名での通報を受けた場合、プラットフォームはユーザーの同意なく直接ユーザーの関連コンテンツ、ページ、商品、リンクを削除、隠蔽、下架することができます。重大な事態で改善を拒否した場合、プラットフォームは直接すべてのサービスを一時停止または終了することができます。ユーザーが既に支払ったすべての費用は返金されません。",
    "三、服务费用、续费与佣金": "三、サービス料金、更新料、コミッション",
    "本平台服务价格以 Taoify 平台官网、购买页面实时公示为准，用户须按约定方式、期限足额支付费用；未付清费用前，Taoify 平台有权暂停、终止提供服务。": "本プラットフォームのサービス料金は、Taoify公式ウェブサイトおよび購入ページで公示されている価格を基準とします。ユーザーは約束された方法と期間内に全額支払う必要があります。未払いの場合は、Taoifyはサービスを一時停止または終了する権利があります。",
    "平台赠送服务、优惠活动均为一次性福利，赠送服务不包含修改、更新、维护费用，亦不得折价抵扣服务费，赠送服务最终解释权归 Taoify 平台所有。": "プラットフォームからのサービスやキャンペーン特典は一回限りのものであり、修正、更新、メンテナンス費用は含まれません。また、これらの特典はサービス料金の割引には使用できません。特典に関する最終的な解釈権はTaoifyが保持します。",
    "服务期限届满前用户未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "サービス期間満了前にユーザーが継続購読料を支払わなかった場合、サービスは自動的に終了します。サービス終了から10日以内に継続購読料を支払わない場合、Taoifyはウェブサイトの全データを削除する権利を持ちます。その際の損失はユーザーが負担します。",
    "若用户实际交易额超出对应产品套装免佣额度，超出部分用户须按约定支付佣金。佣金按单笔实时扣除或自然月统一核算，用户收到账单后5个工作日内完成支付；逾期未支付的，Taoify 平台有权终止服务。": "ユーザーの実際の取引額が対応する製品パッケージの手数料免除枠を超えた場合、超えた分については約束された手数料を支払う必要があります。手数料は個別の取引ごとにリアルタイムで差し引かれたり、自然月でまとめて計算されたりします。ユーザーは請求書を受け取った後5営業日以内に支払いを行う必要があります。支払いが遅延した場合、Taoifyはサービスを停止する権利があります。",
    "用户有权要求 Taoify 平台就实付服务费用开具正规发票，赠送服务对应的金额不纳入开票范围。": "ユーザーはTaoifyに対して実際のサービス料金について正式な領収書の発行を要求することができます。ただし、プレゼントされたサービスの金額は領収書の範囲には含まれません。",
    "第四条 服务终止": "第四条 サービス終了",
    "服务期内用户主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "サービス期間中にユーザーが自発的にサービス終了を申請する場合、1ヶ月前までにTaoifyへ書面で通知する必要があります。既に支払われた料金は返金されません。ユーザーが一方的に契約を終了したことによりTaoifyに損害を与えた場合、直接的・間接的な損失、弁護士費用などを含む賠償が必要となります。",
    "因系统停机、升级、维护；电信线路、设备故障，银行系统异常等第三方问题造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "システムの停止、アップグレード、メンテナンス、通信回線や設備の故障、銀行システムの異常など、第三者の問題によってサービスが中断、遅延、障害が生じた場合、Taoifyは責任を負いません。",
    "因用户原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "ユーザーの原因によるサービスの中断、遅延、障害に関して、Taoifyは責任を負いません。",
    "网络拥堵；黑客攻击、电信故障、政府管制、不可抗力、第三方原因等非 Taoify 平台原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "ネットワークの混雑、ハッキング攻撃、通信障害、政府の規制、不可抗力、第三者の問題など、Taoify以外の理由によるサービスの中断、遅延、障害に関して、Taoifyは責任を負いません。",
    "用户违规占用资源、发布违法信息、侵权、泄露隐私、违法经营、拒不整改等违反本协议约定的，Taoify 平台有权立即关闭网站、终止服务、冻结账号，余款不予退还，同时用户须赔偿 Taoify 平台全部损失，包括但不限于直接损失、间接损失、律师费等。": "ユーザーがリソースを不適切に利用したり、違法情報を掲載したり、著作権侵害やプライバシー漏洩、違法経営、改善命令への不服従などの契約違反を行った場合、Taoifyはウェブサイトを閉鎖し、サービスを終了し、アカウントを凍結する権利を持ちます。残高は返金されず、ユーザーはTaoifyに対する全損失（直接的・間接的な損失、弁護士費用などを含む）を賠償する必要があります。",
    "因用户使用第三方服务导致网站故障、无法使用的，Taoify 平台不承担任何责任。": "ユーザーが使用するサードパーティーサービスによりウェブサイトに障害が生じ、使用不能となった場合、Taoifyは一切の責任を負いません。",
    "Taoify平台无需就用户遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "Taoifyは、ユーザーが被った直接的・間接的な損失、評判の損失、期待利益の損失、営業利益の損失などについて、いかなる賠償責任も負いません。",
    "若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "法定または他の理由によりTaoifyが賠償責任を負うべき場合でも、Taoifyのユーザーに対する累積賠償責任（違約金、賠償金、権利保護費を含む）の上限は、損失事件が発生したサービス期間中にユーザーがTaoifyに実際に支払ったサービス料金の総額です。請求事由の数や損失額に関わらず、合計賠償額はこの上限を超えることはありません。",
    "第五条 知识产权与平台内容约定": "第五条 知的財産権とプラットフォームコンテンツの取り決め",
    "Taoify平台全部内容，包括但不限于文字、图片、文档、资讯、网站架构、界面设计、程序代码等，相关商标权、著作权、专利权、商业秘密等知识产权均归Taoify平台所有。未经 Taoify 平台书面许可，任何主体不得擅自使用、复制、修改、传播、分发平台内容及程序。": "Taoifyプラットフォームの全コンテンツ（文章、画像、ドキュメント、情報、ウェブサイト構造、インターフェースデザイン、プログラムコード等を含む）、関連する商標権、著作権、特許権、商業秘密などの知的財産権はすべてTaoifyが所有しています。Taoifyの書面による許可なく、いかなる主体もプラットフォームのコンテンツやプログラムを使用、複製、改変、伝播、配布することはできません。",
    "用户仅可在 Taoify平台指定专属服务器内使用本平台搭建的网站，不得将网站迁移至非本平台、非本平台提供的服务器运行。": "ユーザーはTaoifyが指定する専用サーバー内でのみ本プラットフォームで構築されたウェブサイトを使用できます。非Taoify提供のサーバーにウェブサイトを移転することはできません。",
    "用户自行在网站创建、上传的内容，由用户独立承担全部法律责任；基于本平台开发的第三方应用，其行为、内容、数据由第三方自行负责，Taoify 平台不承担连带责任。": "ユーザーがウェブサイト上で作成またはアップロードしたコンテンツについては、ユーザーが全責任を負います。本プラットフォームに基づいて開発されたサードパーティアプリケーションの行動、コンテンツ、データについては、サードパーティが責任を負い、Taoifyは連帯責任を負いません。",
    "第六条 条款修订": "第六条 条項の改正",
    "Taoify平台有权随时修订本协议条款、服务定价，协议条款修订提前1个工作日在平台公示，资费调整提前1个月公示。修订后的条款公示后继续使用服务的，视为用户自愿接受全部修订内容。": "Taoifyはいつでも本契約条項やサービス料金を改正する権利を持ちます。条項の改正は1営業日前に、料金の調整は1ヶ月前にプラットフォーム上で公示されます。改正後の条項が公示された後に引き続きサービスを使用する場合、ユーザーは全ての改正内容を受け入れることを同意したものとみなされます。",
    "用户确认，在 Taoify平台注册所提供的身份信息、地址、联系方式为本协议履行、相关的诉讼、仲裁程序中的法定送达地址及送达方式，司法机关可直接据此送达各类司法文书。双方均同意以邮寄、电子送达方式收取司法文书。上述送达地址及方式的效力涵盖仲裁、一审、二审、再审及执行等全部诉讼阶段。若一方信息变更，需提前3个工作日申请变更，未变更的，原约定地址及方式仍视为有效送达地址，任何一方、司法机关按原地址送达即便被退回，也视为有效送达。": "ユーザーは、Taoifyプラットフォームに登録した身分情報、住所、連絡先が本契約の履行、関連する訴訟、仲裁手続きにおける法定送達先および送達方法であることを確認します。司法機関はこれを基に各種司法文書を直接送達することができます。両者は郵送、電子送達による司法文書の受け取りに同意します。上記の送達先および方法の効力は、仲裁、第一審、控訴審、再審及び執行等の全訴訟段階をカバーします。一方の情報が変更された場合、3営業日前までに変更申請を行う必要があります。変更がない場合は、元の約定住所と方法は依然として有効な送達先とみなされ、何らかの理由で返送されたとしても、元の住所への送達は有効とされます。",
    "第八条 不可抗力": "第八条 不可抗力の規定",
    "不可抗力指战争、武装冲突、自然灾害（如地震、洪水）、罢工、暴乱、政府行为（如禁令、制裁）、司法限制、全国性疫情等不能预见、不能避免且不能克服的客观事件。": "不可抗力とは、戦争、武力紛争、自然災害（地震、洪水など）、ストライキ、暴動、政府の措置（禁止令、制裁など）、司法制限、全国的な疫病など、予見し、避けること、克服することのできない客観的な事象を指します。",
    "第九条 其他约定": "第九条 その他の合意",
    "1. Taoify平台发生上市、收购、合并、名称变更等情形时，有权将本协议项下全部权利、义务转移给权利义务承接方，用户对此无异议。": "1. Taoifyプラットフォームが上場、買収、合併、名称変更などの状況になった場合、本契約に基づくすべての権利と義務を権利義務引き継ぎ先に移転する権利を持ち、ユーザーはこれに異議ありません。",
    "2. Taoify 平台内服务说明、价格公示、申请表格等文件，均为本协议不可分割的组成部分，与本协议具有同等法律效力。": "2. Taoifyプラットフォーム内のサービス説明、価格公示、申請フォームなどの文書は、本契約の不可欠な構成部分であり、本契約と同等の法的効力を有します。",
    "3. 若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "3. ユーザーが本契約違反によりプラットフォームが第三者からの賠償請求、訴訟、仲裁を受けたり、行政機関から罰金や賠償命令を受けた場合、全ての責任はユーザーが単独で負担します。ユーザーは、プラットフォームがこれによって生じた全ての直接的損失と間接的損失を十分に賠償しなければなりません。損失の範囲には、プラットフォームが第三者に支払う賠償金、和解金、補償金、違約金；行政機関、司法機関が徴収する罰金、延滞金、訴訟費、仲裁費、保全費、執行費、鑑定費、評価費；プラットフォームが権利保護のために支出する弁護士費用、公証費用、調査証拠取得費用、出張費用、担保費用；プラットフォームの商誉損失、業務中断損失、得べかりし利益の損失、第三者からの追加賠償要求による一切の関連費用が含まれます。",
    "第十条 争议解决": "第十条 争議解決",
    "1. 平台有关条款（包括但不限于本使用协议等）可能会有除中文以外的其他版本。如果不同语言版本的使用协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本使用协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本使用协议，予以明确排除。": "1. プラットフォームに関する条項（本使用協定を含む）は、中国語以外の言語版がある場合があります。異なる言語版の使用協定間に相違、不一致、または曖昧さがある場合、中国語テキストが優先され、他のテキストは参考用であり、中国語テキストの意味を抵触または変更することはできません。本使用協定の成立、効力、解釈、履行及び争議解決は、中華人民共和国法を準拠法とし、海外の法律衝突規則を排除します。《国連国際物品売買契約条約》は本使用協定には適用されず、明確に除外されます。",
    "2. 因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2. 本協定に関連するまたは本協定によって生じるいかなる争議も、当事者は友好的に解決すべきです。協議が成立しない場合、当事者のいずれもTaoifyプラットフォームの運営地にある管轄権を持つ人民法院に訴訟を提起する権利があります。",
    "争议处理期间，除争议事项外，双方应继续履行本协议其他约定。本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "争議処理期間中、争議事項を除き、当事者は本協定の他の約定を継続的に履行するものとします。本協定の一部の条項が廃止され、無効または実行不能となった場合でも、他の条項の効力には影響しません。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本协议更新日期：2026年1月1日。": "本プラットフォームは香港星橋國際貿易有限公司（https://aitaoify.com）によって運営されており、連絡メールアドレス：liutaotao@taocarts.com、WeChat ID：zzsist666です。本協定の更新日：2026年1月1日。",
    "适用于任何项目的": "すべてのプロジェクトに適用されます",
    "根据自己的需求选择合适的模板，并在其基础上进行自定义和修改，以满足自己的品牌形象和功能要求。": "自分のニーズに合わせて適切なテンプレートを選択し、それに基づいてカスタマイズと修正を行い、自分のブランドイメージと機能要件を満たすようにします。",
    "用 AI 设计你的专属模板": "AIであなたの専用テンプレートをデザイン",
    "一句话描述你的店铺风格，AI 自动生成专属模板": "一言でお店のスタイルを表現し、AIが自動で専用テンプレートを生成",
    "无需设计经验": "デザイン経験不要",
    "秒级生成": "秒単位での生成",
    "可二次修改": "再編集可能",
    "立即 AI 设计": "AIでデザインを開始",
    "搜索您想要的模版": "欲しいテンプレートを検索",
    "注册卖家": "セラーとして登録",
    "行业模板": "業界テンプレート",
    "满意度": "満足度",
    "精选模板": "厳選テンプレート",
    "查看模板设计": "テンプレートデザインを見る",
    "最新的主题和模板": "最新のテーマとテンプレート",
    "查看更多": "もっと見る",
    "暂无模板，稍后再来看看吧": "テンプレートはありません、後でもう一度チェックしてみてください",
    "本周精选创作者": "今週の注目クリエイター",
    "个作品": "作品数",
    "查看主页": "ホームを見る",
    "数百万创意资源、无限下载": "数百万のクリエイティブリソース、無制限のダウンロード",
    "立即订阅、可随时取消": "すぐに購読、いつでもキャンセル可能",
    "轻松的设计有您自己在线制作": "自分だけのオンラインデザインを簡単に作成",
    "适合任何技能水平的智能模板": "あらゆるスキルレベルに適したスマートテンプレート",
    "如何用 AI 设计模板": "AIを使ってテンプレートをデザインする方法",
    "描述你的店铺类型和风格，如“欧美简约服饰店”": "あなたの店舗タイプとスタイルを説明してください。例：「シンプルな欧米風の服飾店」",
    "AI 自动生成多套模板设计供你选择": "AIが自動的に複数のテンプレートデザインを生成します",
    "选中模板后一键启用，随时调整细节": "テンプレートを選択してワンクリックで有効化し、いつでも詳細を調整",
    "去模板列表看看": "テンプレートリストを見てみる",
    "我知道了": "わかりました",
    "个筛选": "個のフィルター",
    "全部模板": "すべてのテンプレート",
    "没有结果": "結果なし",
    "作者": "著者",
    "更新时间": "更新時間",
    "实时预览": "リアルタイムプレビュー",
    "立即购买": "今すぐ購入",
    "应用到当前店铺": "現在の店舗に適用",
    "模板介绍": "テンプレート紹介",
    "主题模板特点": "テーマテンプレートの特徴",
    "模版价格": "テンプレート価格",
    "支付方式": "支払い方法",
    "未来更新": "今後のアップデート",
    "提供6个月的支持": "6ヶ月のサポート提供",
    "由Taoify检查质量": "Taoifyによる品質チェック",
    "模板规格": "テンプレート仕様",
    "高分辨率": "高解像度",
    "是的": "はい",
    "不支持": "サポート外",
    "可兼容浏览器": "対応ブラウザ",
    "布局": "レイアウト",
    "模版ID": "テンプレートID",
    "发表时间": "投稿時間",
    "关于作者": "作者について",
    "其他作品": "他の作品",
    "购买成功": "購入成功",
    "购买成功！请在模板中心查看使用。": "購入成功！テンプレートセンターで確認してください。",
    "仅关闭": "閉じるのみ",
    "查看已购买模版": "購入済みテンプレートを表示",
    "预览站点暂时不可用，请稍后再试或联系平台": "プレビューサイトは現在利用できません。後でもう一度お試しください、またはプラットフォームにご連絡ください。",
    "返回": "戻る",
    "审核失败": "審査失敗",
    "（审核失败请到原创作平台进行编辑后更新）": "（審査失敗の場合は、元の創作プラットフォームで編集し更新してください）",
    "失败原因": "失敗理由",
    "申请时间": "申請時間",
    "审核时间": "審査時間",
    "未发布": "未公開",
    "已发布": "公開済み",
    "审核通过": "審査通過",
    "当前版本号": "現在のバージョン番号",
    "发布模版": "テンプレートを公開",
    "删除当前模版": "現在のテンプレートを削除",
    "删除模板": "テンプレートを削除",
    "确定删除该模板吗？删除后不可恢复。": "このテンプレートを本当に削除しますか？削除された後は復元できません。",
    "取消": "キャンセル",
    "确认删除": "削除を確認",
    "申请发布模版，TaoifyShop会尽快审核，请在个人中心查看结果。": "テンプレートの公開申請を行います。TaoifyShopはできるだけ早く審査しますので、個人センターで結果をご確認ください。",
    "确定": "確定",
    "模板设计师工作台": "テンプレートデザイナーワークスペース",
    "把你的设计变成收入": "あなたのデザインを収益に変える",
    "你制作的模板可以发布到模版市场，其他卖家购买后你即可获得佣金收益。": "あなたが作成したテンプレートをテンプレートマーケットに公開し、他の販売者が購入すると、コミッション収益を得ることができます。",
    "发布我的模板": "私のテンプレートを公開する",
    "去模版市场看看": "テンプレートマーケットを見てみる",
    "个": "個",
    "我的模板": "私のテンプレート",
    "已购模板": "購入済みテンプレート",
    "模板审核通过上架后，被其他卖家购买即可获得佣金收益": "テンプレートが審査通過し、他の販売者によって購入されると、コミッション収益を得ることができます。",
    "想快速出模板？试试 AI 设计": "テンプレートを早く作成したいですか？AIデザインを試してみてください",
    "一句话描述店铺风格，AI 自动生成专属模板，省时又省力": "お店のスタイルを一言で説明し、AIが自動的に専用のテンプレートを作成します。時間と労力を節約できます",
    "发布你的设计，赚取佣金": "デザインを公開してコミッションを得ましょう",
    "发布模板": "テンプレートを公開",
    "全选": "すべて選択",
    "已选": "選択済み",
    "批量删除": "一括削除",
    "查看": "確認",
    "发布": "公開",
    "应用": "適用",
    "无结果": "結果なし",
    "已购买模版": "購入済みテンプレート",
    "当前店铺": "現在の店舗",
    "当前店铺应用版本": "現在の店舗アプリケーションバージョン",
    "还未购买模版": "まだテンプレートを購入していません",
    "提交后由平台审核": "提出後、プラットフォームで審査されます",
    "生成待发布模版，可在个人中心提交发布到模版市场，TaoifyShop会尽快审核，审核通过后将上架到模版市场，其他人购买后，可赚佣金。审核结果请在个人中心的自定义模版中查看，大概需要1~2个工作日。": "公開待ちのテンプレートを作成し、個人センターからテンプレートマーケットに提出できます。TaoifyShopはできるだけ早く審査し、承認されたものはテンプレートマーケットに掲載されます。他の人が購入すると、コミッションを得られます。審査結果は個人センターのカスタムテンプレートで確認できます。通常1~2営業日かかります。",
    "选择要发布的模板": "公開するテンプレートを選択",
    "新发布": "新規公開",
    "发布新版本": "新バージョンを公開",
    "暂无未发布模板，请先在工作台制作模板": "テンプレートがまだありません。まず、ワークベンチでテンプレートを作成してください",
    "作品信息": "作品情報",
    "模板名称": "テンプレート名",
    "封面图": "カバーフォト",
    "上传封面": "カバーフォトをアップロード",
    "模板描述": "テンプレートの説明",
    "模版亮点": "テンプレートの特長",
    "付费": "有料",
    "标签": "タグ",
    "按Enter键保存和添加更多": "Enterキーを押して保存し、さらに追加",
    "特点": "特徴",
    "按Enter键添加特点": "Enterキーを押して特徴を追加",
    "关闭": "閉じる",
    "提交": "提出",
    "批量删除模板": "テンプレートの一括削除",
    "确定删除选中的": "選択したものを削除しますか",
    "个模板吗？删除后不可恢复。": "このテンプレートを削除しますか？削除すると復元できません。",
    "删除已购模板": "購入済みテンプレートの削除",
    "确定删除已购模板": "購入済みテンプレートを削除しますか",
    "吗？删除后将无法继续使用。": "？削除すると、再度使用することはできません。",
    "立即去设计": "すぐにデザインを作成する",
    "全部自定义模版": "すべてのカスタムテンプレート",
    "待发布": "公開待ち",
    "待审核": "審査待ち",
    "审核未通过": "審査不合格",
    "自适应": "レスポンシブ",
    "仅支持PC": "PCのみ対応",
    "仅支持H5": "H5のみ対応",
    "删除成功": "削除が完了しました",
    "余额提现": "残高引き出し",
    "提现明细": "引き出し明細",
    "可提现金额": "引き出せる金額",
    "提现到支付宝": "Alipayに引き出す",
    "提现到银行卡": "銀行口座に引き出す",
    "购买记录": "購入履歴",
    "查看你购买过的模板与订单": "購入したテンプレートと注文を確認する",
    "类型": "タイプ",
    "订单编号": "注文番号",
    "已支付": "支払い済み",
    "暂无购买记录": "購入履歴がありません",
    "消费记录": "消費履歴",
    "时间": "時間",
    "详情": "詳細",
    "收入": "収入",
    "收益明细": "収益明細",
    "已失效": "無効になりました",
    "待结算": "精算待ち",
    "已结算": "精算済み",
    "提现记录": "出金記録",
    "模版名称": "テンプレート名",
    "在线咨询": "オンライン相談",
    "在线客服暂时没接上，稍后再试一次；着急的话直接发邮件，我们会尽快回。": "オンラインカスタマーサービスは現在つながりません、後でもう一度お試しください；急ぎの場合、メールでお問い合わせください、できるだけ早く返信いたします。",
    "重新连接": "再接続",
    "想了解开店、选品、物流？直接问…": "店舗開設、商品選定、物流について知りたい？直接聞いてください…",
    "拖动调整大小": "ドラッグしてサイズ調整",
    "开店顾问": "店舗開設アドバイザー",
    "人工在线": "オペレーターがオンラインで対応",
    "全天候自动应答": "24時間自動応答",
    "网络异常，请稍后再试": "ネットワーク異常です。後でもう一度お試しください",
    "AI 顾问": "AI アドバイザー",
    "待人工确认": "オペレーターによる確認待ち",
    "转人工": "オペレーターに切り替える",
    "开店与起步": "店舗開設と立ち上げ",
    "注册、选模板、绑域名、第一件商品": "登録、テンプレート選択、ドメインのバインド、最初の商品",
    "店铺装修": "店舗装飾",
    "模板、组件、配色、手机端排版": "テンプレート、コンポーネント、配色、モバイル端末のレイアウト",
    "商品与库存": "商品と在庫",
    "采集、改价、规格、库存同步": "商品収集、価格変更、仕様、在庫同期",
    "采购、打单、发货、轨迹异常": "調達、出荷伝票作成、発送、トラッキング異常",
    "绑账户、余额、提现、服务费": "アカウントの紐付け、残高、出金、サービス料",
    "营销与 AI": "マーケティングと AI",
    "AI 客服、AI 员工、优惠券、邮件": "AI カスタマーサービス、AI スタッフ、クーポン、メール",
    "账号与权限": "アカウントと権限",
    "子账号、角色、登录、安全": "サブアカウント、ロール、ログイン、セキュリティ",
    "API、Webhook、对接自己的系统": "API、Webhook、独自システムとの連携",
    "注册开店要准备什么？多久能跑起来？": "店舗開設に必要な準備は何ですか？どのくらいで始められますか？",
    "一个能收验证码的邮箱或手机号就能注册，不需要先有营业执照。流程是：选套餐、选模板、绑域名、传第一个商品，一般一小时内能在后台跑通一单测试订单。": "確認コードを受け取れるメールアドレスまたは電話番号があれば登録できます、営業許可証は必要ありません。手順は：プラン選択、テンプレート選択、ドメインのバインド、最初の商品のアップロード、通常1時間以内にテスト注文がバックエンドで完了します。",
    "店铺能不能绑自己的域名？需要备案吗？": "自分のドメインを店舗に結びつけることは可能ですか？ドメイン登録が必要ですか？",
    "可以。在后台「店铺设置 → 域名」里填你的域名，按提示加两条 DNS 解析，一般十分钟生效，SSL 证书自动签发。服务器在境外，不需要国内备案；自有域名按套餐权限开放。": "可能です。バックエンドの「店舗設定 → ドメイン」にあなたのドメインを入力し、指示に従って2つのDNSレコードを追加してください、通常10分で有効になります、SSL証明書は自動的に発行されます。サーバーは海外にあるため、国内でのドメイン登録は不要です；独自ドメインはプランの権限に基づいて開放されます。",
    "模板市场里的模板怎么用？换了会不会影响商品和订单？": "テンプレートマーケットのテンプレートはどのように使いますか？変更すると商品や注文に影響がありますか？",
    "模板只改变店铺外观，不动商品、订单和客户数据，随时可以换回来。应用模板后，再在装修页调首页模块和配色，保存发布后前台才生效。": "テンプレートは店舗の外観のみを変更し、商品、注文、顧客データには影響しません、いつでも元に戻すことができます。テンプレート適用後、装飾ページでトップページのモジュールと配色を調整し、保存して公開することで、フロントエンドに反映されます。",
    "装修改完，前台看还是老样子？": "装飾を変更したのに、フロントエンドでは古いデザインのままです？",
    "先确认改动是否已经保存并发布；再强制刷新一次前台（Ctrl 或 Cmd 加 Shift 加 R），浏览器可能缓存了旧样式。手机上还要清一下站点缓存。仍然不对，把店铺编号和页面地址发给客服。": "まず変更が保存され公開されていることを確認してください；次にフロントエンドを強制的に更新してください（Ctrl または Cmd + Shift + R）、ブラウザが古いスタイルをキャッシュしている可能性があります。スマートフォンではサイトのキャッシュもクリアしてください。それでも改善しない場合は、店舗番号とページURLをカスタマーサービスにお知らせください。",
    "怎么把 1688、淘宝的商品搬到店铺里？": "1688や淘宝の商品を店舗に移動するにはどうすればいいですか？",
    "在后台「商品 → 采集」里贴商品链接，选目标分类和加价规则，确认后生成商品草稿；检查图片、规格、库存再上架。带别人店铺 logo 或水印的图，建议换掉再用。": "バックエンドの「商品 → 采集」で商品リンクを貼り、対象カテゴリと価格設定ルールを選択し、確認して商品ドラフトを作成します。画像、仕様、在庫をチェックしてから出品してください。他の店舗のロゴやウォーターマークが付いている画像は、使用前に変更することをお勧めします。",
    "商品价格怎么定？汇率和加价率在哪里改？": "商品価格はどう決めるのですか？為替レートとマージン率はどこで変更できますか？",
    "在价格规则里配汇率和加价率，商品价格会按规则自动算；单个商品也可以在编辑页手工改价。改规则只影响之后的价格计算，已经生成的订单金额不变。": "価格設定ルールで為替レートとマージン率を設定すると、商品価格は自動的に計算されます。個別の商品については、編集ページで手動で価格を変更することもできます。ルールの変更は、それ以降の価格計算にのみ影響し、既に生成された注文金額には影響しません。",
    "客户下单以后，我要做哪些操作？": "顧客が注文した後、どのような操作が必要ですか？",
    "订单列表里能看到待采购和待发货。先按订单采购，再录入物流单号发货；单号录入后，客户在店铺前台就能看到轨迹。状态卡在某一环节时，后台会有提示。": "注文リストでは未購入と発送待ちの注文を見ることができます。まず注文に基づいて購入し、その後物流番号を入力して発送します。物流番号を入力すると、顧客は店舗のフロントエンドで追跡情報を確認できます。ステータスが特定の段階で止まっている場合、バックエンドに通知があります。",
    "物流轨迹一直不更新，是丢件了吗？": "物流情報が更新されないのは、荷物が紛失したのでしょうか？",
    "单号录入后通常 24 小时内才有第一条轨迹，节假日会更慢。超过 48 小时没有更新，先核对单号和渠道有没有填错；确认无误就把订单号发给客服，由平台向渠道查件。": "物流番号を入力した後、通常24時間以内に最初の追跡情報が表示されます。休日はさらに遅くなることがあります。48時間以上更新がない場合は、まず物流番号とチャネルが間違っていないか確認してください。問題がない場合は、注文番号をカスタマーサポートに送り、プラットフォームがチャネルに問い合わせます。",
    "客户要退款，钱是从哪里退的？": "顧客が返金を希望した場合、お金はどこから返されますか？",
    "从你绑定的收款账户原路退回，平台不经手这笔钱。在订单详情点「退款」，填金额和原因，客户一般 3 到 5 个工作日收到。已经发货的订单，建议先和客户确认拒收或退回。": "あなたの紐付けられた収款口座に元の経路で返金されます。プラットフォームはこのお金を取り扱いません。「返金」をクリックし、金額と理由を記入すると、通常3〜5営業日で顧客が受け取ります。すでに発送済みの注文については、拒否または返品について顧客と確認することをお勧めします。",
    "后台余额怎么充值？提现多久到账？": "バックエンドの残高をどのようにチャージしますか？出金にはどのくらいかかりますか？",
    "充值在「余额」页按提示转账并提交凭证，到账后就能用于采购和扣费。提现提交后按后台显示的结算周期处理，具体时效和手续费以提现页说明为准。": "「残高」ページで指示に従って振込を行い、証拠を提出すると、到着後に購入や料金支払いに使用できます。出金申請後、バックエンドに表示される精算周期に従って処理されます。具体的な所要時間と手数料は、出金ページの説明をご覧ください。",
    "平台服务费和佣金是怎么算的？在哪里看？": "プラットフォームのサービス料とコミッションはどのように計算されますか？どこで確認できますか？",
    "按订单实付金额和你所在套餐的费率计算，账单在后台的账单与佣金页可以逐单核对。对某笔金额有疑问，带上订单号问客服，能查到具体的计费口径。": "実際の注文金額とあなたが加入しているパッケージのレートに基づいて計算されます。各注文の詳細は、バックエンドの請求書とコミッションページで確認できます。特定の金額について疑問がある場合は、注文番号と共にカスタマーサポートに問い合わせて、具体的な計算方法を確認できます。",
    "AI 客服答错了，怎么调整？": "AI カスタマーサポートが間違った回答をした場合、どう修正しますか？",
    "AI 客服只按你给的知识库和话术回答。答错通常是知识库缺这一条：把标准答案补进去，再实测几次。涉及价格、售后时效这类敏感问题，建议写成明确规则，让它照规则说。": "AI カスタマーサポートは、あなたが提供した知識ベースと応答パターンに基づいて回答します。間違った回答は通常、知識ベースに該当する項目がないためです。正しい答えを追加し、何度かテストを行ってみてください。価格やアフターサービスの期間など、敏感な問題については、明確なルールとして書き、それに従って回答させることがお勧めです。",
    "前台能显示多种语言吗？翻译不准能不能自己改？": "フロントエンドで複数言語を表示できますか？翻訳が正確でない場合、自分で修正できますか？",
    "支持 20 种语言，访客进来会按浏览器语言自动显示对应版本。词条在后台语言包里可以直接改，改完前台即时生效；某个语种整段没翻译时，会回退显示英文。": "20種類の言語に対応しており、訪問者はブラウザの言語設定に基づいて対応するバージョンを自動的に表示されます。バックエンドの言語パックで直接修正でき、修正後すぐにフロントエンドで反映されます。特定の言語で翻訳が存在しない場合、英語に戻ります。",
    "子账号怎么开？能不能限制他只能看一部分功能？": "サブアカウントを開設できますか？特定の機能しか見られないように制限できますか？",
    "在「权限管理」里新增管理员并勾选他能访问的菜单，子账号登录后只看到被授权的页面，订单、提现这类敏感操作可以单独关掉。员工离职直接停用账号即可。": "「権限管理」で新しい管理者を追加し、アクセス可能なメニューを選択します。サブアカウントはログイン後、許可されたページのみを表示します。注文や出金などの敏感な操作は個別に無効にすることができます。従業員が退職した場合は、アカウントを停止すればよいです。",
    "忘记密码 / 换了手机号，怎么找回？": "パスワードを忘れた / 電話番号を変更した場合、どのように復旧できますか？",
    "登录页点「忘记密码」，用注册邮箱收验证码重置。邮箱也收不到、或者注册手机号已经停用，就把店铺编号和注册邮箱发给客服，核验后人工处理。": "ログインページで「パスワードを忘れた場合」をクリックし、登録メールアドレスで認証コードを受け取ってリセットします。メールが届かない場合や登録電話番号が使用できない場合は、店舗番号と登録メールアドレスをカスタマーサポートに送り、確認後に手動で処理します。",
    "能不能对接我自己的 ERP？数据怎么同步？": "自分のERPと連携できますか？データはどのように同期しますか？",
    "可以。平台开放 REST 接口和 Webhook：用 ERP 管货的，只同步库存；用自己系统管订单的，只拉订单。接口按店铺隔离，一个 Token 只能读自己店的数据，先在沙箱环境联调。": "はい。プラットフォームはREST APIとWebhookを提供しています：ERPで在庫管理を行う場合、在庫のみを同期します。独自のシステムで注文を管理する場合、注文のみを取得します。APIは店舗ごとに分離されており、1つのトークンは自分の店のデータのみを読み取ることができます。最初はサンドボックス環境で連携テストを行ってください。",
    "首页": "ホーム",
    "功能": "機能",
    "案例": "事例",
    "试用版": "トライアル版",
    "单店版": "シングルストア版",
    "起步版": "スタートアップ版",
    "成长版": "成長版",
    "先免费用 14 天，把店开起来看效果": "まずは14日間無料でお試しください。効果を見てから判断してください。",
    "一个人做代购，够用就好": "個人で代行購入を行う場合、これだけあれば十分です",
    "有团队之后的第一档": "チームを持つ最初のステージ",
    "多店、批量铺货、要账期": "複数店舗、大量出品、支払い猶予が必要な場合"
}
